export const translationKeys = {
    missing_translation: "Missing translation",
    Company: "Company",
    Connected: "Connected",
    CreateConversationHeader: {
        title: "New message to:",
    },
    Location: "Location",
    "Not Connected": "Not connected",
    Pending: "Pending",
    Status: "Status",
    Tags: "Tags",
    search_or_create: "Search or create...",
    account_form: {
        stmp_form: {
            back_button: "Back",
            setup_mail: "Set up mail account",
        },
    },
    action_type: "Action type",
    actions_in_queue: "Queued actions",
    add: "Add",
    add_prospects_input: {
        add_prospects: "Import prospects",
        add_trigger_button: "Add prospects",
        adding_prospects: "Adding prospects",
        clear_filters: "Clear filters",
        conditions_not_meet: "Conditions not met...",
        create_list_button: "Create a list",
        create_list_error: "An error occurred while creating the list '{{name}}'",
        create_list_select: "Create new list",
        empty_list: "Your list is empty, you need to import prospects",
        empty_list_variant: "Your list is empty...",
        empty_list_variant_sub: "You need to import prospects or choose another list to continue.",
        empty_search_list: "No results, try to adjust your search or filters",
        filters_not_match: "Filters you have applied do not match any prospects. ",
        list_select_placeholder: "Select a list",
        move_duplicates_to_other_list: "Move duplicates to import list",
        no_prospects_found: "No prospects found...",
        prospect_list_header: {
            company: "Company",
            job: "Job",
            name: "Name",
            tags: "Tags",
        },
        retroactive_checkbox_label: "Make it retroactive",
        search_placeholder: "Search prospects",
        select_list: "Select a list to display prospects",
        select_list_label: "Select a list into which your prospects will be imported",
        select_trigger_type_label: "Select the type of auto-import",
        some_prospects_already_imported:
            "Some prospects are already included in another campaign, or they do not meet the conditions required to enter in this campaign.",
        tab: {
            prospects: "Prospects Lists",
            triggers: "Auto-import",
        },
        try_again_search_options: "Try again using other search options.",
        view_details: "View details",
    },
    add_to_existing_campaign_without_facultative: "Add to existing campaign",
    add_to_existing_campaign_optional: "Add to existing campaign (optional)",
    added_prospect_selection_group: {
        count: "Count",
        date: "Date",
    },
    added_prospects_input: {
        text_1: "{{count}} prospect{{plural}}",
        text_2: "from #{{prospectListName}}",
        text_3: "in #{{prospectListName}}",
        text_4: "Import in progress",
        text_5: "Import added!",
        trigger: "Auto-import",
        integration: "Integration",
    },
    app_crashed: {
        refresh: "Please fix my rocket!",
        text_1: "Engineers made a mistake in their calculations",
        text_2: "Click on the button below to help them fix your rocket",
        title: "Your rocket has crashed!",
    },
    appsumo: {
        home: {
            card: {
                step1: {
                    button: "Open with Google Chrome",
                    success: "Copied!",
                    title: "Open this page with the Chrome navigator",
                },
                step2: {
                    button: "Download",
                    title: "Download Waalaxy's extension",
                },
                step3: {
                    button: "Open LinkedIn",
                    title: "LogIn To LinkedIn",
                },
                step4: {
                    button: "Go to the app!",
                    title: "Enjoy Waalaxy ! 🎉",
                },
            },
            subtitle: "You also received an email with all the instructions to activate your account.",
            title: "How to link your AppSumo account",
        },
    },
    at: "at",
    attachment: {
        add: "Add an attachment",
        close: "Close",
        error_subtitle_size: "The selected file is too large. The maximum size is {{count}} MB.",
        error_subtitle: "The selected file is too large. The maximum size is 20 MB.",
        error_title: "Unable to import file.",
        global_error_subtitle: "The total size of your files exceeds the maximum allowed limit of 20 MB.",
        upload_type_error: "This type of file is not accepted : {{type}}",
    },
    audio: {
        add: "Record a voice note",
        send_limit_reached: "You can only send one voice note per message",
    },
    authAppVerification: {
        error: {
            cancel: "Something didn't work on our side, please refresh the page and try again",
            verification: "Wrong verification code. Please try again",
        },
        success: {
            verification: "Code verified!",
        },
    },
    auto_campaign_state: {
        toast: {
            details_already_in_campaign: "{{count}} are already in a campaign",
            details_invalid_prospects: "{{count}} prospects do not meet one or more entry conditions of the campaign",
            summary: "{{refusedCount}} prospects couldn't be added to '{{campaignName}}'",
        },
    },
    back_to_home: "Back to the homepage",
    banner: {
        cloud: {
            button: "Go to Cloud settings",
        },
        cloud_trial: {
            text: "☀️ With Free Trial, send your campaigns even offline! To run the Cloud, please enter your LinkedIn ID’s.",
        },
        reconnect_to_cloud: {
            button: "Reconnect Cloud",
            text: "Your LinkedIn account has been disconnected, please enter your credentials to resume Cloud activity",
        },
    },
    beta: "Beta",
    billing_cycle: {
        billing_monthly: "Billing monthly",
        billing_quarterly: "Billing quarterly",
        billing_yearly: "Billing yearly",
        by_month: "/ mo",
        month: "month",
        monthly: "monthly",
        quarter: "quarter",
        quarterly: "quarterly",
        year: "year",
        yearly: "yearly",
    },
    black_friday: {
        badge: {
            save_xx_percent: "-{{percentage}}% {{eventName}}",
        },
        banner: {
            discount_periodicity: "on yearly subscriptions",
            event_name: "Black friday",
            title: "{{date}}. <coloredText>Only.</coloredText>",
        },
        banner_resume_free_trial: {
            ends_in: "— ends in —",
            first_text: "But you are lucky <coloredText>today</coloredText>",
            second_text: "It's Black Friday!",
        },
        countdown: {
            ends_in: "Ends in",
            hours: "Hours",
            minutes: "Minutes",
            promotional_badge: "-50% on yearly subscriptions !",
            seconds: "Seconds",
            title: "black friday",
        },
        pricing_page: {
            banner: {
                lucky: "It's your lucky <strong>day</strong>",
                title: "It's Black Friday !",
            },
        },
        sidebar: {
            cta: "Enjoy the offer",
            subtitle: "Get an extra 50% OFF on Yearly plans -  The event ends in {{hours}}h and {{minutes}}min, don't miss it 🥳",
            title: "Exclusive Black Friday Offer",
        },
    },
    sales_nav_extension_install_modal: {
        title: "Install the Waalaxy Companion chrome extension",
        subtitle: "Sales Navigator imports require the Waalaxy Companion Chrome extension. Watch the video, then follow the steps.",
        download_cta: "Download Waalaxy Companion (.zip)",
        video_badge: "▶ Installation guide · 1:24",
        steps_title: "Then, in Chrome",
        step_1: "Unzip the downloaded .zip folder.",
        step_2_prefix: "Copy",
        step_2_suffix: "then paste in your address bar",
        step_2_copied: "Copied!",
        step_3: "Enable <strong>Developer mode</strong> (top right).",
        step_4: "<strong>Load unpacked</strong> → select the folder.",
    },
    alien_recruiter_extension_install_modal: {
        title: "Install the Alien Recruiter chrome extension",
        subtitle: "Recruiter lite imports require the Alien Recruiter Chrome extension. Watch the video, then follow the steps.",
        download_cta: "Download Alien Recruiter (.zip)",
    },
    free_trial_without_card_modal: {
        title: "Welcome to Waalaxy, {{firstName}} 🎉",
        subtitle: "Discover the power of automated prospecting with the Advanced plan of Waalaxy.",
        days_offered: "days offered",
        divider: "Take action now with",
        features: {
            feature_1: "200 invitations / week",
            feature_2: "Advanced campaigns",
            feature_3: "Integration with your tools",
        },
        cta: "Let's go 💙",
        disclaimer: "No action required, you can start prospecting right away.",
    },
    black_thirstday: {
        banner: {
            title: "{{date}}. Only.",
        },
        pricing_page: {
            banner: {
                lucky: "It's your lucky <strong>day</strong>, -30% on yearly prices",
                title: "It's Black Thirst'day !",
            },
        },
    },
    campaign: "Campaign",
    campaign_edition: {
        about_template: "About {{name}} template",
        back_to_template: "Back to templates",
        complexity: "Complexity",
        complexity_level: "Lvl.{{complexity}}",
        connect_waypoint: {
            save_without_content: "Save without content",
        },
        launch_my_campaign: "Launch my campaign!",
        launch_subtitle: "Tips: Prospects who reply are automatically removed from the campaign.",
        launch_title: "Ready to go?",
        provider_selector: {
            add_email_account_text: "To use this sequence, you must add an email address",
            need_mail_account: "Email required",
            set_mail_account: "Add an email",
        },
        quit_editor: {
            quit: "Quit without saving",
            saveAndQuit: "Save and quit",
            text: "You’ll lose all your changes...",
            title: "Close the edition without saving?",
        },
        see_suggested_content: "See",
        use_this_template: "Use this template",
        webhook_waypoint: {
            cancel: "Cancel",
            save: "Save",
            title: "Send to a CRM",
        },
    },
    campaign_import: {
        importing: {
            info: "Depending on the number of prospects it might take a few seconds before your prospects appear...",
            title: "Adding prospects to your campaign 👥",
        },
        launching: {
            info: "Depending on the number of prospects in your campaign it might take a few seconds before your prospects appear... Your import continues even if you leave the page.",
            title: "Launching your campaign 🚀",
        },
    },
    campaign_name: "Campaign",
    campaign_status: {
        draft: "Draft",
        paused: "Paused",
        running: "Running",
        stopped: "Archived",
    },
    campaign_status_card: {
        stop_campaign: "Archive the campaign",
        stop_modal: {
            cancel_button: "No, cancel",
            stop_button: "Yes, archive this campaign",
            text: "All your prospects will be exited, and you won't be able to play back this campaign. You will still have access to your campaign analytics.",
            title: "You’re about to archive this campaign",
        },
    },
    campaigns: "Campaigns",
    cancel: "Cancel",
    change_plan_form: {
        controls: {
            save: "Save ",
            sections: {
                addons_title: "Adds-ons",
                billing_period: {
                    title: "Billing period",
                },
                current_option: "current",
                inbox: {
                    title: "Waalaxy Inbox",
                    tootltip: "LinkedIn messenger but better, more features and more filters.",
                    for_you_only: "For you only",
                    for_each_of_your_members: "For each of your {{count}} members",
                },
                members: {
                    add_remove_place: "Add or remove seats",
                    each: "Each seat is",
                    hide_addons: "Hide adds-on",
                    members_count: "{{count}} members",
                    number_seats_team: "Members in your team",
                    show_addons: "Show adds-on",
                    subTitle_members_seats_team: "Identical access to the plan and features for each member",
                },
                monthly_price_times: "{{price}}/mo",
                monthly_price_times_members: "{{price}}/mo x {{quantity}} members",
                team: {
                    included_items: {
                        item_1: {
                            description: "Manage leads from one account to another in just a few clicks",
                            title: "Import inter-account and transfer prospects",
                        },
                        item_2: {
                            description: "Never contact the same person as another team member",
                            title: "Anti-duplicate security",
                        },
                        item_3: {
                            description: "Track team performance in one place",
                            title: "Shared statistics",
                        },
                        item_4: {
                            description: "Set up roles and campaigns for the team with one click",
                            title: "Manage team members' accounts",
                        },
                    },
                },
                whats_are_credits: "What are credits ?",
            },
            title: "Update your subscription",
            what_is_included: "What's included ?",
        },
        divider_title: "What's included?",
        inbox: {
            learn_modal: {
                title: "Save hours with the Waalaxy Inbox",
                subtitle: "The Waalaxy Inbox is designed to help you reclaim your time with features tailored to your specific needs.",
                faq: {
                    item1: {
                        title: "Why should I subscribe to Inbox ?",
                        text: "Save countless hours of conversation management : Waalaxy's Inbox is made to help you get back your time with features tailored to Waalaxy's users, without leaving our app. No more back and forth between LinkedIn and Waalaxy to check replies.",
                    },
                    item2: {
                        title: "Which features are added compared to the LinkedIn inbox ??",
                        text: "With Waalaxy's Inbox, you gain access to new filters, new quality of life features (templates, message scheduling, reminders, etc.) and CRM-like features directly in the Inbox : tags, notes, status, prospect data edition, campaign management, etc. Basically all of Waalaxy's power directly embedded in your conversations.",
                    },
                    item3: {
                        title: "Have more questions ?",
                        text: "https://www.waalaxy.com/feature/linkedin-messaging",
                    },
                },
            },
            features: {
                saved_reply: "Pre-recorded responses",
                saved_reply_subtitle: "Stop rewriting for no reason, save time.",
                message_scheduling: "Message scheduling",
                message_scheduling_subtitle: "Send your follow-ups at a specific date",
                message_reminder: "Conversation reminders",
                message_reminder_subtitle: "Bring up conversations at a specific date",
                sync_contacts: "Sync prospects infos",
                sync_contacts_subtitle: "Information, tags, history, notes...",
            },
        },
        team: {
            modal_title: "Manage seats of your team",
            cross_account_import: "Cross-account import",
            cross_account_import_subtitle: "Transfer prospects easily from an account to another",
            anti_duplicate_security: "Anti-duplicate security",
            anti_duplicate_security_subtitle: "Never contact the same person as another team member",
            shared_statistics: "Shared Analytics",
            shared_statistics_subtitle: "Track team performance in one place",
            manage_team_members: "Manage team members' accounts",
            manage_team_members_subtitle: "One click impersonate, manage roles and campaigns",
        },
        transfer: {
            title: "👑 Transfert team ownership",
            subtitle:
                "You will become the new owner of the team, here are the details of the team you will take over. You will be able to change them once the transfer is complete.",
        },
        free_trial: {
            title: "Discover Waalaxy for free !",
            subtitle: "Unlock all LinkedIn features, and get replies this week",
            promotional_1: "Free {{days}} days trial, cancel anytime before it ends.",
            promotional_2: "We’ll remind you before your trial ends.",
            next: "Next",
            continue: "Continue with free trial",
            start: "Start my {{days}} days free trial",
            pre_terms_and_conditions_1: "Your free trial ends {{trialEndDate}}, then you will pay {{planPrice}} incl. VAT yearly on the same date.",
            pre_terms_and_conditions_2: "Change or cancel your plan anytime before {{trialEndDate}}.",
            testimonials: {
                one: {
                    name: "Samy T.",
                    job_title: "Business Developper",
                    message:
                        "Thanks to Waalaxy, I can organize my LinkedIn outreach on a large scale. In a campaign targeting 457 prospects, I achieved a 21.5% engagement rate!",
                },
                two: {
                    name: "Marco F.",
                    job_title: "CEO",
                    message:
                        "With Waalaxy, I generate a steady stream of customers on LinkedIn. One campaign generated over €700,000 in two months. Another turned €500 into €100,000. The ROI is clear.",
                },
                three: {
                    name: "Marwane B.",
                    job_title: "Growth Marketer",
                    message:
                        "Thanks to Waalaxy, I was able to generate 200 leads in two years, with an average order value of €25,000 and a conversion rate of 10% to 30%. An unexpected bonus: our LinkedIn activity also strengthened our employer brand, generating a steady stream of qualified applicants.",
                },
                four: {
                    name: "Philippe A.",
                    job_title: "Founder of Lead Innovation",
                    message:
                        "The best tool for optimizing digital lead generation. More effective and delivers better results than email and phone outreach. Good open and response rates for messages. I highly recommend it.",
                },
                five: {
                    name: "Alyssa C.",
                    job_title: "Talents Acquisition",
                    message: "A very user-friendly tool, even for non-technical users. Useful results for small businesses and SMEs",
                },
                six: {
                    name: "Antonin B.",
                    job_title: "Founder of a design studio",
                    message: "No complicated setup. I launched my first campaign in less than 30 minutes and received my first responses right away.",
                },
                seven: {
                    name: "Simon C.",
                    job_title: "CEO",
                    message:
                        "I appreciate the campaign scheduling features and the templates that make planning them a breeze. The initial setup went perfectly: it was super fast and smooth. I highly recommend it.",
                },
                eight: {
                    name: "Diana H.",
                    job_title: "Business Manager",
                    message:
                        "What I appreciate most about Waalaxy is how simple and intuitive it is. The tool puts an end to the chaos of prospecting on LinkedIn and turns it into a clear, structured process! Thank you!",
                },
                nine: {
                    name: "Delphine P.",
                    job_title: "Business Developper",
                    message:
                        "A great experience with Waalaxy: a simple and convenient tool, and above all, incredibly responsive support. What excellent customer service!!",
                },
            },
        },
        errors: {
            cart_error: "Something went wrong, please contact support",
            new_billing_information_failed: "Error while creating new billing information, please check the form content",
            payment_method_attach_failed: "Payment method attachment failed, please try again in a few seconds.",
            payment_method_creation_failed: "Payment method creation failed, please check your billing informations",
            update_billing_information_error: "Error while updating your billing informations, please check the form content",
            update_email_address: "<a>Please update your email address on the settings page by clicking here</a>",
            update_tax_id_error: "An error occurred while updating your VAT id, please check your VAT id number.",
            tax_id_do_not_match_country: "Tax id does not match the selected country, make sure that's what you want.",
        },
        payment_in_progress: {
            do_not_refresh: "Please stay on this page. You'll be redirected automatically once it's done.",
            downgrade_subtext: "This usually takes a few seconds.",
            payment: "Processing your payment...",
            payment_subtext: "This usually takes a few seconds.",
            processing: "Operation in progress...",
            transfer_processing: "Processing your transfer...",
            transfer_subtext: "This usually takes a few seconds.",
        },
        payment_successful: {
            download_invoice: "Download invoice",
            download_quote: "Download quote",
            operation_successful: "Operation successful!",
            payment_successful: "Payment successful!",
            transfer_successful_line1: "Congrats you are now the owner",
            transfer_successful_line2: "of the Waalaxy Team 🥳",
            go_to_dashboard: "Go to dashboard",
            plan_upgrade_successful: "Plan upgraded, you’re all set",
            plan_upgrade_successful_subtitle: "{{name}}, your {{planName}} plan is now active. You can start prospecting right away.",
            operation_successful_2: "You’re all set !",
            operation_successful_subtitle: "{{name}}, your subscription has been updated. You can start prospecting right away.",
            transfer_success: "You are now the owner of {{teamName}}",
            waalaxy_team: "the Waalaxy Team",
            indian_title: "Almost done!",
            indian_subtitle:
                "due to locale regulation you must complete this payment on the Stripe customer portal, click the following link to pay the invoice.",
            indian_pay_invoice: "Pay my Invoice",
        },
        preview: {
            add_discount: {
                placeholder: "Enter your discount code",
                title: "I have a coupon",
                toasts: {
                    discount_expired: "Expired discount",
                    discount_not_started: "Discount is not available yet",
                    discount_percentage_too_low: "Coupon incompatible with your old coupon (percentage too low)",
                    discount_private: "Discount belongs to another user",
                    discount_product: "Discount not compatible with this cart",
                    discount_quantity_max: "Discount not compatible with the selected quantity (too much seats)",
                    discount_quantity_min: "Discount not compatible with the selected quantity (not enough seats)",
                    discount_quantity_over: "Discount already used",
                    not_a_client_discount_bad_origin: "Coupon code not available for you",
                    not_found: "Discount not found",
                    success: "Discount was successfully applied to your cart",
                    unexpected_error: "Unexpected error with the submitted Discount",
                    multiple_subscription_discounts_not_allowed: "Multiple subscription discounts are not allowed",
                },
                validate: "Apply",
            },
            breakdown: {
                adding_seats: "Adding seat(s)",
                charged_until: "By clicking on the button you will now be charged {{amount}} {{periodicity}} until you cancel your subscription.",
                credit_available: "Balance ({{amount}}{{currency}} available)",
                credit_card_fees: "Credit card fees ({{feesPercentage}}%)",
                credits_days_left: "You only have {{days}} day(s) before your monthly credit renew to use those credits.",
                credits_downgrade: "Downgrade Credits Plan",
                credits_no_changes: "{{quantity}} credits/mo x {{months}} month(s)",
                credits_prorata_tooltip: "You have {{months}} months left on your annual subscription",
                credits_remaining_time: "Remaining time on {{quantity}} credits plan",
                credits_unused_time: "Unused time on {{quantity}} credits plan",
                credits_upgrade: "Upgrade Credits Plan",
                credits_same: "Credits plan",
                plan_same: "{{planName}} Plan",
                current_plan: "Current plan",
                inbox_same: "Inbox plan",
                different_prices_times_members: "{{differentPricesCount}} different prices x {{quantity}} members",
                discount: "Discount",
                downgrade_to: "Downgrade to {{name}}",
                monthly_price_times_members_for_month: "{{amountPerPeriodicity}} x {{quantity}} members / month",
                monthly_price_times_members_for_month_singular: "{{amountPerPeriodicity}} x 1 member / month",
                monthly_price_times_members_with_nbMonths: "{{amountPerPeriodicity}} x {{quantity}} members x {{nbMonths}} months",
                monthly_price_times_members_with_nbMonths_singular: "{{amountPerPeriodicity}} x 1 member x {{nbMonths}} months",
                next_invoice: "Next invoice on {{date}}",
                no_changes: "Please select another subscription than your current one to continue.",
                remaining_time: "Remaining time on {{planName}} {{periodicity}} x{{quantity}}",
                removing_seats: "Removing seat(s)",
                subscribe: "{{periodicity}} {{name}} Plan",
                switching_to: "Switching to {{name}}",
                tax_amount_with_tax_rate: "VAT {{taxRate}}%",
                total_to_pay_now: "Total to pay now",
                unused_time: "Unused time on {{planName}} {{periodicity}} x{{quantity}}",
                will_begin_after: "This update will begin after your current subscription on {{date}}",
            },
            current_payment_method: {
                change_default_payment_method: "Change",
                expires_on: "Expires on {{date}}",
                not_found: "No default payment method found",
                title: "Payment method",
            },
            download_estimate: "Download estimate",
            pay_button: {
                downgrade_disable_bt_discount_event:
                    "The downgrade is not possible during the Black Thirst'day promotional period and will be available again at the end of the event.",
                downgrade_disable_discount_event:
                    "The downgrade is not possible during the Black Friday promotional period and will be available again at the end of the event.",
                go_to_payment: "Go to payment",
                pay_now: "Pay Now",
                pay_amount: "Pay {{amount}}",
                transfer_ownership: "Become the new owner",
                downgrade: "Downgrade",
            },
            title: "Order Summary",
        },
    },
    chat_with_us: {
        button: "Chat with the team",
        text: "Can't find what you're looking for?",
        title: "Chat with us!",
    },
    churn_choice_modal: {
        credit_title: "Credits",
        inbox_title: "Inbox",
        subtitle: "Your plan",
        title: "Need to take a break?",
        unsubscribe_credit: "Unsubscribe",
        unsubscribe_inbox: "Unsubscribe",
        unsubscribe_waalaxy: "Unsubscribe",
    },
    clean_list: {
        tuto_display_data: {
            first_page_content:
                "For example, LinkedIn can refer [Sales Engineer] to [IT Engineer]. This is why we've decided to activate import cleaning.",
            first_page_title: "LinkedIn can mistake jobs titles for each other.",
            second_page_content:
                "We can detect duplicates already present in Waalaxy. These prospects will be transferred to the chosen import list.",
            second_page_title: "Imported prospects may already be in one of your lists",
            third_page_content:
                "Go to LinkedIn, and open the Waalaxy import window. Then, click on the settings button at the top. You can now manage options.",
            third_page_title: "You can edit these settings whenever you like",
        },
    },
    cloudData: {
        error: {
            captcha: "There was an error during verification, please try again",
            purchase: "An error has occured. Please reload the page. If the cloud doesn't seem to run, contact us via the chat. ",
        },
        info: {
            default_proxy: "We were unable to find a proxy for your location. \nWe have assigned you a proxy in the USA.",
        },
        toast: {
            login_success: {
                subtitle: "Everything is ready",
                title: "LinkedIn session connected",
            },
            processing_login: {
                subtitle: "Authorizing LinkedIn in progress",
                title: "Checking your connection…",
            },
        },
    },
    cold_storage: {
        left_modal: {
            title_success_restoration: "Your data has been successfully retrieved!",
        },
        modal: {
            go_home: "Back home",
            subtitle_pending_restoration: "After 6 months of inactivity, we archive your account data. Your prospects will be back in just a moment…",
            tips: {
                auto_transfer_prospects: "You can automatically transfer prospects already in one of your lists to the list you are importing into.",
                best_campaign_model:
                    'The best Waalaxy campaign template is "Invitation + 2 Messages," which offers the highest response rate (40%) for initial contacts.',
                campaign_unique_person: "A person cannot be included twice in the same campaign or in two different campaigns simultaneously.",
                credits_reset_monthly: "Like quotas, your credits reset every month, coinciding with the anniversary of your subscription.",
                crm_sync_description: "Waalaxy is a tool that can be synchronized with other CRMs so you can make all your tools interact together.",
                duplicate_message_protection:
                    "We have implemented a security measure to prevent the repeated sending of the same message to prospects who have already received it.",
                extension_pin_tip: "After downloading the Waalaxy extension, pin it to your browser for easier future imports. This saves you time.",
                import_duplicate_handling:
                    "During an import, Waalaxy scans all prospects, identifies duplicates already present in one of your lists, and excludes them from the import.",
                import_limits:
                    "From LinkedIn, you can import up to a maximum of 1000 prospects. From Sales Navigator, you can import up to 2500 prospects.",
                linkedin_filters_tip: "The LinkedIn search filters that really yield reliable results are: title, company, and location.",
                linkedin_invite_delay: "LinkedIn imposes a 3-week delay after deletion before you can send a new invitation to your prospects.",
                linkedin_keywords_tip:
                    "Using keywords in a LinkedIn search can be ineffective. It's better to use a combination of filters and criteria.",
                linkedin_search_limit:
                    "LinkedIn limits search results display to 1000 profiles. Therefore, it is not possible to import more than 1000 prospects per search.",
                linkedin_sidebar_description:
                    "Our integrated sidebar on LinkedIn allows you to quickly access information and actions available on Waalaxy directly from LinkedIn.",
                message_after_reject_restriction:
                    "If the prospect has declined or ignored your invitation, you cannot send them a message, as they are not yet in your connections.",
                message_templates_tip: "You can create different message and email templates to save time when creating your campaigns.",
                prospect_limit_reached:
                    "If you have reached the maximum number of prospects in your application, you will not be able to import more until you delete some.",
                prospect_tagging:
                    "From your campaign or your prospect list, you can apply tags to your prospects, making filtering and searching easier.",
                prospects_reply_exit_campaign:
                    "If prospects respond during a campaign, they will exit the campaign and will not receive any further actions.",
                quotas_description: "Quotas refer to the maximum number of actions you can take daily. They are calculated at the queue level.",
                quotas_independent_from_linkedin:
                    "Waalaxy's quota system, calculated daily, is independent of the 200 weekly quotas imposed by LinkedIn.",
                random_daily_quota: 'To ensure safe use and a "human" behavior, a random daily quota, between 80% and 100% of your quotas, is set.',
                search_criteria_optimization:
                    "To reduce false positives, simplify and refine your search criteria. Focus on keywords related to the job titles you are targeting.",
                sequence_edit_restriction: "You cannot add, remove, or rearrange actions in a sequence. You must use one of the existing templates.",
                team_feature_description:
                    "The Team system allows you to create a team on Waalaxy, managing multiple seats (one seat = one LinkedIn account).",
                time_to_reach_quotas:
                    "The durations to reach all my quotas: 100 invitations: up to 3 hours and 20 minutes, 150 messages: up to 5.5 hours",
                wait_for_import_completion: "You must wait for your first prospect import to be fully completed before you can start a second one.",
            },
            title_pending_restoration: "Retrieving your prospects…",
        },
    },
    colors: {
        title: "Colors",
    },
    coming_soon: "Coming soon",
    company_upgrade: {
        back_btn: "Back",
        btn: {
            upgrade: "Upgrade",
            upgrade_v2: "Pricing",
        },
        confirm_modal: {
            continue: "Continue",
        },
        periodicity: "Periodicity",
        remove_seats_subtitle: "You need to remove <strong>{{count}} member</strong> from your team to subscribe.",
        remove_seats_title: "Remove {{count}} member",
        retry_fetching_products: "Click the refresh button to get back to our awesome plans!",
        seat: "member",
        seats: "members",
        team_option: "Team Option",
    },
    confirm: "Confirm",
    confirm_cancel_cta: "Cancel",
    connect: "Invitation",
    email: "Email",
    connect_note_restricted: {
        campaign: {
            delete_notes_btn: "Delete notes for this campaign",
            subtitle:
                "Since a recent update, only LinkedIn Premium members can include notes in their invitations.<br />\nIf your invitations are pending, switch to Premium or remove the notes from your campaign so that it can continue.",
        },
        campaigns: {
            delete_notes_btn: "Delete notes in all campaigns",
            subtitle:
                "Since a recent update, only LinkedIn Premium members can include notes in their invitations.<br />\nIf your invitations are pending, switch to Premium or remove the notes from your campaigns so that they can continue.",
        },
        check_restriction_modal: {
            check: {
                check_again_btn: "Recheck my subscription",
                check_btn: "Check my subscription",
                subtitle:
                    "You have chosen to upgrade to LinkedIn Premium. We need to verify your subscription so that you can access its benefits.<br /> <br />\nIf you haven't joined LinkedIn Premium, you can return to the relevant campaigns to remove the notes.",
                title: "Check your subscription",
            },
            verified: {
                cta: "Cool!",
                subtitle: "As a LinkedIn Premium user, you can continue to send invitations with notes.",
                title: "Subscription verified!",
            },
        },
        drafts: {
            delete_notes_btn: "Delete notes in all campaigns",
            subtitle:
                "Since a recent update, only LinkedIn Premium members can include notes in their invitations.<br />\nUpgrade to Premium or remove notes from your campaigns so that you can launch them without blocking invitations.",
        },
        go_premium: "Upgrade to LinkedIn Premium",
        linear_sequence: {
            disabled_tooltip: "Adding notes to your invitations is only possible with LinkedIn Premium",
        },
        linkedin_update: "LinkedIn update: note restrictions",
        quick_launch: {
            tips_card: "With LinkedIn Premium, you can add a note to your invitations.",
        },
        remove_notes_modal: {
            campaign: {
                subtitle:
                    "Your campaign will relaunch without the invitation note.<br /> If you have messages in your campaign, remember to check that they are still consistent without the invitation note.",
                warning: "They will be removed for this campaign only.",
            },
            campaigns: {
                subtitle:
                    "Your campaigns will relaunch without invitation notes.<br /> If you have messages in your campaigns, remember to check that they are still consistent without the invitation note.",
                warning: "They will be deleted from all your campaigns: in progress, paused and draft.",
            },
            cancel_btn: "No, cancel",
            remove_btn: "Yes, delete",
            title: "Are you sure you want to delete your notes?",
            toast: {
                success: "Notes have been removed",
            },
        },
        still_not_premium: "You are still not subscribed to LinkedIn Premium. ",
        verify_subscription: "Check my LinkedIn subscription",
    },
    connected_as: "Connected as {{firstName}} {{lastName}}",
    content: "Content",
    content_editor: {
        cancel: "Cancel",
        create_new_template: "Create a new template",
        custom_variable: "You need to fill this information in order to validate your message",
        template_already_used_in_campaign: "This content template is already used in some campaign(s)",
        update_everywhere: "Update everywhere",
    },
    create: "Create",
    create_campaign: "Create a new campaign",
    create_prospect_list_modal: {
        title_create_list: "Create a list",
    },
    credits: {
        add_credits: "Add Credits Plan",
        banner: {
            subtitle: "Find professional email addresses with customize credits. 1 credit = 1 pro email found.",
            title: "Choose your credits plan",
        },
        basic_card: {
            until_reset_date: "until {{ date }}",
        },
        buy_more: "Buy more credits",
        credits: "Credits",
        credits_by_month: "{{credits}} credits/mo",
        additional_credits: "Additional Credits",
        credits_plans: "Credits plans",
        learn_about_credits: "Learn about Credits",
        learn_about_credits_link: "https://www.waalaxy.com/feature-email-finder/",
        learn_about_modal: {
            credit_equals_email_found: "1 credit = 1 pro email found",
            faq: {
                item1: {
                    text: "Credits are valid for one month. At the end of the period, they are reset.",
                    title: "When do credits expire?",
                },
                item2: {
                    text: "It's not possible to buy \"one-off\" credits; it's only possible to buy credit plans.",
                    title: 'Can I buy "one-off" credits?',
                },
                item3: {
                    text: "If you buy credits just before your renewal, you'll only have a few days to use them (until your renewal date).",
                    title: "What happens if I buy credits just before my renewal?",
                },
                item4: {
                    text: "Credits are renewed every month, on your subscription renewal date. If you have a yearly or quarterly subscription, this is the day of the month in which you subscribed.\nFor example, if you bought a yearly subscription on 12/15/2023, your credits will renew every 15th of the month.",
                    title: "When do my credits renew?",
                },
                item5: {
                    text: "Yes, the higher your credit plan, the cheaper the credits.",
                    title: "Is there a volume discount?",
                },
                item6: {
                    link: "https://www.waalaxy.com/feature-email-finder/",
                    title: "Have more questions ?",
                },
                title: "Frequently asked questions",
            },
            get_started: "Get started",
            subtitle: "You can add more credits as per your needs. These add-on credits are shared across your team.",
            tiers: {
                monthly_credits: "Monthly credits",
                price_per_credit: "Price per credit",
                price_per_month: "Price/mo",
            },
            title: "Add more credits",
        },
        modal: {
            add_credits: "Add credits to your subscription",
            features: {
                customize_plan: {
                    subtitle: "Find professional email addresses with customize credits.",
                    title: "Customized Credits plans",
                },
                pay_on_success: {
                    subtitle: "Pay only for what you get.",
                    title: "1 credit = 1 pro email found",
                },
                shared_team: {
                    subtitle: "Your credits are available for all your team members.",
                    title: "Shared across team",
                },
            },
            subtitle: "Find professional email addresses with customize credits.",
            title: "Credits Plans",
        },
        next_renew: "Next credit renew on {{date}}",
        plus_free_credits: "(+{{freeCredits}} free per seat)",
        queue_card: {
            credits_left: "left until {{month}}",
            learn_more_tooltip: "To learn more about renewing your credits click here.",
            reached: "Credit limits reached",
            start_a_campaign: "Start a campaign",
            total: "Total credit",
        },
        shared_team: "Credits are shared across team members.",
        team_credits: "Team credits",
    },
    crm_cta: "Connect CRM",
    cta_import: "Import",
    daily_quotas: "Daily quotas",
    dashboard: {
        acceptanceRate: "Acceptance rate",
        actionsSent: {
            accepted: "Accepted",
            bounced: "Not delivered",
            connections: "Invitations",
            emailFinder: "Pro emails searched",
            emailTitle: "Emails sent",
            email_found: "Pro Email found",
            followed: "Followed",
            follows: "Follows",
            mails: "Sent",
            message_requests: "Message requests",
            messages: "Messages",
            no_data: {
                email: {
                    button_link: "https://blog.waalaxy.com/en/sales-email/",
                    button_text: "Start my email campaign strategy",
                    subtitle: "Don't panic, get started with the help of our tips!",
                    title: "You haven't sent any emails yet 😿",
                },
            },
            queued: "Email finder started",
            replied: "Received a response",
            sent: "Sent",
            title: "Actions sent",
            visited: "Visited",
            visits: "Visits",
        },
        all_members: "All members",
        answerRate: "Response rate",
        back: "Back to team analytics",
        day: "{{day}} days",
        delete_pending_invitation: "Delete pending invitations",
        email: "Email",
        linkedin: "LinkedIn",
        locked_email: {
            button_text: "Unlock Emails",
            incentive_text: "Users get as much as <strong>50% more answers</strong> when they also send emails in their campaigns.",
            label: "Emails",
        },
        modal: {
            delete_pending_invitation_content:
                "Your pending invitations beyond <strong>{{delay}}</strong> will be gradually removed. This can take up to an hour.",
            delete_pending_invitation_title: "Delete pending invitations",
        },
        month_many: "{{month}} months",
        month_one: "{{month}} month",
        my_infos: {
            connections: "Connections",
            invitations: "Pending",
            views: "Profile views",
        },
        performances: {
            acceptance_rate: {
                absolute_value_description: "Accepted invitations",
                percentage_value_description: "Acceptance rate",
                tooltip: "Number of accepted invitations, out of the total sent with Waalaxy",
            },
            answer_rate: {
                absolute_value_description: "Answered messages",
                percentage_value_description: "Response rate",
                tooltip:
                    "Responses obtained from prospects who go through a campaign, and who have accepted an invitation and/or received a message.\nWhen a prospect responds in a campaign, all invitations and messages sent in the campaign are considered responded to.",
            },
            bounce_rate: {
                absolute_value_description: "Not delivered",
                percentage_value_description: "Bounced rate",
                tooltip: "Emails that have been marked as Spam or have been rejected by the prospect's provider (= bounced emails)",
            },
            delivery_rate: {
                absolute_value_description: "Delivered",
                percentage_value_description: "Deliverability rate",
                tooltip: "Emails that have been correctly delivered into your recipient's main inbox",
            },
            emailFinder: {
                absolute_value_description: "Pro Emails found",
                good_to_known: "Good to know",
                info: "The size of your prospects' company has an impact on the rate of emails found. The larger the structure, the higher the rate.",
                percentage_value_description: "Email found percentage",
                tooltip: "Number of emails found out of the total number of email finder launched",
            },
            opened_rate: {
                absolute_value_description: "Opened",
                percentage_value_description: "Open rate",
                tooltip: "Percentage of opened emails out of delivered emails",
            },
            replied: {
                absolute_value_description: "Responses",
                percentage_value_description: "Response rate",
                tooltip: "Emails to which your prospects have replied",
            },
        },
        prospecting_status: {
            actions_in_queue: "Queued actions",
            active_campaigns: "Active campaigns",
            status: {
                active: {
                    text: "Active",
                    tooltip: "Your actions are currently being sent",
                },
                campaignsInvitationsFrozen: {
                    text: "Action required",
                    tooltip:
                        "Since a recent update, only LinkedIn Premium members can include notes in their invitations. Your invitations are on hold, you can relaunch them from the 'Campaign list' page.",
                },
                inactive: {
                    cta_text: "Create a campaign",
                    text: "Inactive",
                    tooltip: "You have no active campaign",
                },
                off: {
                    cta_text: "Update activity",
                    text: "Off",
                    tooltip: "You are outside your working hours",
                },
                postponed: {
                    tooltip: 'LinkedIn or Waalaxy invitation quotas reached.\nMore info on your actions in the "Daily Quotas" section.',
                },
                quotas_full: {
                    text: "Quotas reached",
                    tooltip: "LinkedIn or Waalaxy invitation quotas reached, more info in your queued actions",
                },
                waiting: {
                    cta_text: "See my campaigns",
                    text: "Waiting",
                    tooltip:
                        "You don't have any actions in the queue, but prospects can move forward in your campaigns (waiting for acceptance, response or delay)",
                },
            },
            title: "Prospecting status",
        },
        remove_invitation: {
            cta: "Delete",
            success: "Your invitations are being deleted",
            title: "Delete invitations sent older than:",
        },
        title_team_analytics_dashboard: "Team analytics",
        tooltips: {
            email: "Responses to emails from my campaigns",
            linkedin:
                "Responses obtained from prospects who go through a campaign, and who have accepted an invitation and/or received a message.\nWhen a prospect responds in a campaign, all invitations and messages sent in the campaign are considered responded to.",
        },
        total_replies: {
            email: "Email responses",
            linkedin: "Message responses",
        },
    },
    data_restoring: "Retrieving your leads… This may take a few moments",
    day: "day",
    delete: "Delete",
    delete_prospect_list_modal: {
        cancel_button: "No, Cancel",
        delete_button: "Yes, Delete this list",
        text_2: "Confirm by typing the number of prospects:",
        title: "Delete this list?",
    },
    disabled: "Disabled",
    discount_event: {
        claim_discount: "Claim discount",
        black_friday: {
            name: "Black Friday",
        },
        black_thirstday: {
            name: "Black Thirstday",
            alert_text: "<bt>{{eventName}}:</bt> get 30% OFF our Advanced, Business and Inbox yearly plans until 19/06, 11 a.m CET",
        },
    },
    discussion_preview: {
        subtitle: "How your prospect will see your message",
        title: "Preview",
    },
    done: "Done",
    dont_show_again: "Don’t show again",
    downgrade: "Choose this plan",
    download: "Download",
    download_manifest_v3: {
        title: "New version of <color>Waalaxy</color> released",
    },
    drag_and_drop: {
        browse: "Browse",
        cta: "Choose file",
        info1: "Drag & Drop or",
        info2: "to upload",
        loading: "Uploading",
        max_size_of: "Max size of",
    },
    duplicate_security: "Team duplicate security",
    edit: "Edit",
    emailVerification: {
        error: {
            cancel: "Something didn't work on our side, please refresh the page and try again",
            resend: "Unable to resend verification code. Please try entering your credentials again",
            verification: "Wrong verification code. Please try again",
        },
        success: {
            resend: "Verification code resent by email",
            verification: "Email verified!",
        },
    },
    emojis: {
        loading: "Loading...",
        not_found: "Not found",
        title: "Emojis",
    },
    endFreeTrialModal: {
        advanced: {
            feature_1: "100 daily invitations quotas",
            feature_2: "LinkedIn Lead Generation",
            feature_3: "Auto-import LinkedIn profiles",
            feature_4: "Synchronise your data with your CRM",
            feature_5: "Offline mode",
            title: "Advanced Plan",
        },
        black_friday: {
            business: {
                feature_1: "100 daily invitations",
                feature_2: "LinkedIn campaign",
                feature_3: "Email campaigns",
                feature_4: "500 email enrichments",
                feature_5: "Priority support",
            },
            cta: {
                cancel: "Stay restricted by my current plan",
                go: {
                    advanced: "Get 50% off the Business offer",
                    freemium: "Get 50% off the Advanced offer",
                    pro: "Get 50% off the Advanced offer",
                },
            },
            pro: {
                feature_1: "11 daily invitations",
                feature_2: "300 monthly invitations max",
            },
            subtitle: {
                advanced: "You’re moving to the Advanced plan and will no longer have access to Business features",
                freemium: "You’re switching to the Freemium plan and will lose access to premium features",
                pro: "You’re moving to the Pro plan and will no longer have access to Advanced features",
            },
        },
        business: {
            feature_1: "100 daily invitations quotas",
            feature_2: "LinkedIn + Email campaigns",
            feature_3: "Auto-import LinkedIn profiles",
            feature_4: "Synchronise your data with your CRM",
            feature_5: "Offline mode",
            title: "Business Plan",
        },
        cta_show_all_plans: "View plans",
        cta_stay_limited: "Keep the free plan",
        freemium: {
            feature_1: "3 daily invitations",
            feature_2: "LinkedIn only campaigns",
            feature_3: "Auto-import LinkedIn profiles",
            feature_4: "Synchronise your data with your CRM",
            feature_5: "Offline mode",
            title: "Freemium Plan",
        },
        keepYourPlan: "You’ll still be able to do :",
        leaveYourPlan: "BB",
        leave_your_plan: "But immediately loose access to :",
        pro: {
            title: "Pro Plan",
        },
        reduction_only_today: "(-50% today only)",
        subtitle: "You are downgraded to the Freemium plan and loose access to premium features",
        title: "Your free trial is over 😞",
    },
    end_of_pro_plan_modal: {
        cta: "Ok! Got it!",
        headline: "You benefit from the Advanced Plan at no extra cost",
        sections: {
            what_wont_change: {
                billing_cycle: "The <strong>periodicity</strong> of your subscription",
                options: "<strong>Inbox</strong> and <strong>Team</strong> if you have these options",
                price: "The <strong>price</strong> of your current subscription",
                title: "What doesn't change:",
            },
            whats_more_for_you: {
                advanced_sequences: "<strong>More advanced </strong>campaigns",
                quotas: "Increase in <strong>quotas</strong>",
                see_all_advanced_perks: "See all Advanced Plan features",
                sync_crm: "CRM Sync",
                title: "Plus for you:",
                triggers: "prospects <strong>Auto-import</strong>",
            },
        },
        title: "Surprise, you've been upgraded! ",
    },
    end_of_trial: {
        extend_free_trial: {
            enjoy_new_month: "Enjoy your benefits for another month!",
            enjoy_new_week: "Enjoy your benefits for another week!",
            free_trial_over: "Your free trial is over, ready to upgrade?",
            get_one_more_month: "Claim my free month",
            get_one_more_week: "Claim another free week",
            need_another_week: "Need another week to try it out? So here's a special gift for you!",
            ready_upgrade: "Ready to upgrade?",
            toast_success: "Your trial period has been extended for 7 days 🎉",
            upgrade_now: "Upgrade now",
        },
        list_benefits: {
            advance: "advanced",
            auto_import: "Auto-Imports",
            email_search: "with email search",
            multi_channel: "Multi-channel",
            of_prospect: "of prospects",
            quotas: "Quotas",
            sequence: "Campaigns",
            unlimited: "maximum",
        },
        resume_free_trial: {
            change_from_freeplan: "You'll be changed to our free plan and lose access to all your Premium benefits:",
            free_trial_over: "Your free trial is over.",
            goodbye_premium_befenits: "Goodbye Premium benefits 😢",
            information:
                "With the end of your free trial, you’ll always have to keep your <strong> computer on </strong> and a <strong> Linkedin tab open </strong> to execute actions on your account.",
            now: "now",
            resume_stat: "Here is what you got since you got here:",
            skip_for_now: "Skip for now",
            specific_black_friday: {
                button_cancel: "Cancel and lose access to those features",
                button_upgrade_suffix: "& Keep my campaigns running",
                change_from_freeplan: "You’ll change to our free plan and lose access to all your Premium benefits:",
                free_trial_over: "Your free trial is over, ready to upgrade?",
                what_you_lose: "What you’ll lose 😢",
            },
        },
    },
    end_point: "End point",
    enter_post_url: "Enter the URL here",
    error: "Something went wrong",
    error_while_fetching: "Error while fetching",
    export: "Export",
    export_to_hubspot: "Export to HubSpot",
    export_to_pipedrive: "Export to Pipedrive",
    extension: {
        alien_copilot_promo: {
            cta_add: "Add",
            settings_subtitle: "Import from LinkedIn",
            settings_title: "Install Alien Copilot",
            subtitle: "Imports from your LinkedIn feed.",
            title: "Alien Copilot extension",
        },
        is_not_ok: "We’re having some issues accessing your planet.",
        link_success: "Your Waalaxy extension is now connected 🎉",
        missing: {
            CTA: "Go to Chrome Store",
            image_url: "https://i.postimg.cc/yYPkMGt9/Dark.png",
            info: "You need to download or activate the Waalaxy extension on the google chrome store to access the app.",
            title: "You don’t have Waalaxy’s chrome extension 😮",
        },
        need_reload: {
            link: "https://my-public-bucket-prod.s3.eu-west-1.amazonaws.com/reload_extension.gif",
            title: "Oops! Your extension needs to restart to connect to LinkedIn 👉 <a>see how to do it</a>",
        },
    },
    failed: "Failed",
    field_cannot_be_empty: "This field cannot be empty",
    filters: {
        excluded: "Exclude",
        inc_exc_multi_key_value: {
            add_button: "Add",
            key: "Key",
            remove_button: "Remove",
            value: "Value",
        },
        included: "Include",
        more: "More filters",
        multi_select: {
            no_options: "No options",
        },
        reset_all_button: "Reset filters",
    },
    filters_title: "Filters",
    follow: "Follow",
    form: {
        campaign: {
            name: {
                feedback: {
                    error: {
                        empty_name: "Empty campaign name",
                        same_name: "Campaign name already exist",
                    },
                },
                fields: {
                    name: {
                        placeholder: "Campaign name",
                    },
                },
            },
        },
        company_permissions: {
            access_members_analytics: "Access to members analytics",
            access_team_analytics: "Access to team analytics",
            impersonate: "Access to members' app",
            import_duplicates: "Import with Team duplicates",
            import_in_crm: "Import in members' app",
            manage_company_members: "Add/remove members",
            manage_company_permissions: "Update members permissions",
            manage_company_settings: "Edit team name and logo",
            manage_duplicates: "Manage Team duplicates",
            multi_select: {
                placeholders: {
                    access_members_analytics: "Select members",
                    impersonate: "Select members",
                    import_in_crm: "Select members",
                },
            },
            see_actions_overview: "See members with empty queue",
            see_company_members: "See other members",
            select: {
                options: {
                    all: "All",
                    custom: "Custom",
                },
            },
            tooltips: {
                access_members_analytics: "Activate to allow this user to see other members analytics",
                access_team_analytics: "Activate to allow this user to access the Team Analytics tab",
                impersonate: "Enable to allow this user to access the app of the other members",
                import_duplicates: "Enable to allow this user to import without checking for duplicates in the app of the other members",
                import_in_crm: "Enable to allow this user to import prospects in the app of the other members",
                manage_company_members: "Enable to allow this user to add or remove other members in the Team",
                manage_company_permissions: "Enable to allow this user to update the permissions of the other members in the Team",
                manage_company_settings: "Enable to allow this user to edit the company name and icon",
                manage_duplicates: "Enable to allow this user to see and manage Team duplicates",
                see_actions_overview: "Enable to allow this user to see the members without actions in their queue",
                see_company_members: "Enable to allow this user to see the other members in the Team",
            },
        },
        content: {
            attachments: {
                error: {
                    required: "Please add attachments",
                },
            },
            editor: {
                placeholder: "Write something amazing...",
            },
            fragments: {
                error: {
                    required: "This field is required",
                    variables_invalid_fallbacks: "Some variables have no default value",
                    variables_invalid_interpolation: "Please enter valid variables to continue",
                    variables_no_blank_left: "Remove the brackets and insert a text that fits your case",
                },
            },
            gifs: {
                error: {
                    required: "Please add a GIF",
                },
            },
            helper: {
                avoid_politeness: "avoid politeness e.g. “Sincerely”, “Best regards”",
                caracter_limit: "use between 100 and 500 characters",
                dont_use_name: "don’t use your first name or last name",
                dont_use_pronoun: 'don\'t use the pronoun "I" or "we" more than once',
                invitation_caracter_limit: "use between 100 and 300 characters",
                more_tips: "More tips to write your message",
                subtitle: "Skyrocket response with expert advice",
                title: "Check your message",
                tuto: {
                    page_1: {
                        content: "A sentence that gets attention so that the rest of your message is read. Focus on your prospect's problem.",
                        title: "Start by attracting attention with a good hook",
                    },
                    page_2: {
                        content:
                            "The 2 best reasons for your prospect to work with you. Be concise. Show how your offer specifically meets the prospect's needs.",
                        title: "Propose a solution with your value proposition",
                    },
                    page_3: {
                        content: "The next action your prospect have to take to go further. E.g.: a Calendly link, a website, a phone number, etc.",
                        title: "Encourage next steps with a call to action",
                    },
                    page_4: {
                        content:
                            "Maintain the same structure. Use another hook, another value proposition, another CTA. Never ask your prospect to read your previous message. ",
                        title: "Do almost the same for your first follow-up",
                    },
                    page_5: {
                        content: "Use an unexpected approach to get a response at all costs. ",
                        title: "For your last follow-up: be original",
                    },
                    page_6: {
                        content:
                            'If you want more tips and some examples for messages that work, <a href="https://blog.waalaxy.com/en/prospecting-messages/"> read the full article. </a>',
                        title: "More tips, more examples",
                    },
                },
                use_first_name_variable: "use {{firstName}} variable",
            },
            name: {
                default_connect: "Invitation",
                default_email: "Email",
                default_message: "Message",
                default_saved_reply: "Templates",
                error: {
                    already_used: "Content with same name already exist",
                    max_length: "The name is too long",
                    required: "This field is required",
                },
                label: "Model name",
                placeholder: "Name your message template",
            },
            provider: {
                error: {
                    required: "This field is required",
                },
                label: "Send with",
                placeholder: "Send with email account...",
            },
            root: {
                no_content: "Your message is empty, add text, attachments or gifs",
            },
            selector: {
                email_label: "Email model",
                label: "Message model",
            },
            subject: {
                error: {
                    max_length: "The subject is too long",
                    required: "This field is required",
                },
                placeholder: "Email subject",
            },
            toolbar: {
                attachment: {
                    add: "Add attachment",
                },
                color_picker: {
                    tooltip: "Font color",
                },
                disabled: "Attachments unavailable",
                emoji_picker: "Add Emoji",
                font_size: {
                    large: "Large",
                    medium: "Medium",
                    small: "Small",
                    tooltip: "Font size",
                    very_large: "Very large",
                },
                link: {
                    add: "Add link",
                    link_label: "Link",
                    modify: "Modify link",
                    placeholder: "Link label",
                    text_label: "Text",
                },
                signature_picker: {
                    manage_signatures: "Manage my signatures",
                    no_signature: "No signature",
                },
                to_much_attachment: "4 attachments max",
            },
            waami: {
                form: {
                    placeholder: {
                        call_to_action_placeholder: "I would like my prospects to...",
                        differentiatingElement_placeholder: "I stand out by...",
                        language_placeholder: "Choose language",
                        target_placeholder: "e.g: Business manager",
                        text_placeholder: "I offer...",
                    },
                    title: {
                        call_to_action_input_title: "Call to action (required)",
                        differentiatingElement_input_title: "Differentiating factor (required)",
                        language_input_title: "Language",
                        submit: "Generate",
                        submit_again: "Re-Generate",
                        submit_loading: "Generation in progress...",
                        target_input_title: "Target (required)",
                        value_input_title: "Value proposition (required)",
                    },
                    tooltip: {
                        call_to_action_tooltip:
                            "The next action your prospect have to take if convinced. E.g.: a Calendly link, a website, a phone number, etc.",
                        differentiatingElement_tooltip: "What makes your service / product better than your competitors",
                        value_proposition_tooltip: "What problem are you here to solve for your customer?",
                    },
                },
                fresh_message: "Fresh message every time!",
                generation_in_progress: "Generation in progress...",
                subtitle: "Write the perfect message instantly",
                title: "Waami, your AI buddy",
                tuto: {
                    page_1: {
                        content:
                            'Clearly state what you offer and why it\'s beneficial <br /> <br /> Example: "Our project management service helps reduce operational costs by 30%...".',
                        title: "Defining the value proposition",
                    },
                    page_2: {
                        content:
                            'Focus on the tangible, quantifiable or emotional benefits users will get. <br /> <br /> Example: "Recruitment costs halved VS a traditional recruitment agency."',
                        title: "Tell us what makes you different",
                    },
                    page_3: {
                        content:
                            'Decide on the specific action you want the recipient to take. <br /> <br /> Example: "I\'d like the prospect to make an appointment for a free demonstration."',
                        title: "Formulating the Call to Action",
                    },
                    page_4: {
                        content:
                            "<ul><li> <strong>Be Specific:</strong> The more precise your information, the more personalized the message.</li> <li> <strong>Focus on Benefits:</strong> Highlight the clear, tangible benefits of your offer.</li><li> <strong>Clear CTA:</strong> Your call to action should be direct and easy to understand.</li><li> <strong>Consistency:</strong> Make sure the tone, value proposition and CTA are aligned...</li></ul>",
                        title: "Tips for filling the form ",
                    },
                },
                tutorial: "See how to use Waami at its full potential",
            },
        },
        crm_sync: {
            connect_form: {
                accepted_invitation: "Accepted my invitation",
                added_to_campaign: "All prospects added to campaigns",
                choose_when_to_sync: "Choose when you want your prospects to be synchronized with {{crmName}} :",
                less_data: "Less data",
                more_data: "More data",
                pipedrive_data: "Pipedrive data",
                pro_email_found: "Were successfully enriched (email finder)",
                reply_to_email: "Replied to an email",
                reply_to_linkedin_message: "Replied to a LinkedIn message",
                reply_to_linkedin_message_with_interest: "Replied to a LinkedIn message with interest (Response Analysis)",
                select_all: "Select all",
                select_data: "Properties configuration",
                waalaxy_data: "Waalaxy data",
            },
            connect_in_settings: "Connect my CRM in Settings",
            export_to_crm: "Export to {{crmName}}",
            hubspot: {
                connect_form: {
                    added_to_campaign: "All prospects added to campaigns",
                    choose_when_to_sync: "Choose when you want your prospects to be synchronized with HubSpot :",
                    create_list: "Create list: {{listName}}",
                    creating_list: "Creating list...",
                    error_invalid_triggers: "You must select at least one trigger",
                    hubspot_data: "HubSpot data",
                    less_data: "Less data",
                    more_data: "More data",
                    no_option: "You don't have any lists, enter the name of your list to create it.",
                    none: "Only prospects I manually export",
                    only_on: "Only prospects who:",
                    select_all: "Select all",
                    select_data: "Properties configuration",
                    select_list: "HubSpot list to send data to (optional)",
                    select_list_placeholder: "Select or create a list",
                    select_type: "You must select at least the email property or first and last name properties.",
                    waalaxy_data: "Waalaxy data",
                    do_not_contact: "Do not contact (Waalaxy)",
                },
                disconnect_form: {
                    connect_app: "Connect app",
                    connect_to_hubspot: "Connect Waalaxy to HubSpot",
                    send_data: "Send the data you want from your prospects directly to your HubSpot account!",
                },
                how_affect: {
                    how_affect_hubspot: "How to use HubSpot integration?",
                    link_url: "https://intercom.help/waalaxy/en/articles/7234415-waalaxy-x-hubspot",
                },
                properties: {
                    do_not_contact: "Do not contact (Waalaxy)",
                    company_linkedin_url: "Company Linkedin URL (Waalaxy)",
                    company_name: "Company name",
                    company_website: "Website URL",
                    email: "Email",
                    first_name: "First name",
                    gender: "Gender (Waalaxy)",
                    job_title: "LinkedIn Headline (Waalaxy)",
                    last_name: "Last name",
                    linkedin_url: "LinkedIn URL",
                    location: "Country/Region",
                    occupation: "Job Title",
                    phone_numbers: "Phone number",
                    profile_status: "Prospect status (Waalaxy)",
                    prospect_list: "Prospects list (Waalaxy)",
                    state: "Prospect state (Waalaxy)",
                    tags: "Tags (Waalaxy)",
                },
                save_as_default_list: "Save as default list",
                settings: "HubSpot settings",
            },
            menu: {
                coming_soon: "Coming soon",
                connect_app: "Connect App",
                reconnect: "Reconnect",
                disconnected: "Disconnected",
                connected: "Connected",
                new: "New",
                send_data: "Send the data you want from your prospects directly to your {{name}} account!",
                via_zapier: "via Zapier",
            },
            no_crm: {
                advice: "Where to find?",
                api_key: {
                    advice_title: "Where to find your API key?",
                    label: "API Key*",
                    placeholder: "Put your noCRM.io API key here",
                    required: "API key required",
                },
                connect: "Connect",
                disconnect: "Disconnect",
                disconnected_error_subtitle: "Please edit your information to continue.",
                disconnected_error_title: "Oops! Seems like we had some issues connecting to your noCRM.io account.",
                email: {
                    invalid: "Email has invalid format",
                    label: "Email*",
                    placeholder: "donald.duck@mail.com",
                    required: "Email required",
                },
                lead_description: {
                    advice: "<strong>Note:</strong> add your Waalaxy variables here to export your prospects' information to noCRM.io!",
                    failed_to_fetch: {
                        ask_support: "Ask the support",
                        retry: "Retry",
                        subtitle: "Unable to get your variables",
                        title: "Failed to retrieve variables",
                    },
                    label: "Description",
                    placeholder: "Write something amazing...",
                },
                lead_title: {
                    label: "Title of the lead",
                    placeholder: "Name your lead",
                },
                pay_subscription: "Your noCRM subscription has ended, check your payment settings on noCRM.io",
                subdomain: {
                    advice_title: "Where to find your subdomain?",
                    label: "Subdomain*",
                    placeholder: "your.subdomain.name",
                    required: "Subdomain required",
                },
                title: "Connect to noCRM.io",
                update: "Update",
                wrong_email: "This email is not linked to a noCRM.io account",
                wrong_nocrm_plan: "You must upgrade your noCRM plan to link your account to Waalaxy",
                wrong_subdomain_or_api_key: "Wrong subdomain or API key",
            },
            pipedrive: {
                create_deal: {
                    description: "Automatically create a deal in Pipedrive every time a person is created through a trigger or manual export",
                    no_pipeline_option: "You don't have any pipelines, enter the name of your pipeline to create it.",
                    no_stage_option: "You don't have any stages, enter the name of your stage to create it.",
                    select_pipeline: "Choose the pipeline",
                    select_pipeline_placeholder: "Select the pipeline",
                    select_stage: "Choose the stage",
                    select_stage_placeholder: "Select the stage",
                    title: "Also create a deal when a person is created",
                },
                create_note: {
                    description: "Actions performed by Waalaxy on prospects will be logged in Pipedrive as a note, in the person details",
                    title: "Log Waalaxy actions in Pipedrive",
                },
                disconnect_form: {
                    connect_to_pipedrive: "Connect Waalaxy to Pipedrive",
                    send_data: "Send the data you want from your prospects directly to your Pipedrive account!",
                },
                error_invalid_stage_pipeline_select: "Please choose a pipeline and stage",
                error_pipeline_empty: "Invalid Pipeline",
                error_stage_empty: "Invalid Stage",
                failed_property: "Couldn’t be created in Pipedrive",
                failed_to_save_properties: "Too many custom fields in Pipedrive ",
                how_to_use: "How to use Pipedrive integration?",
                link_url: "https://intercom.help/waalaxy/en/articles/7338903-waalaxy-x-pipedrive",
                properties: {
                    company_linkedin_url: "Company Linkedin URL (Waalaxy)",
                    company_name: "Organisation",
                    company_website: "Company Website (Waalaxy)",
                    email: "Email",
                    first_name: "First name",
                    gender: "Gender (Waalaxy)",
                    job_title: "LinkedIn Headline (Waalaxy)",
                    last_name: "Last name",
                    linkedin_url: "URL LinkedIn (Waalaxy)",
                    location: "Location (Waalaxy)",
                    occupation: "JobTitle (Waalaxy)",
                    phone_numbers: "Phone number",
                    profile_status: "LinkedIn Status (Waalaxy)",
                    prospect_list: "Prospects list (Waalaxy)",
                    state: "Prospect state (Waalaxy)",
                    tags: "Tag",
                    do_not_contact: "Do not contact (Waalaxy)",
                },
                settings: "Pipedrive settings",
            },
            sync: "{{crmName}} sync",
            sync_settings_explanation:
                "Now <b>ALL your campaigns are synced with {{webhookType}}</b>, no need to go through a campaign with Synchro CRM.<br />\nThe sync options are editable in <a>your settings</a>.",
            toast: {
                crm_disconnect_success: "CRM account disconnected",
            },
            waalaxy: {
                properties: {
                    company_linkedin_url: "Company LinkedIn URL",
                    company_name: "Company name",
                    company_website: "Company Website URL",
                    email: "Pro email / Email",
                    first_name: "First name",
                    gender: "Gender",
                    job_title: "LinkedIn profile title (Headline)",
                    last_name: "Last name",
                    linkedin_url: "LinkedIn profile URL",
                    location: "Location",
                    occupation: "Job Title",
                    phone_numbers: "Phone number",
                    profile_status: "Prospect status",
                    prospect_list: "Prospects list",
                    state: "Prospect state",
                    tags: "Tags",
                    do_not_contact: "Do not contact",
                },
                tooltip: {
                    email: "Pro email is used when available, otherwise LinkedIn email is used instead",
                },
            },
        },
        email_registration_required: {
            existing_user_subtitle: "The email associated with your LinkedIn account was not detected, please enter it manually",
            feedback: {
                error: {
                    email_already_used: "This email is already linked to a Waalaxy account",
                    empty_email: "This field is mandatory",
                    not_email: "This email is not valid.",
                },
            },
            fields: {
                email: {
                    label: "Email",
                    placeholder: "donaldduck@gmail.com",
                },
            },
            main_cta_label: "Confirm",
            title: "Hello 👋",
            server_error: "Something went wrong with our server, please try again",
        },
        my_account_affiliation: {
            fields: {
                affiliation_code: {
                    error: {
                        required: "The affiliation code is required",
                    },
                    label: "Affiliation Code (12 characters)",
                    placeholder: "xxxxxxxxxxxx",
                },
            },
            save: "Validate",
        },
        my_account_mail: {
            feedback: {
                error: {
                    empty_email: "Empty email",
                    not_email: "Please enter a valid email address",
                },
            },
            fields: {
                email: {
                    label: "Contact email",
                    placeholder: "john.doe@contact-mailbox.com",
                },
                firstName: {
                    label: "First name",
                },
                lastName: {
                    label: "Last name",
                },
            },
            save: "Update",
        },
        payment_settings: {
            validate_billing_information: "Validate billing information",
            billing_information_title: "Billing information",
            individual: "Individual",
            enterprise: "Enterprise",
            fields: {
                address: {
                    label: "Address*",
                    placeholder: "123 street",
                },
                bank_iban: {
                    label: "IBAN*",
                },
                card_cvc: {
                    label: "CVC",
                },
                card_expirity: {
                    label: "Expiry",
                },
                card_number: {
                    label: "Card number",
                },
                city: {
                    label: "City*",
                    placeholder: "Montpellier",
                },
                country: {
                    label: "Country*",
                    placeholder: "Select your country",
                },
                last_name: {
                    label: "Full Name or Company Name*",
                    placeholder: "Pitt",
                },
                tax_number: {
                    errorMessage: "Your VAT id number is invalid.",
                    label: "VAT number (optional)",
                    placeholder: "xxxxxxxx",
                },
                zip_code: {
                    invalid: "ZIP code is invalid for this country.",
                    label: "ZIP code*",
                    placeholder: "34000",
                },
            },
            final_step: "Final step, to make it happen 🤓",
            go_back: "Go back",
            payment_method: {
                bank_transfer: "SEPA Direct Debit",
                credit_card: "Credit Card",
                credit_card_fee: "+{{fee}} fees",
            },
            payment_method_title: "Payment method",
            toasts: {
                get_initial_value_error: "Unable to retrieve your billing informations",
            },
        },
        prospect_list: {
            name: {
                feedback: {
                    error: {
                        empty_name: "Please enter a name for your list",
                        name_taken: "This list name already exists",
                    },
                },
            },
        },
    },
    free: "Free",
    free_trial: {
        will_end_in: "Your free trial will end in {{count}} day{{plural}}",
        will_end_today: "Your free trial will end today",
    },
    free_trial_ad: {
        button_label: "Try for free for {{daysOfFreeTrial}}d",
        small_button_tooltip: "Try for free during {{daysOfFreeTrial}} days",
        text: "Try for free during {{daysOfFreeTrial}} days",
        title: "Free trial",
    },
    free_trial_black_friday_ad: {
        active_trial: {
            description:
                "You're currently trialing the {{planName}} plan. No billing before this date. Then <strong>-50% extra</strong> on the yearly plan if you stay subscribed.",
        },
        churned_trial: {
            cta_label: "Reactivate my trial",
            description: "You're currently trialing the {{planName}} plan.\nReactivate before 11/28 to keep your perks with -50% on the yearly plan",
            title: "Trial canceled — {{daysOfFreeTrial}}",
        },
        inactive_trial: {
            cta_label: "Start free trial",
            description: "Enjoy Waalaxy for {{price}} until 11/28 — and get our exclusive offer when it ends",
            title: "Free until Black Friday",
        },
    },
    free_trial_page_black_friday: {
        left_panel: {
            plan_cards: {
                advanced: {
                    feature_1: "<strong>100</strong> invitations per day",
                    feature_2: "Profiles Auto-import",
                    feature_3: "CRM Synchronisation",
                    subtitle: "All LinkedIn features and full quotas to sell your product or service",
                },
                business: {
                    badge_text: "Best value",
                    feature_1: "<strong>100</strong> invitations per day",
                    feature_2: "Cold Emailing Automation",
                    feature_3: "500 Email Finder Credits",
                    subtitle: "LinkedIn and Cold Emailing features for an all-around solution to maximise responses",
                },
                days_of_free_trial: "{{trialNumberOfDays}} days free trial",
                monthly_price: "then {{monthlyPrice}}/mo",
            },
            steps_explanation: {
                step_1: {
                    subtitle: "You successfully downloaded Waalaxy",
                    title: "Install the extension",
                },
                step_2: {
                    subtitle: "Get full access to features, launch your first campaign and contact 200+ prospects per week",
                    title: "Today : Get instant {{planName}} Plan access and start prospecting",
                },
                step_3: {
                    subtitle: "You'll receive an email reminder about your trial expiring in 3 days",
                    title: "November 25th: Trial reminder",
                },
                step_4: {
                    subtitle: "Your yearly subscription starts and you’ll get -50% off. Cancel anytime in 2 clicks.",
                    title: "November 28th: Trial ends",
                },
            },
            subtitle: "Pre save your -50% Black Friday discount on all yearly plans",
            title: "Waalaxy is free until Black Friday",
        },
        payment_information_form: {
            extra_reduction: "(-50% extra)",
            start_trial_button_label: "Start my free trial 🎁",
            total_due_on_black_friday_day: "Total due on November 28th",
        },
    },
    free_trial_page_v2: {
        exit_confirmation_modal: {
            go_back_button_label: "No, I want my free trial",
            plan_cards: {
                pro: {
                    feature_1: "11 daily invitations",
                    feature_2: "300 monthly invitations max",
                    feature_3: "LinkedIn campaigns only",
                    feature_4: "Auto-import LinkedIn profiles",
                    feature_5: "Synchronise your data with your CRM",
                    feature_6: "Runs automatically / computer off",
                    title: "Pro Plan",
                },
                advanced: {
                    feature_1: "100 daily invitations quotas",
                    feature_2: "LinkedIn campaigns only  ",
                    feature_3: "Auto-import LinkedIn profiles",
                    feature_4: "Synchronise your data with your CRM",
                    feature_5: "Runs automatically / computer off",
                    title: "Advanced Plan",
                },
                business: {
                    feature_1: "100 daily invitations quota",
                    feature_2: "LinkedIn + Email campaigns",
                    feature_3: "Auto-import LinkedIn profiles",
                    feature_4: "Synchronise your data with your CRM",
                    feature_5: "Runs automatically / computer off",
                    feature_6: "LinkedIn + Email campaigns",
                    title: "Business Plan",
                },
                freemium: {
                    feature_1: "3 daily invitations quota",
                    feature_2: "LinkedIn only campaigns",
                    feature_3: "Manual import only",
                    feature_4: "Manual data export only",
                    feature_5: "LinkedIn tab must stay open",
                    feature_6: "LinkedIn campaigns only",
                    title: "Freemium Plan",
                },
                title: "By refusing your free trial, you'll be limited:",
            },
            stay_limited_button_label: "Keep the freemium plan",
            subtitle: "Trying out Waalaxy without all the features is like landing on Mars without oxygen",
            title: "Are you sure you want to skip free trial?",
        },
        left_panel: {
            steps_explanation: {
                step_1: {
                    subtitle: "You successfully downloaded Waalaxy",
                    title: "Install the extension",
                },
                step_2: {
                    subtitle: "Get all features, launch your first campaign and contact 200+ prospects per week",
                    title: "Today : Get instant {{plan}} access and start prospecting",
                },
                step_3: {
                    subtitle: "You will receive a reminder by email about your trial expiring in 3 days.",
                    title: "Day {{day}} : Trial reminder",
                },
                step_4: {
                    subtitle: "Your subscription starts and you’ll be charged. Cancel anytime in 2 clicks.",
                    title: "Day {{day}} : Trial ends",
                },
                title: "How does free trial work?",
            },
        },
        payment_information_form: {
            cgu_checkbox: "By going further you accept <customLink>Waalaxy's CGU</customLink>",
            exit_button_label: "Maybe later",
            title: "Your {{plan}} free trial",
            total: "Total due today",
        },
        social_proof: {
            chrome_store_reviews_link: "https://chromewebstore.google.com/detail/waalaxy-linkedin-automati/hlkiignknimkfafapmgpbnbnmkajgljh/reviews",
            provider_rating: "<strong>{{rating}}</strong> on {{providerName}}",
            title: {
                part_1: "Our",
                part_2: "users love using Waalaxy",
            },
            trustpilot_reviews_link: "https://www.trustpilot.com/review/waalaxy.com",
        },
    },
    free_trial_page_v3: {
        left_panel: {
            periodicity_card: {
                common: {
                    billed: "Billed",
                    days_of_free_trial: "{{daysOfFreeTrial}} days free trial",
                    monthly_price: "{{price}}/mo",
                    yearly_price: "{{price}}/year",
                },
                monthly: {
                    caption: "No commitment, total flexibility",
                },
                yearly: {
                    caption: "Get 6 months free by paying upfront",
                    tag_label: "Save 50%",
                    tag_label_20: "Save 20%",
                },
            },
            perks: {
                advanced: {
                    perk_1: "LinkedIn Campaigns",
                    perk_2: "+800 invitations and LinkedIn messages per month",
                    perk_3: "Access to all features (Auto-import, CRM...)",
                },
                business: {
                    perk_1: "LinkedIn Campaigns",
                    perk_2: "+800 invitations and LinkedIn messages per month",
                    perk_3: "Access to all features (Auto-import, CRM...)",
                },
                title: "You'll get",
            },
            title: "See if it's a fit. Try Waalaxy {{planName}} for {{price}}",
        },
        payment_information_form: {
            days_free: "({{daysOfFreeTrial}} days free)",
            next_payment_information:
                "Your free trial ends {{endOfTrialDate}}, then you will pay {{chosenPlanPrice}} incl. VAT {{periodicity}} on the same date. <strong>Change or cancel your plan anytime.</strong>",
            start_trial_button_label: "Start my {{daysOfFreeTrial}} days free trial",
            total_due_after_trial: "Total due incl. VAT after trial",
        },
    },
    frozen: "frozen",
    gifs: {
        add: "Add a GIF",
        search: "Search for GIFs",
        temporarily_unavailable: "Temporarily unavailable",
    },
    go_advanced: "Go Advanced",
    go_business: "Go Business",
    go_pro: "Go Pro",
    goal: "Goal",
    good_to_know: "Good to know:",
    got_it: "Got it!",
    header: {
        credits: {
            credits: "credit{{plural}}",
            find_emails_cta: "Find professional emails",
            remaining_credits: "remaining credit{{plural}}",
            reset_date: "{{totalCredits}} credits renewing on {{resetDate}}",
            reset_date_with_hours: "{{totalCredits}} credits renewing on <br />{{resetDateDay}} at {{resetDateHours}}",
            subtitle: "1 credit = 1 email found",
            title: "Email Finder Credits",
        },
        dropdown: {
            disabled: "back-office.header.dropdown.disabled",
        },
        team_members: {
            add_seats: "Add seats",
            invite_members: "Invite members",
            subtitle: "{{plan}} Plan • {{usedSeats}} / {{totalSeats}} member{{plural}}",
            title: "My team",
            plan_label: "{{plan}} Plan",
            seats_info: "{{usedSeats}} / {{totalSeats}} member{{plural}}",
        },
    },
    hour: "hour",
    hubspot: {
        new_tuto_display_data: {
            page1: {
                content: "We've improved integration to make it simpler and more intuitive.<br />\nDiscover the new features now.",
                media: "https://i.postimg.cc/W1sFGLHc/f25efe5fe0c9a88a0a258db0648f8ca3-fx-Yl-COa7-Ln-SU.png",
                title: "Hubspot integration gets a makeover!",
            },
            page2: {
                content:
                    "Automatically send your prospects to HubSpot according to your preferences: invitation accepted, response or campaign entry - the choice is yours!",
                media: "dQipKMO1cdU",
                title: "Say goodbye to the CRM sync stage in your campaigns!",
            },
            page3: {
                content: "From a list or campaign, select your prospects and export them directly to HubSpot with a single click.",
                media: "A8aOEGvIHVk",
                title: "You can also send your leads manually!",
            },
            page4: {
                content: "Easily link Waalaxy information to columns in your HubSpot database to better organize your leads.",
                media: "LdBd4_tfLpc",
                title: "Customize the data sent to Hubspot",
            },
            page5: {
                content: "Your prospects Waalaxy history is now visible in their contact details, in the “Activities” tab.",
                media: "f1Ub_ASuCoo",
                title: "Track your prospects activity directly on Hubspot!",
            },
        },
    },
    image: {
        add: "Add an image",
    },
    import: {
        add_to_campaign: "Add this import to a campaign",
        already_importing: "You can start a new import as soon as the current one is finished.",
        back_button: "Back",
        member_label: "Import on a team member's account",
        campaign: {
            add_error: "Error while adding import to the campaign",
            added: "Import added to ‘{{campaignName}}’ campaign",
            added_to_new: "Import ajouté à la campagne",
            campaign_placeholder: "Select a campaign",
            existing: "Existing Campaign",
            must_select: "Please select a campaign",
            new: "New campaign",
            no_campaign: "No Campaign",
            undo: "Undo",
            undo_error: "Unlink failed",
            undo_modal_content: "This import will not be added to the campaign",
            undo_modal_title: "Unlink this import from ‘{{campaignName}}’ ?",
            undo_success: "Unlinked with success",
        },
        csv: {
            import: "Import CSV",
            fields: {
                company_domain: "Company domain",
                company_name: "Company name",
                email: "Email",
                first_name: "First name",
                headline: "Headline",
                job_title: "Job Title",
                last_name: "Last name",
                linkedin_url: "LinkedIn Url",
                phone_number: "Phone number",
                region: "Region",
            },
            finalize_import: {
                description: "Matching complete! Configure the import options and then start the import.",
                title: "Finalize your import of",
            },
            mapping: {
                add_custom_property: "Add a custom property",
                choose_property: "Choose a property",
                csv_property: "Properties from CSV",
                custom_property_already_exists: "A property with this name already exists",
                custom_property_placeholder: "Property name",
                custom_property_required: "Please name this property",
                custom_variable_over_limit_warning_sg: "The property for 1 prospect contains more than 1000 characters, it wont be imported.",
                custom_variable_over_limit_warning_pl: "Properties for {{count}} prospect contain more than 1000 characters; they wont be imported.",
                description: "LinkedIn URLs are automatically detected and imported - no mapping needed.",
                help_link: "Understanding how Waalaxy structures my data",
                help_link_url: "https://blog.waalaxy.com/import-csv-waalaxy",
                preview: "Preview Information",
                property_already_used: "Property is already mapped to",
                prospects_detected: "prospects detected ",
                title: "Match your data",
                waalaxy_property: "Waalaxy property",
            },
            modal: {
                drag_and_drop: {
                    errors: {
                        no_data: "No data",
                        no_urls: "No urls detected",
                        too_many_urls: "Too many urls detected ({{numberUrl}} urls)",
                        wrong_file_format: "Only files in .csv format are accepted.",
                    },
                },
            },
            steps: {
                finalize_import: "Finalize import",
                mapping: "Match data",
                upload: "Upload",
            },
            toasts: {
                missing_file: "Please select a file",
                select_a_list: "Please select a prospect list",
                wrong_file_type: "Please select a CSV file",
            },
            upload: {
                prospect_list_label: "Import list",
                subtitle: "Make sure all prospects have LinkedIn URLs in the file.",
                title: "Import a CSV file",
            },
        },
        comments: {
            title: "Import prospects who have commented on a post",
        },
        events: {
            error_fetching_events: "Failed to fetch your events",
            label_number_prospects_import: "Number of prospects to import",
            placeholder_select: "Select an event",
            subtitle: "Select a LinkedIn event to import",
            title: "From my LinkedIn events",
            toasts: {
                select_a_list: "Please select a prospect list",
                select_an_event: "Please select an event",
            },
            tooltips: {
                disabled_button: "You must select an event and import less than {{count}} prospects",
                number_prospects_import: "You will not be able to import more than {{count}} prospects",
            },
        },
        regular_cloud: {
            cloud_connect_tooltip: "Connect your LinkedIn account in Cloud settings to use this import",
            import: "Import",
            import_locked: "An import is already in progress. Please wait for it to finish.",
            invalid_url: "Enter a valid LinkedIn people search URL",
            quantity_label: "Number of prospects to import",
            quantity_tooltip: "You can import up to {{count}} prospects",
            title: "Import via LinkedIn Search",
            url_label: "LinkedIn search URL",
            url_placeholder: "https://www.linkedin.com/search/results/people/?keywords=...",
            url_tooltip: "Paste the URL of your LinkedIn people search results page",
            import_failed: "The cloud import failed. Please try again.",
            tooltip_video_url: "https://my-public-bucket-prod.s3.eu-west-1.amazonaws.com/linkedin-search-2-updated-1782134782311.mp4",
        },
        first_relation_cloud: {
            import: "Import",
            quantity_label: "Number of prospects to import",
            quantity_tooltip: "You can import up to {{count}} prospects",
            title: "Import my LinkedIn network",
        },
        profile_cloud: {
            import: "Import",
            invalid_url: "Enter a valid LinkedIn profile URL",
            title: "Import from a LinkedIn profile",
            url_label: "LinkedIn profile URL",
            url_placeholder: "https://www.linkedin.com/in/...",
            url_tooltip: "Paste the URL of the LinkedIn profile you want to import",
        },
        post_comment_cloud: {
            import: "Import",
            url_required: "Enter a LinkedIn post URL",
            quantity_label: "Number of prospects to import",
            quantity_tooltip: "You can import up to {{count}} prospects",
            title: "Import post commenters",
            url_label: "LinkedIn post URL",
            url_placeholder: "https://www.linkedin.com/posts/...",
            url_tooltip: "Paste the URL of the LinkedIn post whose commenters you want to import",
        },
        post_reaction_cloud: {
            import: "Import",
            url_required: "Enter a LinkedIn post URL",
            quantity_label: "Number of prospects to import",
            quantity_tooltip: "You can import up to {{count}} prospects",
            title: "Import post reactors",
            url_label: "LinkedIn post URL",
            url_placeholder: "https://www.linkedin.com/posts/...",
            url_tooltip: "Paste the URL of the LinkedIn post whose reactors you want to import",
        },
        post_repost_cloud: {
            import: "Import",
            url_required: "Enter a LinkedIn post URL",
            quantity_label: "Number of prospects to import",
            quantity_tooltip: "You can import up to {{count}} prospects",
            title: "Import post republishers",
            url_label: "LinkedIn post URL",
            url_placeholder: "https://www.linkedin.com/posts/...",
            url_tooltip: "Paste the URL of the LinkedIn post whose republishers you want to import",
        },
        groups: {
            error_fetching_groups: "Could not fetch your LinkedIn groups",
            label_number_prospects_import: "Number of prospects to import",
            placeholder_select: "Select a group",
            subtitle: "Select a LinkedIn group to import",
            title: "From my LinkedIn groups",
            toasts: {
                select_a_group: "Please select a group",
            },
            tooltips: {
                disabled_button: "You must select a group and import less than {{count}} prospects",
                number_prospects_import: "You will not be able to import more than {{count}} prospects",
            },
        },
        import_button: "Import",
        import_finished_text: "You have successfully imported {{prospectCount}} prospects into <lnk>{{prospectList}}</lnk>",
        learn_more: "Learn more about prospects import",
        post: {
            bad_link: "This LinkedIn post link is not valid",
            cant_import: "Couldn't import this post",
            no_comments: "This post has no comment",
            no_reactions: "This post has no reaction",
            no_reposts: "This post has no repost",
            paste_post_url: "Paste the LinkedIn post URL",
            post_link_placeholder: "https://www.linkedin.com/posts/...",
            post_url_tooltip_video_url: "https://my-public-bucket-prod.s3.eu-west-1.amazonaws.com/injections_v4_post_url.mp4",
            quantity_label: "Number of prospects to import",
            toasts: {
                import_failed: "Couldn't start the import. Please try again.",
                no_url: "Please paste the LinkedIn post URL",
                select_a_list: "Please select a prospect list",
            },
        },
        reactions: {
            title: "Import prospects who have reacted to a post",
        },
        reposts: {
            title: "Import prospects who have reposted a post",
        },
        next_button: "Next",
        progress_bar_label: "<strong>{{value}}% completed</strong>",
        progress_summary_V2:
            "<strong>{{scanned}}</strong> scanned, <strong>{{success}}</strong> success, <strong>{{duplicates}}</strong> duplicates, <strong>{{cleaned}}</strong> false positives",
        progress_summary_V3: "Details : {{success}} success, {{duplicates}} duplicates, {{cleaned}} false positives",
        dnc_duplicates_summary: "<strong>{{count}}</strong> prospect(s) already in your Do Not Contact list",
        progress_title_V3: "Importing {{total}} prospects into",
        sales_leads: {
            error_fetching_sales_leads: "Failed to load sales leads lists. Please make sure you have a Sales Navigator tab open",
            import: "Import",
            label_number_prospects_import: "Number of prospects to import",
            placeholder_select: "Select a leads list",
            subtitle: "Leads list to import",
            title: "From a Sales Navigator list",
            toasts: {
                select_a_lead_list: "Please select a Sales Navigator leads list",
                select_a_list: "Please select a prospect list",
            },
            tooltips: {
                number_prospects_import: "You will not be able to import more than {{count}} prospects",
            },
        },
        sales_search_cloud: {
            saved_search_url: "This link is a saved search. Use “Import from a saved search” instead.",
            title: "Import via Sales Navigator search",
            tooltip_video_url: "https://my-public-bucket-prod.s3.eu-west-1.amazonaws.com/sales-navigator-search-EN-1782129929428.mp4",
        },
        sales_searches: {
            error_fetching_sales_searches: "Failed to fetch your sales searches",
            import: "Import",
            label_number_prospects_import: "Number of prospects to import",
            placeholder_select: "Select a search",
            subtitle: "Import from a saved sales search",
            title: "From a saved search in Sales Navigator",
            toasts: {
                select_a_list: "Please select a prospect list",
                select_a_search: "Please select a saved search",
            },
            tooltips: {
                number_prospects_import: "You can import a maximum of {{count}} prospects",
            },
        },
        status: "State",
        stop_import: "Stop Import",
        cancelling_import: "Cancelling import…",
    },
    important: "Important :",
    infiniteloginModal: {
        accordion1: {
            text1: "<strong>Step 1</strong>: Go to Linkedin, click on your profile picture in the top right corner",
            text2: "<strong>Step 2</strong>: From the dropdown, open Settings & Privacy",
            text3: "<strong>Step 3</strong>: Choose Sign in & security and click two-step verification",
            text4: "<strong>Step 4</strong>: Click Set up, choose Authenticator app as your preferred verification method from the dropdown menu, and click Continue to enable two-step verification",
            text5: "<strong>Step 5</strong>: Copy your 2FA secret key and make sure to save it in a place only you can access",
            title: "I don’t have 2FA enabled on LinkedIn (4min)",
        },
        accordion2: {
            link: "https://intercom.help/waalaxy/en/articles/12830900-linkedin-connection-infinite-login",
            text1: "To be able to use Infinite login :",
            text2: "- You'll have to use app-based authentication code, and not via phone (SMS)",
            text3: "- You'll need to have your 2FA secret key available (it’s a unique code you get from LinkedIn once you enable your 2FA, keep in mind that you can't access it again)",
            text4: "Didn't use Authenticator app or lost your 2FA secret key ? You'll need to disable 2FA and turn it back on to get a new key. Here's an <a>easy-to-follow guide</a>.",
            title: "I already have 2FA enabled on LinkedIn",
        },
        intercom_help: "I need help logging in with Infinite Login.",
        modal: {
            confirmCta: "Yes, 2FA is enabled and I have my 2FA secret key",
            description:
                "Using Infinite login protects your Linkedin account from getting disconnected and pausing your campaigns. To be able to use it, you'll need to enable Linkedin Two-Factor Authentication (2FA).",
            title: "Do you already have 2FA enabled on LinkedIn ?",
        },
        need_help: {
            link: "https://intercom.help/waalaxy/en/articles/12830900-linkedin-connection-infinite-login",
            text: "Need help ? Check the <a>step-by-step guide</a> or reach out to our <support>customer support team</support>",
        },
    },
    insert: "Insert",
    insert_variable: "Insert a variable",
    variable_picker: {
        custom_variables_section: "Custom variables",
    },
    launch: "Launch",
    left_F: "left",
    left_M: "left",
    limits: {
        campaign: {
            content_import:
                "These prospects will be frozen until others have completed the campaign and then automatically added. \nYou can upgrade or create a new campaign to import your prospects.",
            content_max:
                "On our {{plan}} plan, you can have a maximum of {{max}} prospects in a campaign. \nUpgrade to add more prospects in your campaigns.",
            subtitle_import: "Some prospects couldn’t be added to your campaign",
            subtitle_max: "Maximum of {{max}} prospects per campaign",
            title: "You’ve reached the limit of prospects in the campaign {{name}}",
        },
        campaign_max: {
            content_import:
                "These prospects will be frozen until others have completed the campaign and then automatically added. \nYou can upgrade or create a new campaign to import your prospects.",
            content_max:
                "On our {{plan}} plan, you can have a maximum of {{max}} prospects in a campaign. \nUpgrade to add more prospects in your campaigns.",
            subtitle_import: "Some prospects couldn’t be added to your campaign",
            subtitle_max: "Maximum of {{max}} prospects per campaign",
            title: "You’ve reached the limit of prospects in the campaign {{name}}",
        },
        prospectList: {
            content_import: "You can upgrade or create a new list to import your prospects.",
            content_max:
                "On our {{plan}} plan, you can have a maximum of {{max}} prospects in a list. \nUpgrade to import more prospects in your lists.",
            move: {
                content_import: "You can upgrade or create a new list to move your prospects.",
                subtitle_import: "{{total}} prospect(s) couldn’t be moved.",
            },
            subtitle_import: "{{total}} prospect(s) couldn’t be imported.",
            subtitle_max: "Maximum of {{max}} prospects per list",
            title: "You’ve reached the limit of prospects in the list {{name}}",
            title_with_count: "You’ve reached the limit of {{limit}} prospects in the list {{name}}",
        },
        prospectList_max: {
            content_import: "You can upgrade or create a new list to import your prospects.",
            content_max:
                "On our {{plan}} plan, you can have a maximum of {{max}} prospects in a list. \nUpgrade to import more prospects in your lists.",
            move: {
                content_import: "You can upgrade or create a new list to move your prospects.",
                subtitle_import: "{{total}} prospect(s) couldn’t be moved.",
            },
            subtitle_import: "{{total}} prospect(s) couldn’t be imported.",
            subtitle_max: "Maximum of {{max}} prospects per list",
            title: "You’ve reached the limit of prospects in the list {{name}}",
        },
        total: {
            content_import: "You can still access to all your lists and functionalities.\nUpgrade to import more prospects!",
            content_max: "On our {{plan}} plan, you can have a maximum of {{max}} prospects in your app.\nUpgrade to import more prospects!",
            subtitle_import: "{{total}} prospect(s) couldn’t be imported.",
            subtitle_max: "Maximum of {{max}} prospects in the {{plan}} plan.",
            title: "You’ve reached the total limit of prospects to import!",
        },
        total_max: {
            content_import: "You can still access to all the functionalities.",
            content_max: "Unfortunetly, you can have a maximum of {{max}} prospects in your app.",
            subtitle_import: "{{total}} prospect(s) couldn’t be imported.",
            subtitle_max: "Maximum of {{max}} prospects in the app",
            title: "You’ve reached the total limit of prospects to\nimport! 😢",
        },
        total_banner: {
            text: "You\u2019ve reached your limit of {{max}} prospects. New imports (including auto-imports) will be blocked until you free up space.",
            upgrade: "Upgrade to increase your limit.",
        },
    },
    linkedin: "LinkedIn",
    linkedin_weekly_quota: "LinkedIn weekly quota reached",
    list: "List",
    loading: "Loading",
    login_to_linkedin: {
        CTA: "Log into LinkedIn",
        action: "You need to log into LinkedIn to access Waalaxy.",
        info: "You are not logged into your LinkedIn account",
    },
    mail: "Email",
    mails: "Emails",
    manual_import: "Manual import",
    message: "Message",
    message_request: "Message request",
    messages: "Messages",
    minute: "minute",
    modal: {
        black_friday_free_trial: {
            button: "Explore features",
            text: "Unlimited quotas, multi-channel with email search, 500 credits, auto-import of prospects, and all advanced campaigns!",
            title: "You’ve activated a Free {{planName}} Trial until {{expirationDate}}",
        },
    },
    modal_retry_confirm_payment_method: {
        amount: "Amount: {{amount}}",
        confirmation_failure: "The payment method confirmation failed. Try to confirm it again or cancel the transaction.",
        cta: "Complete the payment",
        subtitle: "You have left the payment veritification. To continue, finalize the 3DS authentication.",
        title: "Action required to complete payment",
    },
    move_duplicates_to_other_list: "Move duplicates to import list",
    move_prospect: "Move",
    name: "Name",
    new: "New",
    new_actions: "{{count}} new action(s) added. Refresh to see the changes",
    next: "Next",
    no: "no",
    no_data: "No data",
    no_events_found: "In order to import from an event, please be part of an event first",
    no_groups_found: "In order to import from a group, please be part of a group first",
    notes: {
        add_new_note: "Add a note",
        asking_for_delete: "Delete this note ?",
        editing_in_progress: "Editing in progress",
        irreversible_action: "This action is irreversible.",
        note_title_tab: "Notes",
        placeholder: "Write a short note",
        prospection_with_notes: "Never lose track of your prospecting again with notes",
        writing_first_note: "Write your first note in 30 seconds!",
        you: "You",
    },
    notifications: {
        accept: "Accept",
        campaigns_invitations_frozen: {
            see_campaigns: "See my campaigns",
            text: "⚠️ Your LinkedIn Premium subscription has expired: <strong>your campaigns containing invitation notes have been paused.</strong>",
        },
        cancelPlan: "Your current plan is going to be cancelled and refunded as credits",
        chooseRefound: "Choose where you want to be credited",
        company_not_owner_invitation: {
            title: "Join {{new_team_name}} ?",
            subtitle: "You are already a member of team {{team_name}}.",
            description: "To join this new team, you must leave your current team.",
            cancel: "Stay in my team",
            join: "Join the team",
        },
        company_join_owner_invitation: {
            title: "Transfer ownership to leave your team",
            subtitle: "You are the owner of {{team_name}}",
            description: "Transfer ownership to a member of your team before you can join {{new_team_name}}.",
            cancel: "Close",
            transfer: "Transfer ownership",
        },
        company_invitation: {
            accept: "Accept",
            decline: "Decline",
            text: "<strong>{{ inviter }}</strong> invite you to join the team <strong>‘{{ company }}’</strong>",
            text_accepted: "✅ You are now a member of the team <strong>‘{{ company }}’</strong>",
            text_declined: "❌ You have declined the invitation to join the team <strong>‘{{ company }}’</strong>",
        },
        company_invitation_accepted:
            "✅ <strong>{{ displayName }} has accepted</strong> your invitation to join the team <strong>‘{{ company }}’</strong>",
        company_invitation_refused: {
            cta: "Invite another member",
            text: "❌ <strong>{{ displayName }} has declined</strong> your invitation to join the team <strong>‘{{ company }}’</strong>",
        },
        company_owner_invitation: {
            cancel: "Decline",
            cta: "Accept",
            text_accepted: "✅ You are now the owner of the team '<strong>{{ company }}</strong>'",
            text_cancel:
                "❌ <strong>{{ displayName }} has canceled</strong> the invitation to make you the new owner of '<strong>{{ company }}</strong>'",
            text_declined: "❌ You have declined the invitation to become the captain of the '<strong>{{  company }}</strong>' team.",
            text_pending: "<strong>{{ displayName }}</strong> wants to make you the new owner of the team '<strong>{{ company }}</strong>'",
        },
        company_owner_invitation_decision: {
            cta: "Choose a new owner",
            text_accepted:
                "✅ <strong>{{ displayName }} has accepted</strong> your invitation to be the new owner of the team '<strong>{{ company }}</strong>'",
            text_accepted_leave:
                "<strong>{{ displayName }}</strong> has accepted your invitation to become the new owner of team '<strong>{{ company }}</strong>', so we have proceed to your request to leave the team.",
            text_declined:
                "❌ <strong>{{ displayName }} has declined</strong> the invitation to become the captain of the '<strong>{{ company }}</strong>' team.",
        },
        credits: "Credits",
        credits_available: {
            cta: "Launch an Email Finder campaign",
            description:
                "You have <strong>{{newCreditAvailable}} credits</strong> available to find your prospects' pro emails, remember to use them 👑",
        },
        decline: "Decline",
        empty_list: {
            subtitle: "Notifications will appear here when there’s activity.",
            title: "All clear for now!",
        },
        failed_to_accept_invitation: "Unable to accept the invitation",
        gotIt: "Got it",
        impersonating_tooltip: "You are currently impersonating {{firstName}} {{lastName}}, thus you can’t access their notifications.",
        linkedin_connect_quota_full: {
            cta: "Launch an emailing campaign",
            description:
                "You <strong>don’t have anymore LinkedIn</strong> invitations quotas. Find your prospects' pro emails and contact them by email! ✉️",
        },
        linkedin_connect_quota_not_full: {
            cta: "Launch an invitation campaign",
            dynamicDescription:
                "You didn't use all your LinkedIn invitation quotas last week. Remember to send your <strong>{{invitationsCount}} invitations</strong> this week 🚀",
        },
        no_connect_action_in_queue: {
            cta: "Launch an invitation campaign",
            description:
                "You don’t have any more <strong>LinkedIn invitations</strong>  in the queue! Start a new campaign or add prospects to an existing one 🚀",
        },
        no_more_credit: {
            cta: "Buy more credits",
            description:
                "⚠️ You have <strong>reached your credits quotas.</strong> Recharge your credits to continue prospecting without interruption!",
        },
        quotas_upsell: {
            advanced: "Upgrade to Advanced",
            pro: "Upgrade to Pro",
            text_advanced:
                "You have <strong>reached your daily invitation quotas.</strong> Upgrade to Advanced plan to continue prospecting without interruption! 👑",
            text_pro:
                "You have <strong>reached your daily invitation quotas.</strong> Upgrade to Pro plan to continue prospecting without interruption! 👑",
        },
        refoundTitle: "You are about to join <strong>{{company}}</strong>'s team",
        renew_failed: {
            cta: "Manage Payment",
            description: "❌ <strong>Your renewal payment failed.</strong> Regularize your payment to keep enjoying Waalaxy!",
        },
        teamBalance: "Team balance",
        title: "Notifications",
        traveler_reply_threshold_reached: {
            cta: "Open my Inbox",
            description: "You have received <strong>{{travelerRepliedCount}} replies</strong> to your messages, check them in your Inbox 📩",
        },
        userBalance: "My own balance",
        yourPlan: "Your current plan",
    },
    email_disconnected_modal: {
        description_no_campaigns: "Reconnect your account to resume email sending.",
        description_with_date: "Your email campaigns have been paused since {{disconnectedAt}}. Reconnect your account to resume them.",
        dismiss: "Later",
        reconnect: "Reconnect",
        reconnect_form: {
            description_no_date: "Enter the mailbox's current password to resume your email campaigns.",
            description_with_date:
                "Your email campaigns have been paused since {{disconnectedAt}}. Enter the mailbox's current password to resume them.",
            error_imap_unreachable: "Couldn't reach the IMAP server. Check the host and port.",
            error_password_refused: "The mail server refused this password.",
            error_smtp_unreachable: "Couldn't reach the SMTP server. Check the host and port.",
            error_unknown: "We couldn't reconnect this mailbox. Try again in a moment.",
            slow_check: "Still checking — some mail servers are slow to answer.",
            success: "{{emailAddress}} is reconnected. Your campaigns resume.",
        },
        title: "Your account {{emailAddress}} is disconnected",
    },
    email_disconnected_warning: {
        description: "The email address {{emailAddress}} used in one or more campaigns is disconnected. Reconnect it to resume email sending.",
        description_multiple:
            "The email addresses {{emailAddresses}} used in one or more campaigns are disconnected. Reconnect them to resume email sending.",
        reconnect: "Reconnect",
        title: "Email sending interrupted",
    },
    oauth2_provider: {
        custom_signin: "Sign in with an other account",
        error: "Oops! An error has occurred",
        google: {
            email_already_connected: {
                button: "Understood",
                description: "You already use this account on Waalaxy. It cannot be modified here.",
                title: "Your Gmail account is already connected",
            },
            expired_account: {
                button_cancel: "Do nothing",
                button_confirm: "Go to parameters",
                description: "Reconnect it in your “Email accounts” settings to restart your email campaigns.",
                description_p: "Reconnect them in your “Email accounts” settings to restart your email campaigns.",
                title: "Your Gmail account has been disconnected",
                title_p: "Your Gmail accounts have been disconnected",
            },
            success: "Google account successfully added!",
        },
        hubspot: {
            success: "HubSpot account successfully added!",
        },
        new_mail_account_modal: {
            description: "You can connect another email account to continue cold emailing.",
            orOtherProviders: "or other providers",
            title: "Connect a new email address",
        },
        outlook: {
            admin_consent: {
                granted: {
                    description: "Your teammates are ready to connect their Outlook account to Waalaxy.",
                    title: "Waalaxy is approved!",
                },
                required: {
                    copy_link_button: "Copy the link for your admin",
                    copy_link_copied: "Link copied!",
                    description:
                        "Your Outlook account is managed by your organization. Send the link below to your admin so they can approve Waalaxy, then retry the connection.",
                    help_center_button: "Open the guide for your admin",
                    help_center_link: "https://intercom.help/waalaxy/en/articles/10199192-how-to-sync-outlook-with-your-waalaxy-account",
                    title: "Your admin needs to approve Waalaxy",
                },
            },
            success: "Outlook account successfully added!",
        },
        pipedrive: {
            success: "Pipedrive account successfully added!",
        },
        redirect: "You will be redirected to Waalaxy...",
        signin: "Sign in with {{provider}}",
    },
    oauth_linkedin: {
        redirected_after_authentication: {
            failed: {
                subText: "Please try again",
                text: "Oops, the connection didn't work",
            },
            succeeded: {
                subText: "You will be redirected to Waalaxy...",
                text: "LinkedIn account successfully connected!",
            },
        },
        signin_modal: {
            title: "LinkedIn Login",
        },
    },
    oauth_login: {
        page_title: "Sign in to Waalaxy",
        product_label: "Waalaxy MCP",
        heading: "<strong>{{clientName}}</strong> wants to connect to Waalaxy",
        unknown_client: "An application",
        email_placeholder: "you@company.com",
        authorize_button: "Authorize connection",
        sending_button: "Sending magic link…",
        no_password_hint: "We'll email you a one-time magic link to confirm the connection, no password required.",
        connected_as: "Signed in as <strong>{{email}}</strong>",
        permissions_title: "This will allow it to:",
        permissions: {
            read_prospects: "View your prospect lists and their content.",
            read_campaigns: "View your running and paused campaigns.",
            import_prospects: "Import new prospects into a list and enroll them in a campaign.",
        },
        generic_client_name: "the application",
        check_email_title: "Check your email",
        check_email_body: "We sent a magic link to <strong>{{email}}</strong>.<br/>Click it to authorize the connection.",
        check_email_close_hint: "You can close this tab — the link opens a new one.",
        forbidden_title: "Upgrade required",
        forbidden_body: "Connecting external applications via OAuth requires an <strong>Advanced</strong> or <strong>Business</strong> plan.",
        forbidden_cta: "See plans",
        errors: {
            missing_email: "Please enter your email.",
            forbidden: "An Advanced or Business plan is required to connect external applications.",
            no_account: "We couldn't find a Waalaxy account for this email.",
            network_error: "Network error. Check your connection and try again.",
            internal_error: "Something went wrong. Please try again.",
            invalid_request: "Invalid OAuth request",
            invalid_request_hint: "This page was opened with missing or incorrect parameters. Please retry the connection from your application.",
            link_invalid_token: "This sign-in link has expired or has already been used.",
            link_invalid_token_hint: "Please restart the connection from {{clientName}}.",
            link_error: "We couldn't complete the connection.",
            link_error_hint: "Restart it from {{clientName}} and open the email link in the same browser.",
        },
    },
    ok: "Ok",
    onboarding: {
        about_user_form: {
            discovery_source: {
                ads: "Advertisement",
                affiliation: "Affiliation",
                google_search: "Google search",
                linkedin: "LinkedIn",
                other: "Other",
                title: "How did you hear about Waalaxy? (required)",
                webinar: "Webinar",
                word_of_mouth: "Word of mouth",
                youtube: "Youtube",
            },
            objective: {
                find_emails: "Find emails",
                find_prospects_and_generate_leads: "Find prospects and generate leads",
                manage_client_accounts: "Manage clients' accounts",
                recruit_talents: "Recruit talents",
                title: "What is your primary objective with Waalaxy? (required)",
            },
            previous_tool_experience: {
                already_tested_waalaxy: "I already tested Waalaxy",
                already_using_another_tool: "I have already used another tool",
                first_time: "It is my first time",
                title: "Have you ever used a similar tool? (required)",
            },
            select: "-- Select --",
            title: "Tell us more about yourself",
            user_role: {
                ceo_founder: "CEO / Founder",
                consultant_freelancer: "Consultant / Freelancer",
                marketer: "Marketer / Growth",
                other: "Other",
                recruiter: "Recruiter",
                sales_sdr_bdr: "Sales / Business Developer",
                title: "What is your role? (required)",
            },
        },
        access_to_app: "Access the app",
        completed: {
            bravo: "Well done 🎉",
            dashboard_unlocked:
                "You have completed your first missions on Waalaxy!\nYou now have access to the dashboard to track your campaign's performance!",
            lets_go: "Let's go!",
            title: "Well done, {{ firstName }}! 🎉",
            subtitle: "Your campaign has been launched, and Waalaxy can begin its work.",
            description_1:
                "In the next few hours, your network will start to grow, and you may already start receiving responses from your prospects.",
            description_2: "To keep track of all this, you now have access to the <strong>Dashboard.</strong> ",
            description_3: "You can find your acceptance and response rates there to closely monitor your campaign's performance.",
            cta: "View my dashboard",
        },
        find_prospects: {
            job_title: {
                account_manager: "Account manager",
                advertising_layout_artist: "Advertising layout artist",
                advertising_manager: "Advertising manager",
                art_director: "Art director",
                business_analyst: "Business analyst",
                business_manager: "Business manager",
                buyer: "Buyer",
                communication_assistant: "Communication assistant",
                communication_officer: "Communication officer",
                community_manager: "Community manager",
                corporate_journalist: "Corporate journalist",
                creative_director: "Creative director",
                cybersecurity_engineer: "Cybersecurity engineer",
                data_scientist: "Data scientist",
                database_administrator: "Database administrator",
                database_manager: "Database manager",
                designer_editor: "Designer editor",
                developer: "Developer",
                digital_learning_manager: "Digital learning manager",
                direct_marketing_manager: "Direct marketing manager",
                director_of_communication: "Director of communication",
                export_assistant: "Export assistant",
                front_end_developer: "Front end developer",
                head_of_department: "Head of department",
                hotline_engineer: "Hotline engineer",
                industrial_computer_technician: "Industrial computer technician",
                information_system_architect: "Information system architect",
                it_network_engineer: "IT Network engineer ",
                it_project_manager: "IT Project manager",
                marketing_director: "Marketing director",
                marketing_research_manager: "Marketing research manager",
                media_planner: "Media planner",
                merchandising_manager: "Merchandising manager",
                microcomputer_salesperson: "Microcomputer salesperson",
                motion_designer: "Motion designer",
                network_engineer: "Network engineer",
                press_attache: "Press attache",
                product_manager: "Product manager",
                profit_center_manager: "Profit center manager",
                promotion_officer: "Promotion officer",
                referencing_technician: "Referencing technician",
                sales_agent: "Sales agent",
                sales_representative: "Sales representative",
                security_engineer: "Security engineer",
                seo_consultant: "SEO Consultant",
                store_manager: "Store manager",
                technical_sales_engineer: "Technical sales engineer",
                telecom_installer: "Telecom installer",
                telecommunications_technician: "Telecommunications technician",
                traffic_manager: "Traffic manager",
                ux_designer: "UX Designer",
                web_designer: "Web designer",
                webmaster: "Webmaster",
            },
        },
        missing_required_fields: "Please fill the required fields",
        onboarded_user_summary: {
            employees: "employees",
        },
        overview_title: "Steps for success",
        pre_required_actions: {
            subtitle: "Ready to explore? Connect with LinkedIn to activate your account and access all features",
            title: "Welcome to <coloredText>Waalaxy</coloredText> 👋",
        },
        progress_bar: {
            percentage: "{{value}}%",
            task_completed_on_all_tasks: "{{completedTasks}} task on {{totalTasks}} completed",
            task_completed_on_all_tasks_plurial: "{{completedTasks}} tasks on {{totalTasks}} completed",
        },
        required_actions: {
            authenticationOAuth: {
                cta: "Sign in",
                subtitle: "You need to be connected to LinkedIn to create your Waalaxy account.",
                title: "Sign in on LinkedIn",
            },
        },
        skip_onboarding_modal: {
            cancel_cta: "Picking up where I left off",
            submit_cta: "Yes, access the app",
            subtitle: "You'll lose your progress",
            text: "The automation campaign you are creating will not be saved. If you don't want to launch it now, you can draft it later.",
            title: "Leaving onboarding?",
        },
        start_quickly: {
            title: "Getting started on Waalaxy in 5 min 🚀",
            video_id: "TET-M03w468",
        },
        talk_to_us: {
            open_chat: "Open the chat",
            subtitle: "Need any help? Talk to us directly through chat. Click on the blue bubble at the bottom right.",
            title: "Talk to us",
        },
        tasks: {
            complete_lists: {
                advice: {
                    see_tutorial: "See tutorial",
                    tutorial_link: "https://www.youtube.com/watch?v=kv8xiUFoFfg",
                },
                button: "Import profiles",
                title: "Complete my lists",
            },
            contact_profiles: {
                button: "Start a campaign",
                hide_gif: "Hide GIF tutorial",
                show_gif: "See GIF tutorial",
                title: "Contact profiles",
            },
            link_to_linkedin: {
                title: "Install Waalaxy Chrome extension",
            },
            sync_with_linkedin: {
                advice: {
                    learn_more: "Learn more",
                },
                button: "Link my account",
                title: "Sync with LinkedIn",
            },
        },
        welcome_step: {
            description_v2: "Personalize your Waalaxy experience by answering a few questions",
            start: "Start",
            welcome_on_waalaxy_v3: "Welcome to <coloredText>Waalaxy</coloredText> 🚀",
        },
    },
    open_linkedin_prospect_page: "View on Linkedin",
    or: "or",
    other: "Other",
    overwrite_prospect_information: "Overwrite and replace existing prospect information",
    pages: {
        button: "Go back",
        cloudLogin: {
            welcome: {
                title: "Welcome to Waalaxy 👋",
                titleHighlight: "Waalaxy",
                subtitle:
                    "Reach 800+ qualified prospects on LinkedIn every month. Invitations, messages, emails and automated follow-ups. No technical skills required.",
                createAccount: "Create my account",
                signIn: "Sign in",
            },
            onboarding: {
                title: "Tell us more about you",
                next: "Next",
                back: "Back",
                missingFields: "Please answer all the required fields.",
            },
            credentials: {
                titleSignup: "Create my account with LinkedIn",
                titleLogin: "Sign in with LinkedIn",
                subtitle: "Enter your LinkedIn account credentials.",
                emailLabel: "LinkedIn email",
                emailPlaceholder: "you@company.com",
                passwordLabel: "LinkedIn password",
                submit: "Sign in",
                googleCta: "I use Google sign-in",
                back: "Back",
            },
            googleSso: {
                title: "Add a password from LinkedIn",
                subtitle: "Your LinkedIn account doesn't have a password yet. Set one in a few seconds.",
                step1: "Click <strong>Go to LinkedIn</strong> below.",
                step2: "Open <strong>Sign in & security</strong>.",
                step3: "<strong>Set a password</strong>, then come back here.",
                goToLinkedin: "Go to LinkedIn",
                backToLogin: "Back to sign in",
            },
            connecting: {
                title: "Connecting",
                subtitle: "We are establishing the connection with your account.",
                doNotClose: "Please wait, do not close this window.",
                stepCounter: "Step {{current}}/{{total}}",
                step1Title: "Authenticating your account",
                step1Desc: "Secure connection to LinkedIn.",
                step2Title: "LinkedIn security check",
                step2Desc: "This step can take up to 2 minutes.",
            },
            verify: {
                title: "Enter your code",
                subtitleEmail: "LinkedIn sent a 6-digit code by email to the address on your account.",
                subtitlePhone: "LinkedIn sent a 6-digit code by SMS to the phone number on your account.",
                subtitleAuthApp: "Enter the 6-digit code from your authenticator app.",
                resendQuestion: "Didn't get it?",
                resend: "Resend",
                verify: "Verify",
            },
            secondaryHandle: {
                title: "Choose how to receive your code",
                subtitle: "LinkedIn needs to verify your identity. Select one of the available methods.",
                emailOption: "Email — {{handle}}",
                phoneOption: "SMS — {{handle}}",
                submit: "Send me a code",
                waalaxy: {
                    title: "Choose where to receive the code",
                    subtitle: "LinkedIn will send a code to the method you select.",
                    emailOption: "Email to {{maskedValue}}",
                    phoneOption: "Text message to {{maskedValue}}",
                    confirm: "Send me a code",
                    sending: "Sending the code…",
                    sendingSubtitle: "LinkedIn is preparing the verification. This may take a few seconds.",
                    error: "The code could not be sent. Please try again.",
                },
            },
            twofa: {
                title: "Over to you",
                actionRequired: "Action required",
                instruction: 'In the LinkedIn app, tap "Yes, it\'s me".',
                instructionHighlight: `"Yes, it's me"`,
                noNotification: "No notification?",
                resend: "Resend the request",
                tryAnotherWay: "Try another way",
                switchingMethod: "Changing verification method…",
                switchingMethodSubtitle: "LinkedIn is preparing another verification method. This may take a few seconds.",
                switchMethodError: "The new verification method is taking too long. Please try again.",
                confirm: "I confirmed on my phone",
                checking: "Checking the connection…",
                checkingSubtitle: "One moment, we are confirming with LinkedIn.",
            },
            success: {
                titleSignup: "Here we go 🚀",
                subtitleSignup: "Your Waalaxy account is created and connected to LinkedIn. Your first prospects are waiting!",
                titleLogin: "Good to see you again 🎉",
                subtitleLogin: "Your LinkedIn account is reconnected. Your campaigns resume where you left off.",
                preparing: "Preparing your workspace…",
            },
        },
        campaign: {
            add_prospects: "Add prospects",
            archive_my_campaign: "Archive",
            duplicate_campaign: "Duplicate",
            duplicate_campaign_modal: {
                campaign_name: "Campaign name",
                cancel_button: "Cancel",
                cannot_open_campaign_tooltip: "You do not have permission to access your Team members' accounts. Contact your captain.",
                checkbox: "Open the campaign after duplication",
                copy_of: "Copy of",
                description: "The prospects are not copied. The campaign will be duplicated without prospects.",
                duplicate_button: "Duplicate the campaign",
                duplicate_to: "Duplicate to",
                name_already_exist: "This campaign name is already taken",
                not_premium:
                    "{{fullName}} does not have a LinkedIn Premium account. The invitation note will be duplicated in their templates but not added to the campaign.",
                open_campaign: "Open",
                subtitle: "Create a copy to reuse the same content and settings.",
                title: "Duplicate the campaign",
            },
            bulkbar: {
                add_tags: "Tag",
                back_in_campaign: {
                    modal: {
                        active_other_campaign_prospect: "{{prospectsNb}} are already active in another campaign",
                        active_prospect: "{{prospectsNb}} prospects are already active in this campaign",
                        branch_end_prospect: "{{prospectsNb}} prospects already finished this campaign",
                        buttons: {
                            cancel: "Cancel",
                            ok: "Okay!",
                            put_back: "Put back {{prospectsNb}} prospects",
                        },
                        deleted_prospects: "{{prospectsNb}} have their prospect deleted.",
                        total_invalid_prospects: "{{prospectsNb}} prospects couldn't be put back in the campaign.",
                    },
                },
                do_not_contact_prospects: "Do not contact",
                exit_prospects: "Exit prospects",
                export_prospects: "Export",
                export_prospects_csv: "Download CSV file",
                pause_finished_prospects_disabled: 'The status of the selected prospects is "Finished". Please select "Ongoing" prospects.',
                pause_prospects: "Pause prospects",
                pause_prospects_disabled: 'The status of selected prospects is “Paused”. Please select "Ongoing" prospects.',
                play_finished_prospects_disabled: 'The status of the selected prospects is "Finished". Please select "Paused" prospects.',
                play_prospects: "Play prospects",
                play_prospects_disabled: 'The status of selected prospects is “Ongoing”. Please select "Paused" prospects.',
                put_prospects_back_in_campaign: "Put back in campaign",
                toast: {
                    error_fetching_all_prospects: "An error occured while fetching prospects",
                    error_fetching_prospect_can_be_put_back_in_campaign: "Error while trying to retrieve infos about travelers",
                    error_put_prospect_back_in_campaign: "Error while trying to put prospects back in your campaign",
                },
            },
            campaign_header: {
                level0: {
                    acceptance_rate: {
                        range: "< 15%",
                        subTitle:
                            "Profile looks incomplete or unprofessional.<br/><br/>Add a professional profile picture that clearly shows your face and makes people want to work with you.",
                    },
                    answer_rate: {
                        range: "< 5%",
                        subTitle:
                            'Messages are too self-centered/salesy.<br/><br/>Rewrite from scratch and start with their pain/situation; remove your "offer" from the first line.',
                    },
                    title: "Level 0",
                },
                level1: {
                    acceptance_rate: {
                        range: "15-30%",
                        subTitle:
                            "Basic profile without clear value proposition.<br/><br/>Update your headline to clearly explain what you do and who you help. Avoid generic job titles or meaning less words.",
                    },
                    answer_rate: {
                        range: "5-15%",
                        subTitle:
                            "Messages are too generic/fluffy to trigger a reply.<br/><br/>Add a precise detail about their role/industry; state why you're reaching out now.",
                    },
                    title: "Level 1",
                },
                level2: {
                    acceptance_rate: {
                        range: "30-50%",
                        subTitle:
                            "Visible profile but lacks credibility signals.<br/><br/>Add a professional banner and complete your About section. Show your expertise in your profile.",
                    },
                    answer_rate: {
                        range: "15-25%",
                        subTitle:
                            "Messages don’t pull people into a conversation, no clear opportunity for them to answer.<br/><br/>Cut 20–30% of the text; end with one simple, sincere, one-line question.",
                    },
                    title: "Level 2",
                },
                level3: {
                    acceptance_rate: {
                        range: "> 50%",
                        subTitle:
                            "Profile is optimized!<br/><br/>Make sure you have clear CTAs on your profile (website link, calendar, resources). Think of it like a sales page.",
                    },
                    answer_rate: {
                        range: "> 25%",
                        subTitle:
                            "Messaging works well.<br/><br/>Duplicate the message and test 1–2 small variations (opening line, question, value) to find your top performer and scale it across campaigns.",
                    },
                    title: "Level 3",
                },
                performance_indicator: {
                    dropdown: {
                        title: "How is it going?",
                    },
                },
            },
            campaign_is_processing: "An action is currently ongoing please wait until it finishes.",
            campaign_is_stopped: "Campaign is currently archived",
            edit: "Manage my campaign",
            edit_my_campaign: "Edit my campaign",
            empty_list: "You have no prospects in this campaign",
            enrichment_quotas_left: "{{quotasLeft}} emails left to find ({{monthlyMax}} max/month)",
            errors: {
                failed_fetching: "An error occurred while fetching the template please try again.",
            },
            filters_empty_list: {
                subtext: "Try adjusting or clearing your filters for results.",
                text: "No prospect matched the filters used",
            },
            pause_my_campaign: "Pause my campaign",
            play_my_campaign: "Play my campaign",
            playPauseSuccess: "Campaign updated",
            prospects: {
                waiting_for_condition: "Waiting for condition",
            },
            prospects_error: "Error",
            prospects_header: {
                list: "List",
                name: "Name",
                next_action: "Current step",
                status: "State",
                tags: "Tags",
            },
            see_my_campaign: "See my campaign",
            sequence_used_name: "<strong>{{name}}</strong>",
            sequence_used_title: "Campaign used",
            sidebar: {
                details: {
                    modal: {
                        button: "Discover the meaning of each step",
                        title: "Information on campaign steps",
                    },
                    no_prospects: {
                        button: "Add prospects",
                        title: "You don't have any active prospects",
                    },
                    sections: {
                        condition: {
                            description: {
                                sleep: "The prospect will move on to the next step after the set time.",
                                waitingConnect: "The prospect has not yet accepted your connection request.",
                                waitingEmail:
                                    "The prospect has received your email, and if he doesn't reply in the next few days, he'll move on to the next step.",
                                waitingMessage:
                                    "The prospect has received your message, and if he doesn't reply in the next few days, he'll move on to the next step.",
                            },
                            sleep: "Move on to the next step after a delay",
                            waitingConnect: "Waiting to accept your invitation",
                            waitingEmail: "Awaiting reply to an email",
                            waitingMessage: "Awaiting reply to a message",
                        },
                        description: {
                            exited_manually: "You take out manually the prospect from your campaign.",
                            frozen: "Too many prospects in a campaign can affect the tool's performance. The prospect exceeding the limit is 'blocked'. He will start the campaign when another prospect has completed it.",
                            has_not_pro_mail:
                                "If your prospect doesn't have a professional email address and the email search is the last stage of the campaign, he's considered to have completed the campaign.",
                            has_pro_mail:
                                "If your prospect has a professional email address and the email search is the last stage of the campaign, he is considered to have completed the campaign.",
                            invitation_accepted:
                                "If your last campaign action is an invitation, and the prospect accepts the invitation, then we consider he have completed the campaign.",
                            invitation_declined:
                                "If the prospect has refused your invitation, or has not accepted it after a long delay, then we consider he have completed the campaign.",
                            not_replied:
                                "When the prospect doesn’t reply to your message or email after a long delay, then we consider he completed the campaign.",
                            paused: "You have paused the prospect. No further action will be taken. You can reactivate him to resume actions.",
                            postponed: "The limit of 200 invitations/week imposed by Linkedin has been reached. Your actions will resume next week.",
                            replied: "When the prospect reply to your message or email, then we consider he completed the campaign.",
                        },
                        title: {
                            condition: "Waiting for a condition",
                            error: "Encountered an error",
                            exited_manually: "Taken out manually",
                            finished: "Completed the campaign",
                            frozen: "Are frozen",
                            has_not_pro_mail: "Hasn’t a pro email",
                            has_pro_mail: "Has a pro email",
                            interested: "Are interested",
                            invitation_accepted: "Accepted my invitation",
                            invitation_declined: "Did not accept my invitation",
                            later_interested: "To be followed-up",
                            not_categorized: "Not categorized",
                            not_interested: "Are not interested",
                            not_replied: "Did not reply",
                            paused: "Are paused",
                            postponed: "Are postponed",
                            replied: "Replied",
                            waypoint: "Will soon receive an action",
                        },
                        waypoint: {
                            connectLinkedin: "Will receive an invitation",
                            description: {
                                connectLinkedin: "The prospect will receive a connection request on Linkedin.",
                                email: "The prospect will soon receive your email.",
                                enrichment: "Dropcontact is looking for your prospects' professional email address.",
                                followLinkedin: "The prospect will get a notification that shows you follow his profile.",
                                messageLinkedin:
                                    "The prospect will soon receive your message if you are connected on LinkedIn, or when it accepts your connection request.",
                                messageRequestLinkedin:
                                    "The prospect will soon receive a message request on his LinkedIn inbox, which requires their approval before they can reply.",
                                visitLinkedin: "The prospect will get a notification that shows you visit his profile.",
                                webhook: "The selected infos will be sent to my CRM",
                            },
                            email: "Will receive an email",
                            enrichment: "Will be enriched",
                            followLinkedin: "Will be followed",
                            messageLinkedin: "Will receive a message",
                            messageRequestLinkedin: "Will receive a message request",
                            visitLinkedin: "Will be visited",
                            webhook: "Will be sent to my CRM",
                        },
                    },
                    travelers_exited: "Exited prospects",
                    travelers_paused: "Standstill prospects",
                    travelers_traveling: "Active prospects",
                },
                overview: {
                    connectCondition: "Waiting to accept my invitation",
                    defaultCondition: "Waiting for a response",
                    steps: {
                        delay: {
                            tooltip: {
                                connect:
                                    "Have received your invitation. Prospects will go to the next step if they accept. If they don't accept in {{days}} days, they will exit the campaign.",
                                response:
                                    "If the prospect answers, he will exit the campaign. If didn't answer for {{days}} days, will go to the next step.",
                            },
                        },
                    },
                },
                tabs: {
                    details: "Details",
                    overview: "Overview",
                },
                toasts: {
                    travelersSummaryError: "Unable to retrieve prospect progress data in your campaign",
                },
            },
            sleep_unit_day: "days",
            sleep_unit_minutes: "minutes",
            tab: {
                analytics: "Analytics",
                prospects: "Prospects",
            },
        },
        campaigns: {
            campaign_actions: {
                delete_prospects: "Exit prospects",
                exit_prospects_campaign:
                    "Do you really want to exit {{nbUsersToExit}} prospects from this campaign and delete related programmed actions?",
                pause: "Pause",
                play: "Play",
                stop: "Archive",
                view_actions: "View queued actions",
                will_delete_prospects: "You are going to exit prospects",
            },
            campaigns_filter: {
                no_campaign: "No campaign to select",
            },
            content: {
                modal: {
                    delete_draft: {
                        delete_confirm: "Delete draft",
                        draft_campaign_to_delete: 'Are you sure you want to delete "{{draftCampaign}}"',
                        title: "You are about to delete a draft campaign",
                    },
                },
            },
            create_campaign: "Start a campaign",
            edit_draft: "Edit draft",
            error_fetching: {
                button: "Refresh page",
                text1: "Your campaigns have trouble loading.",
                text2: "Click on the refresh button to find all your campaigns in no time.",
                title: "Oops, we landed on the wrong planet",
            },
            frozen: {
                title: "{{ plan }} Plan campaign",
                view_campaign: "See campaign",
            },
            has_travelers_with_ongoing_action: "Queued actions",
            has_traveling_travelers:
                "Prospects waiting for a condition to be fulfilled, your queue is currently empty, and actions will automatically be added once the conditions are met.",
            no_campaign: "You don't have any campaigns here",
            no_traveling_travelers: "No ongoing actions",
            status_count_tooltip: {
                paused: "Paused",
                running: "Prospects currently running in the campaign",
                stopped: "Archived",
            },
            tabs: {
                draft: "Draft",
                paused: "Paused",
                running: "Running",
                stopped: "Archived",
            },
            title: "My campaigns",
            trigger_running: "Auto-import running",
        },
        contents: {
            cta_primary: "Create a template",
            empty_list: "No templates",
            form: {
                save_cta: "Save as new",
                update_cta: "Update my template",
            },
            header: {
                content: "Content",
                email_subject: "Subject",
                name: "Name",
            },
            linkedin_message: {
                message_without_text_content: "No content",
            },
            modal: {
                cannot_delete_content: "This template is used in at least one campaign and can not be deleted",
                confirm_content_delete: "Are you sure you want to delete this content?",
                delete_confirm: "Yes, delete",
                delete_title: "Delete",
                edit_email_title: "Edit an email",
                edit_title: "Edit a message",
            },
            title: "Messages management",
        },
        conversation: {
            filter_groups: {
                date: "Date",
                has_sent_last_message: "Last message",
                is_archived: "Archived",
                is_read: "Conversation Read - Unread",
            },
            filter_labels: {
                is_archived: "Conversation archived",
                is_from_contact: "Prospect",
                is_from_user: "Me",
                is_read: "Conversation read",
                is_unread: "Conversation unread",
                from_ignore: "Does not matter",
                ignore_archive: "Does not matter",
            },
            filter_placeholder: {
                tags: "Search tags",
            },
            status: {
                cancel: "Cancel",
                delivered: "Delivered",
                waiting: "Waiting",
            },
            type: {
                contain_attachment: "Contain attachment",
                message: "Messages scheduled",
                never_answered: "Never answered",
                reminder: "Reminder set",
            },
        },
        conversations: {
            filter_groups: {
                other: "Other",
                status: "Status",
                type: "Action",
            },
        },
        home: {
            hello: "Hello",
        },
        linkedin_messenger: {
            activate: {
                button_pay: "Subscribe to Inbox",
                descriptions: {
                    conversation_reminder: "Conversation reminders",
                    message_programming: "Scheduled messages",
                    preregister_responses: "Templates",
                    sub_descriptions: {
                        conversation_reminder: "Bring up conversations at a specific date",
                        message_programming: "Send your follow-ups at a specific date",
                        preregister_responses: "Don't rewrite for nothing, save time",
                        sync_contacts: "Organize your Inbox the way you want",
                    },
                    sync_contacts: "Prospects' tags",
                },
                footer: "Want to know more about Waalaxy's Inbox?",
                footer_href: "https://www.waalaxy.com/linkedin-messaging",
                footer_link: "It's over here",
                hours: "HOURS",
                inbox: "Waalaxy Inbox",
                minutes: "MINUTES",
                no_card_required: "No credit card required",
                seconds: "SECONDS",
                subtitle: "Only better.",
                title: "LinkedIn messaging.",
                toasts: {
                    activate_failed: "Failed to activate Inbox feature",
                    activate_successed: "Inbox feature activated",
                },
                trial_subtitle: "500 conversations managed at no cost and with no time limit!",
                trial_title: "Test the Inbox for free",
                try_for_free: "Test Inbox for free 😎",
                youtube_video_id: "K2Nh7N-CfK4",
                youtube_video_subtitle: "Take your first steps!",
            },
            conversations: {
                archived: "Unarchive",
                bulkbar_actions: {
                    archive: "Archive",
                    csv_export: "CSV Export",
                    read: "Read",
                    reminder: "Reminder",
                    schedule: "Schedule",
                    tags: "Tag",
                    unread: "Unread",
                    zapier_export: "Send to Zapier",
                },
                contact: {
                    import_in_crm: "Import to Waalaxy",
                    not_in_crm: "This prospect is not in Waalaxy",
                    notes: "Note",
                    notes_placeholder: "Write a note...",
                    open_linkedin_profile: "Open LinkedIn profile",
                },
                errors: {
                    archive_state_update_failed: "Unable to archive the conversation",
                    conversations_fetch_failed: "Failed to retrieve conversations data",
                    failed_to_send_message: "Unable to send message. Please try again...",
                    fetch_failed: "Failed to fetch messages",
                    read_state_update_failed: "Unable to mark this conversation as read/unread",
                },
                filters: {
                    apply: "Apply",
                    date: "Date",
                    date_placeholder: "Start date - end date",
                    reset: "Reset",
                    tags: "Tags",
                },
                home: {
                    no_conversation_button: "Write a new message",
                    no_conversation_text: "Create a conversation to start 💬",
                    select_conversation: "Click on a conversation to start",
                },
                input_placeholder: "Use # to access saved replies - Ctrl/⌘ + Enter to send",
                message: {
                    delete: "Delete",
                    download: "Download",
                    edit: "Edit",
                    should_delete: "Delete this message?",
                },
                message_overview: {
                    reminder_set: "Reminder set the {{date}} at {{time}}",
                    scheduled_message_set: "Scheduled message set for the {{date}} at {{time}}",
                },
                message_overview_time: {
                    day: "{{day}}d",
                    hour: "{{hour}}h",
                    min: "{{minute}} min",
                    month: "{{month}} months",
                    now: "Now",
                    year: "{{year}} year(s)",
                },
                message_overview_types: {
                    deleted: "This message has been deleted",
                    deleted_me: "You have deleted this message",
                    edited: "Edited",
                    file: "Sent you a file",
                    file_me: "You have sent a file",
                    gif: "Sent you a GIF",
                    gif_me: "You have sent a GIF",
                    image: "{{firstName}} sent you an image",
                    image_me: "You sent an image",
                    message: "{{firstName}}: {{message}}",
                    message_me: "You: {{message}}",
                    new_message: "{{firstName}} sent you a message",
                    new_message_me: "You sent a message",
                    reminder: "Reminder: {{message}}",
                    sharing_post: "Sent you a post",
                    sharing_post_me: "You have sent a post",
                },
                no_conversation_search: {
                    clear_search: "Clear all",
                    no_result_text: "Try adjusting or clearing your filters and/or keywords to display better results.",
                    no_result_title: "No results found 😿",
                },
                read: "Mark as unread",
                reminders: {
                    create: "Set reminder",
                    cta: "Remind me",
                    date: "Date",
                    error_date: "Invalid date, the chosen date is in the past",
                    remove: "Remove reminder",
                    remove_modal: {
                        cancel: "No, Cancel",
                        confirm: "Yes, Remove",
                        description: "Are you sure you want to remove the reminder from this conversation?",
                        title: "Remove the reminder",
                    },
                    scheduled: "I will remind you of this conversation on <strong>{{date}}</strong>.",
                    scheduled_cancel_by_me: "Your reminder for <strong>{{date}} was cancelled</strong> because you have sent a message.",
                    scheduled_cancel_by_prospect: "Your reminder for <strong>{{date}} was cancelled</strong> because {{name}} sent you a message.",
                    scheduled_trigger: "You asked me to remind you of this conversation on <strong>{{date}}</strong>.",
                    title: "Remind me this conversation later",
                    update: "Update reminder",
                },
                scheduled_messages: {
                    cta: "Send later",
                    failReason: {
                        default: "Error in message scheduling. Please try again",
                        delete_scheduled_event_failed: "Failed to delete scheduled event",
                        failed_to_format_content: "Failed to format content scheduled for the message",
                        get_content_failed: "Failed to retrieve the scheduled content",
                        not_message_schedule_event: "The message could not be scheduled because it is not a message scheduling event",
                        not_reminder_schedule_event: "The reminder could not be scheduled because it is not a reminder scheduling event",
                        send_attachment_failed: "Failed to send scheduled attachment",
                        send_gif_failed: "Failed to send scheduled GIF",
                        send_message_failed: "Failed to send scheduled message",
                        set_conversation_is_read_failed: "Failed to mark conversation as read",
                    },
                    remove_modal: {
                        cancel: "Cancel",
                        confirm: "Yes, remove",
                        description: "This message won't be sent",
                        title: "Remove the scheduled message",
                    },
                    scheduled: "A message is scheduled to be sent on <strong>{{date}}</strong>.",
                    scheduled_cancel_by_prospect:
                        "Your scheduled message for <strong>{{date}} was cancelled</strong> because {{name}} sent you a message.",
                    scheduled_cancel_subscription_end:
                        "Your scheduled message for <strong>{{date}} was cancelled</strong> because you didn't have the Inbox feature",
                    scheduled_will_be_sent_soon: "Your scheduled message will be sent shortly...",
                    toast: {
                        cancel: {
                            message: {
                                error: "Something went wrong, please try again!",
                                success: "Your message has been cancelled",
                            },
                            reminder: {
                                error: "Something went wrong, please try again!",
                                success: "Your reminder has been cancelled",
                            },
                        },
                        created: {
                            message: {
                                error: "Something went wrong, please try again!",
                                success: "Your message has been scheduled",
                            },
                            reminder: {
                                error: "Something went wrong, please try again!",
                                success: "Your reminder has been created",
                            },
                        },
                        updated: {
                            message: {
                                error: "Something went wrong, please try again!",
                                success: "Scheduled message updated",
                            },
                            reminder: {
                                error: "Unable to update your reminder",
                                success: "Reminder updated",
                            },
                        },
                    },
                },
                sidebar: {
                    filters: {
                        conversations: "conversations",
                        reset: "Reset filters",
                    },
                    free_trial_badge: {
                        button: "Upgrade now",
                        left: "of free trial left",
                        trial: "{{count}} day{{plural}}",
                    },
                    search: {
                        placeholder: "Search for a contact...",
                    },
                    title: "Discussions",
                },
                tabs: {
                    all_tab: "All",
                    unread_tab: "Unread",
                },
                toasts: {
                    conversation_archived: "Conversation archived",
                    conversation_unarchived: "Conversation unarchived",
                },
                unarchived: "Archive",
                unread: "Mark as read",
            },
            forbidden: {
                you_cant_access_inbox: "You can’t access this Inbox",
                you_cant_access_inbox_descr:
                    "You are currently impersonating <strong>{{firstName}} {{lastName}}</strong>, therefore you can’t access this Inbox.",
            },
            free_trial_over_modal: {
                expired: {
                    subtitle: "In addition to losing the management of your messages from the Inbox, you also lose :",
                    title: "Your free access to Inbox has expired",
                },
                explanation:
                    "With the end of your free trial, <strong>Inbox is suspended</strong> and you no longer have access to all the features that come with it. \nBy subscribing to Inbox, you'll get your templates and scheduled messages back, among other things.",
                lost_features: {
                    crm_sync: "CRM <strong>synchronization</strong>,",
                    reminders: "The <strong>remind</strong> of your conversations,",
                    saved_replies: "Your <strong>templates</strong>,",
                    scheduled_messages: "The <strong>scheduling</strong> of your messages,",
                    time: "<strong>Therefore time</strong>",
                },
                skip: "Skip",
                stats: {
                    conversations: "Engaged conversations",
                    saved_replies: "Templates",
                    scheduled_messages: "Scheduled messages",
                },
                subscribe: "Subscribe to Inbox",
                subtitle: "Here's what you've accomplished with Inbox:",
                title: "Don't stop there",
            },
            free_trial_progession: {
                button: "Your progression",
                manage_conversations: "Manage {{count}} conversations",
                schedule_messages: "Schedule {{count}} messages",
                unlock_new_quests: "🏆 Complete your goals to unlock new quests",
                write_saved_replies: "Write {{count}} templates",
            },
            initialization_information:
                "We are retrieving your conversations from LinkedIn... It may take a few minutes before they are all available.",
            keyboard_shortcut: {
                keyboard_shortcuts_navigate: "Use keyboard shortcuts to navigate!",
                navigate_conversations_history: "to navigate in conversations history",
                navigate_conversations_list: "to navigate in your conversations list",
                quickly_saved_reply: "to quickly add a template",
                send_message: "to send a message",
                tips: "TIPS",
            },
            message: {
                preview_see_more: "...see more",
            },
            open_help: "Open support chat",
            saved_replies: {
                confirm_modal_delete: {
                    title: "Delete this template?",
                },
                no_saved_replies: {
                    sub_title: "Do you want to create one?",
                    title: "You don’t have saved replies yet.",
                },
                no_saved_replies_on_search: {
                    title: "There is no results for “{{search}}” 😿",
                },
                title: "Saved Replies",
            },
            schedule_event: {
                edit_fail: "Failed to edit",
                information_schedule_message:
                    "💡 <strong>Keep Waalaxy open or upgrade to Cloud.</strong> If you don’t have the Cloud feature your message will be sent on the next connexion to Waalaxy after the delay set. <a>Learn more</a>",
                learn_more: "Learn more",
                title_reminder: "Reminder",
                title_schedule: "Scheduled message",
            },
            time_shortcuts: {
                next_day: "Tomorrow",
                next_monday: "Next Monday",
                one_month: "1 Month",
                one_week: "1 Week",
            },
        },
        not_found: {
            text_1: "A black hole!",
            text_2: "Looks like you've strayed into an unexplored Waalaxy.",
            title: "Oh ship...",
        },
        paywall: {
            autoImport: {
                item: {
                    description_1: "Import people who invite, visit, comment your posts... or from Sales Navigator",
                    description_2: "Waalaxy automatically adds qualified prospects to your campaigns",
                    description_3: "Focus on following up and converting your prospects into clients",
                    title_1: "Smart targeting",
                    title_2: "Continuous prospecting",
                    title_3: "Boosted conversion",
                },
                subtitle: "Your prospects imported automatically",
                title: "Your prospects imported automatically",
            },
            cloud: {
                item: {
                    description_1: "Don't stop your prospecting for a wifi bug",
                    description_2: "Meet your daily action quotas and choose the best sending times",
                    description_3: "Your prospect data is updated in real-time on Waalaxy",
                    title_1: "Sending actions continuously",
                    title_2: "Optimize your prospecting",
                    title_3: "Performance and reliability",
                },
                subtitle: "Don't let your prospecting stop when your computer shuts down.",
                title: "Prospect even offline",
            },
            crm: {
                item: {
                    description_1: "Choose the data and events that trigger the sending of prospects",
                    description_2: "Automatic updates at each key stage of the prospect's journey.",
                    description_3: "Each contact is verified before sending: no duplicates, no confusion",
                    description_4: "Generate your keys and connect Waalaxy to your internal tools.",
                    title_1: "Custom synchronization",
                    title_2: "Automatic, continuous transfer",
                    title_3: "Clean CRM, no duplicates",
                    title_4: "API Key Management",
                },
                subtitle: "Synchronize your CRM and retrieve your API keys to automate the tracking of your prospects.",
                title: "Connect Waalaxy to your stack",
            },
            email_settings: {
                item: {
                    description_1: "Increase your response rate by reaching prospects where they actually read you",
                    description_2: "No email? No problem. Waalaxy finds them for you",
                    description_3: "Keep an eye on the performance of each message and identify what really works",
                    title_1: "LinkedIn + Email = 2x more opportunities",
                    title_2: "Professional email enrichment",
                    title_3: "Real-time tracking",
                },
                subtitle: "Combine LinkedIn and email in a single automated, multichannel sequence",
                title: "60% of invitations go unanswered...",
            },
            sequence: {
                crm: {
                    subTitle: "Quickly convert your prospects into clients",
                },
                email: {
                    subTitle: "Combine LinkedIn and email into a single multichannel sequence, 100% automated",
                },
                titleButton: "Unlock this campaign template",
            },
            team: {
                item: {
                    description_1: "Track your team's performance in one place",
                    description_2: "Manage leads from one account to another in just a few clicks",
                    description_3: "Easily switch between accounts and manage their campaigns",
                    description_4: "Never contact the same person as another team member",
                    title_1: "Shared statistics",
                    title_2: "Inter-account import and lead transfer",
                    title_3: "Simplified collaboration",
                    title_4: "Anti-duplicate security",
                },
                subtitle: "Customize your team now!",
                title: "Easily prospect as a team",
            },
            titleButton: "Unlock feature",
        },
        prospect_detail: {
            refill_credits: "Refill credits",
            no_more_credits: "No more credits available",
            add_prospects_input: {
                not_respect_enter_conditions: "Does not meet entry requirements",
            },
            content_name: "Template : ",
            crm_sync: "CRM Sync",
            custom_variables: {
                section_title: "Custom properties",
                add_button: "Add a property",
                add_placeholder: "Property name",
                modal_title: "Add a custom property",
                modal_description_1: "Find it in your prospect lists and update it automatically via CSV and API imports.",
                modal_description_2: "Manage all your custom properties directly from your Settings.",
                modal_field_label: "Property name",
                modal_field_placeholder: "Message1, Sector...",
                modal_field_required: "Property name is required",
                modal_field_already_exists: "A property with this name already exists",
                modal_label_too_long: "The property name exceeds {{count}} characters",
                modal_cancel: "Cancel",
                modal_create: "Add my property",
                value_too_long: "Content cannot exceed 1000 characters",
            },
            email_account: "Account : ",
            email_object: "Object : ",
            errors: {
                email_format: "The format of the email is not correct",
                phone_number: "Telephone numbers require only digits",
            },
            history: {
                hubspot_succeeded: "Sent to Hubspot",
                pipedrive_succeeded: "Sent to Pipedrive",
            },
            job_title: "Job Title",
            list_name: "List",
            placeholder: {
                birthday: "Birthday",
                email: "Email",
                email_linkedin: "LinkedIn Email",
                email_pro: "Pro Email",
                gender: "Gender",
                phone_number: "Phone",
                region: "Region",
            },
            do_not_contact: {
                title: 'Add prospect to the "Do Not Contact" list?',
                campaign_warning: "This prospect is in an active campaign and will be removed immediately.",
                menu_label: "Do not contact",
            },
            refresh: "Refresh",
            see_all_items: "Display all",
            tabs: {
                history: "History",
                infos: "Infos",
            },
            toast: {
                fail: "An error occurred while updating the prospect",
                fail_validator: "{{error}}",
                success: "This prospect has been updated",
            },
            today: "Today",
            type: {
                campaign: "Campaign",
                campaign_back_in_campaign: "Reinstated in the campaign",
                campaign_error: "Error in the campaign",
                campaign_exit: "Removed from the campaign",
                campaign_finish: "Campaign completed",
                campaign_pause: "Campaign on hold",
                campaign_play: "Campaign resumed",
                campaign_start: "Campaign launched: {{campaignName}}",
                connect: "Invitation",
                connect_accepted: "Invitation accepted",
                connect_note: "Invitation sent with note",
                email: "Email",
                email_bounced: "Email not received",
                email_sent: "Email sent",
                enrichment: "Email Finder",
                enrichment_error: "Pro email not found",
                enrichment_success: "Pro email found",
                follow: "Follow",
                message: "Message",
                message_request_sent: "",
                message_seen: "",
                message_sent: "Message sent",
                moved_to: "Moved to {{listName}}",
                response: "Reply",
                response_follow_up: "Reply: Follow up",
                response_interested: "Reply: Interested",
                response_not_interested: "Reply: Not interested",
                visit: "Visit",
                webhook_succeeded: "CRM sync",
            },
            yesterday: "Yesterday",
        },
        prospects: {
            activityTab: {
                message_replied_interested: "Interested",
                message_replied_later_interested: "To follow-up",
                message_replied_not_interested: "Not interested",
                no_activity: "This prospect has no activity yet",
                prospection_updated_label: "Modified status : ",
                state_removed: "Status removed",
            },
            how_it_works: "How it works",
            add_campaign_cta: "Add to a campaign",
            add_existing_campaign_cta: "Add to an existing campaign",
            add_prospects_tags: "Tag",
            add_to_campaign: "Add to campaign",
            all_list: "All lists",
            auto_import_cta: "Auto-import ({{count}})",
            clean_list: {
                button: "Clean my list",
                modal: {
                    examining_list: {
                        title: "Your list is carefully examined...",
                    },
                    insert_job_title: {
                        button_verify: "Verify my list",
                        cancel_button: "Cancel",
                        errors: {
                            empty_input: "Please insert one job title to clean your list",
                        },
                        good_to_know_content:
                            "LinkedIn may return results that are not exactly what you are looking for. (e.g.: [Sales Engineer] can refer to [IT Engineer])",
                        good_to_know_title: "Good to know :",
                        input_title: "Fill in the job title you want to keep",
                        placeholder_input: "Sales Manager",
                        title: "Would you like to clean your list based on your prospects’ job titles?",
                    },
                    no_prospect_detected: {
                        cancel_button: "Cancel",
                        description:
                            "All the prospects in your list match the job title you're looking for. <br /> Would you like to try again with another job title?",
                        title: "Your list is already clean!",
                        try_again_button: "Try with another job title",
                    },
                    prospect_detected: {
                        clean_button: "Clean my list",
                        description:
                            "Our algorithm found {{countDetected}} prospects who are not <strong>{{jobTitle}}</strong>. Are you sure to delete them from your list ?",
                        previous_button: "Previous",
                        title: "{{countDetected}} false positives detected",
                    },
                    prospect_in_campaign_detected: {
                        clean_button: "Clean my list and campaigns",
                        description:
                            "Our algorithm found {{countDetected}} prospects who are not <strong>{{jobTitle}}</strong>. <br />This action will remove prospects from your lists and campaigns.",
                        previous_button: "Previous",
                        title: "{{countDetected}} false positives detected,<br /> including {{countInCampaign}} in campaigns",
                    },
                    success: {
                        button: "Done",
                        description: "Our algorithm has removed <strong>{{countCleaned}}</strong> false positive prospects from your list.",
                        title: "Operation successfull!",
                    },
                },
                toasts: {
                    error_analysing_list: "Error while examining your list, please try again",
                    error_clean_list: "Error while cleaning your list, please try again",
                    success_clean_list: "Successfully cleaned your list",
                },
                tooltip_disabled_button: "Available as soon as the current import is done",
            },
            columns: {
                activity: "Activity",
                campaign: "Campaign",
                company: "Company",
                country: "Country",
                custom_variables_section: "Custom variables",
                gender: "Gender",
                import_date: "Import date",
                job: "Job",
                name: "Name",
                pro_email: "Pro email",
                status: "Status",
                tags: "Tags",
            },
            content_tooltip: {
                no_prospectlist: {
                    add_campaign_cta:
                        'You can\'t add prospects into a campaign from the "all prospects" tab. Please select a list of prospects to add to a campaign',
                    move_prospect: 'You can\'t move prospects into another list from the "all prospects" tab. Please select a list to move prospects',
                    start_campaign_cta:
                        'You can\'t add prospects into a campaign from the "all prospects" tab. Please select a list of prospects to launch a campaign',
                },
            },
            enrichment: {
                cta: "Find email",
                email_copied_feedback: "Email copied!",
                enrich_button: "AI prospect finder",
                error_description: "A problem occurred during email retrieval, please try again later.",
                error_title: "Error",
                no_prospectlist: 'You can\'t enrich prospects from the "all prospects" tab. Please use a prospect list to enrich',
                not_found_cta: "Email not found",
                searching: "Research",
                bulk_modal: {
                    title: "Oops, you don't have enough credit 😭 ",
                    content:
                        "You only have enough credits to enrich the first {{creditsAvailable}} selected prospects. Start with those {{creditsAvailable}}, or top up to cover everyone.",
                    launch: "Launch the first {{creditsAvailable}}",
                },
                success_toast: {
                    title: "Enrichment initiated",
                    content: "This may take a few minutes. You'll find the emails that were found in your list ",
                },
            },
            filter_groups: {
                company: "Company",
                country: "Country",
                distance: "Distance",
                email_actions: "Email actions",
                gender: "Gender",
                has_email: "Email",
                has_invitation_sent: "Invitation sent",
                has_phone_number: "Phone number",
                has_profile_picture: "Profile picture",
                import_date: "Import date",
                is_crm_synced: "CRM",
                is_in_campaign: "Is in a campaign",
                is_influencer: "Influencer",
                is_job_seeker: "Jobseeker",
                is_premium: "Premium",
                job: "Job title",
                linkedin: {
                    messages: "LinkedIn messages",
                    restriction: "LinkedIn restriction",
                    can_receive_message_request: "Can receive message request",
                },
                linkedin_actions: "LinkedIn Visit/Follow",
                linkedin_events: "LinkedIn events",
                linkedin_groups: "LinkedIn groups",
                location: "Location",
                profile_complete: "Profile",
                state: "State",
                status: "Status",
                tags: "Tags",
            },
            filter_labels: {
                not_can_receive_message_request: "Can't receive message request",
                can_receive_message_request_ignore: "Does not matter",
                ignore_restriction: "Does not matter",
                can_receive_message_request: "Can receive message request",
                can_invite_while_restricted: "Can be invited while LinkedIn quota has been reached",
                cant_invite_while_restricted: "Can't be invited while LinkedIn quota has been reached",
                distance_one: "1st",
                distance_three: "3rd and +",
                distance_two: "2nd",
                email_not_replied: "Has not replied",
                email_not_sent: "No email sent",
                email_replied: "Has replied",
                email_sent: "Email sent",
                has_email: "Has an email",
                has_invitation_not_sent: "Invitation not sent",
                has_invitation_sent: "Invitation sent",
                has_linkedin_email: "Has a LinkedIn email",
                has_no_linkedin_email: "Don't have a LinkedIn email",
                has_no_phone_number: "Phone number not retrieved",
                has_no_pro_email: "Don't have a pro email",
                has_no_profile_complete: "Partial profile",
                has_no_profile_picture: "No profile picture",
                has_phone_number: "Phone number retrieved",
                has_pro_email: "Has a pro email",
                has_profile_complete: "Complete profile",
                has_profile_picture: "Has profile picture",
                influencer_ignore: "Does not matter",
                invitation_sent_ignore: "Does not matter",
                is_in_campaign: "Is in a campaign",
                is_influencer: "Is an influencer",
                is_job_seeker: "Is a jobseeker",
                is_not_in_campaign: "Is not in a campaign",
                is_not_influencer: "Is not an influencer",
                is_not_job_seeker: "Not a jobseeker",
                is_not_premium: "Not premium",
                is_premium: "Premium",
                job_seeker_ignore: "Does not matter",
                job_seeker_unknown: "Unknown",
                linkedin_follow: "Following",
                linkedin_message: "Message sent",
                linkedin_visit: "Profile visited",
                message_not_replied: "Has not replied",
                message_replied: "Has replied",
                no_linkedin_follow: "Not following",
                no_linkedin_message: "No message sent",
                no_linkedin_visit: "Profile not visited",
                not_same_linkedin_event: "Is not in the same event as me",
                not_same_linkedin_group: "Is not in the same group as me",
                not_synced: "Not sync",
                out_of_network: "Out of network",
                phone_number_ignore: "Does not matter",
                premium_ignore: "Does not matter",
                profile_complete_ignore: "Does not matter",
                profile_picture_ignore: "Does not matter",
                same_linkedin_event: "Is in the same event as me",
                same_linkedin_event_ignore: "Is or is not in the same event as me",
                same_linkedin_group: "Is in the same group as me",
                same_linkedin_group_ignore: "Is or is not in the same group as me",
                sync_error: "Sync error",
                synced: "Sync",
            },
            filter_placeholder: {
                company: "Search for current company",
                country: "Search by country",
                job: "Search for a job title",
                location: "Add a country/region",
                tags: "Search tags",
            },
            filter_tooltips: {
                gender: "Detected by AI with 98% accuracy",
                is_job_seeker: "Waalaxy only knows the jobseeker status of prospects whose LinkedIn profile has been visited",
            },
            gender: {
                female: "Female",
                male: "Male",
                undetermined: "Undetermined",
            },
            list: {
                company: "Company",
                csv_imported_explanation:
                    "This prospect comes from a CSV file. Information will be retrieved once you perform a visit or a follow on this profile.",
                headline: "Headline",
                prospect_states: {
                    delete: "Delete",
                    finalized: "Finalized",
                    interested: "Interested",
                    later_interested: "To follow-up",
                    none: "Add a status",
                    not_interested: "Not interested",
                    replied: "Replied",
                },
                prospectin_imported_explanation:
                    "This prospect comes from a ProspectIn transfer. Information will be retrieved once you perform an action (visit/follow/connect/message) for this prospect",
                sales_imported_explanation:
                    "This prospect has been imported from sales navigator. Information will be retrieved once you perform an action (visit/follow/invitation/message) for this prospect",
                regular_imported_explanation:
                    "This prospect has been imported from LinkedIn. But we couldn't retrieve all the information. Information will be retrieved once you perform an action (visit/follow/invitation/message) for this prospect",
                status: {
                    connected: "Connected",
                    not_connected: "Not connected",
                    pending: "Pending invitation",
                    unknown:
                        "Unknown status. In order for the status to be retrieved, the related account must be connected to LinkedIn with the Waalaxy extension active",
                },
                toast: {
                    create_error: "Error while creating the list",
                    create_success: "Prospect list created",
                    delete_error: "Error while deleting the list",
                    delete_error_ongoing_import: "You can't delete a list with an ongoing prospect import.",
                    delete_success: "List deleted with success",
                    duplicate_name: "The list name is already in use. Please choose another one.",
                    update_error: "Error while updating the list",
                },
                tooltips: {
                    connect_action: {
                        none: "No invitation sent",
                        replied: "Invitation note replied",
                        sent: "Invitation sent",
                    },
                    crm_not_synced: "Not Sync with CRM",
                    crm_synced: "CRM Sync",
                    crm_synced_error: {
                        contact_deleted: "Contact is deleted from CRM",
                        hubspot_contact_limit_reached: "HubSpot contact limit reached",
                        multiple_profile_id_with_same_email: "Prospect already in CRM (same email)",
                        pipedrive_account_not_open: "Pipedrive account inactive (trial expired or payment missing)",
                        rate_limit_reached: "Rate limit reached",
                        unknown: "Unknown sync error",
                    },
                    crm_synced_retry: "Rate limit reached : sync postponed tomorrow",
                    email_action: {
                        none: "No email sent",
                        replied: "Email replied",
                        sent: "Email sent",
                    },
                    follow_action: "Follow",
                    has_email: "Has an email",
                    has_no_email: "Has no email",
                    message_action: {
                        none: "No message sent",
                        replied: "Has replied",
                        replied_interested: "Interested",
                        replied_later_interested: "To follow-up",
                        replied_not_interested: "Not interested",
                        sent: "Message sent",
                    },
                    message_request_action: {
                        none: "No message request sent",
                        replied: "Message request replied",
                        sent: "Message request sent",
                    },
                    no_follow_action: "No follow sent",
                    no_shared_events: "Not in the same event",
                    no_shared_groups: "Not in the same group",
                    no_visit_action: "Not visited",
                    shared_events: "Same event",
                    shared_groups: "Same group",
                    visit_action: "Visited",
                },
            },
            do_not_contact: {
                add_prospects_to_do_not_contact: "Do not contact",
                modal_title: 'Add {{count}} prospects to the "Do Not Contact" list?',
                all_traveling_description: "These {{count}} prospects are all in an active campaign. They will be removed immediately.",
                some_traveling_description: "{{count}} of these prospects are in an active campaign and will be removed immediately.",
                ignore_traveling_checkbox: "Ignore prospects in campaign",
                no_traveling_description: "These prospects will no longer receive any Waalaxy actions.",
                success_toast_title: "{{count}} prospects excluded",
                success_toast_description: "They will no longer receive Waalaxy actions",
            },
            loading_text_1: "The prospects arrive...",
            loading_text_2: "We give them a little trim.",
            max_transfer_prospects: {
                cta: "I understand",
                max_prospect_in_list: {
                    text: "With our {{planName}} plan, you can import up to {{maxProspectPerListCount}} prospects in a list. Upgrade to import more prospects in your lists.",
                    title: "The maximum is {{maxProspectCount}} prospects per list.",
                },
                prospect_not_transferred: {
                    text: "You can upgrade or create a new list to import your prospects",
                    title: "{{notImportedProspectCount}} prospects have not been imported",
                },
                title: 'You\'ve reached the limit for the list "{{listName}}"',
            },
            modal: {
                confirm_delete_cta: "Confirm",
                confirm_delete_prospects_with_count: "Are you sure you want to delete {{ count }} prospects?",
                confirm_upper_500_prospects_cancel_cta: "No, Cancel",
                confirm_upper_500_prospects_delete_cta_with_count: "Yes, Delete {{count}} prospects",
                delete_prospects_in_campaign_cancel_cta: "No, cancel",
                delete_prospects_in_campaign_confirm_cta: "Yes, delete",
                delete_prospects_in_campaign_confirm_cta_with_count: "Yes, delete {{count}} prospects",
                delete_prospects_in_campaign_selection1: "All prospects:",
                delete_prospects_in_campaign_selection2: "Only those who are not in campaigns:",
                delete_prospects_in_campaign_text1:
                    "This action will exit the prospects from campaigns and delete them from Waalaxy. This action can’t be undone. ",
                delete_prospects_in_campaign_text2: "Confirm by selecting the number of prospects to be deleted",
                delete_prospects_in_campaign_title_with_count: "Delete {{count}} prospects ?",
                delete_prospects_in_campaign_warning_with_count: "{{count}} prospects are already in a campaign.",
                delete_prospects_title: "Delete prospect",
                delete_upper_500_prospects_confirm: "Confirm by typing the number of prospects deleted:",
                delete_upper_500_prospects_text_1: "This action will exit the prospects from your campaigns, and delete them from Waalaxy.",
                delete_upper_500_prospects_text_2: "This action can’t be undone.",
                delete_upper_500_prospects_title_with_count: "Delete {{count}} prospects?",
            },
            import_panel: {
                comments_form_title: "Import people who commented a post",
                comments_form_placeholder_url: "Paste the LinkedIn post URL",
                empty_state_cta: "Import prospects",
                options_title: "Import options",
                clean_my_import_title: "Clean my import",
                clean_my_import_description: 'Enable this option to remove "false positive" prospects from your import.',
                import_comments_choice: "Who commented on a LinkedIn post",
                import_csv_choice: "From a CSV file",
                import_event_choice: "From a LinkedIn event",
                import_group_choice: "From my LinkedIn groups",
                import_network_choice: "From my LinkedIn network",
                import_reactions_choice: "Who reacted to a LinkedIn post",
                import_reposts_choice: "Who reposted a LinkedIn post",
                import_regular_search_choice: "From a LinkedIn Search",
                import_sales_leads_list_choice: "From a Sales Navigator list",
                import_sales_saved_search_choice: "From a saved search in Sales Navigator",
                import_sales_search_choice: "From a Sales Navigator search",
                sales_cloud_maintenance_badge: "Currently unavailable",
                sales_cloud_maintenance_tooltip: "Sales Navigator cloud imports are temporarily unavailable.",
                import_talent_choice: "From Recruiter Lite",
                import_talent_search_choice: "Import via Recruiter Lite search",
                reactions_form_title: "Import people who reacted to a post",
                section_classics: "Classic",
                section_sales: "Sales Navigator",
                section_recruiter: "Recruiter",
                section_signals: "Interest signals",
                title: "Import prospects",
                cloud_connecting_title: "Connecting to LinkedIn…",
                cloud_connecting_subtitle: "We're restoring your LinkedIn connection to import your prospects. Just a moment.",
                recruiter_connecting_title: "Connecting to the Alien Recruiter extension",
                recruiter_connecting_subtitle: "Recruiter Lite imports require the Alien Recruiter Chrome extension.",
                cloud_error_title: "Something went wrong",
                cloud_error_subtitle: "The connection could not be established.",
                cloud_error_cta: "Try again",
                cloud_session_expired_title: "Your LinkedIn session has expired",
                cloud_session_expired_subtitle: "Reconnect to LinkedIn to resume importing your prospects.",
                cloud_session_expired_cta: "Reconnect to LinkedIn",
                sales_verifying_title: "Checking connection…",
                sales_verifying_subtitle: "We're checking your Sales Navigator access. Just a moment.",
                sales_restoring_session_title: "Restoring your session...",
                sales_restoring_session_subtitle: "We're restoring your Sales Navigator session. Just a moment.",
                sales_unreachable_title: "We can't reach Sales Navigator",
                sales_unreachable_step_1: "Open a LinkedIn tab.",
                sales_unreachable_step_2: "Make sure you're logged in as {{name}}.",
            },
            no_existing_campaign: "No campaign to select",
            no_results_description: "Adjust or reset applied filters to find signs of life",
            no_do_not_contact_description:
                "The prospects added here will no longer receive any Waalaxy actions. <br/>Add them from your prospect list or a CSV import.",
            no_results_title: "No prospects detected",
            no_do_not_contact_title: "No prospects here",
            no_rows_description: "Your mission: Import prospects",
            no_rows_title: "No signs of life detected",
            refresh_status: {
                bulk_disabled_tooltip: "User cloud is not active",
                bulk_title: "Refresh status",
                modal: {
                    continue_pl: "Refresh the {{count}} other statuses",
                    continue_sg: "Refresh the {{count}} other status",
                    no_status_title: "No status can be refreshed",
                    reason_pl: "{{count}} prospects are in a campaign",
                    reason_sg: "{{count}} prospect is in a campaign",
                    title_pl: "{{count}} statuses cannot be refreshed",
                    title_sg: "{{count}} status cannot be refreshed",
                },
            },
            start_campaign: {
                confirm_create_campaign_cta: "Continue with {{count}} prospects",
                invalid_prospects: "{{count}} prospects do not meet one or more conditions in the campaign:",
                preconditions: {
                    connected: "Being connected with you",
                    has_email: "Having an email address",
                    linkedin_events_or_groups: "Be in the same group or participate to the same event as you",
                    not_connected: "Not being connected with you",
                    not_in_a_campaign: "Not being in a campaign already",
                    pending: "Waiting to accept an invitation",
                    unknown: "Having a known status",
                },
                prospects_already_traveling: "{{count}} prospects are already in a campaign.",
                title: "{{count}} prospects cannot be added to this campaign.",
            },
            start_campaign_cta: "Start a campaign",
            status: {
                connected: "Connected",
                not_connected: "Not connected",
                pending: "Pending",
                unknown: "Unknown",
            },
            tags_empty_subtitle: "Create your first tag 👆",
            tags_empty_title: "Interstellar void",
            tags_search_placeholder: "Search or create a tag",
            tooltip_disabled_add_campaign_cta: "You have no active campaigns.",
            transfer_prospects: {
                above_target_list_limit_info: "{{nbProspects}} prospects are above {{teamMemberName}} lists limits and will not be transferred",
                active_prospects_info: "{{count}} prospects are in a campaign and will not be moved.",
                cancel_btn: "Cancel",
                confirm_btn: "Move {{count}} prospects",
                confirmation_title: "Move {{count}} prospects to",
                duplicated_prospects_info: "{{count}} prospects are already in {{teamMemberName}}'s lists and will not be moved.",
                success: {
                    completed_title: "Transfer complete",
                    in_progress_message: "Transferring {{count}} prospects...",
                    message: "{{count}} prospects have been moved.",
                    moving_title: "Moving Prospects",
                    title: "Success",
                },
                transfer_failed: {
                    no_request_result_message: "Prospects could not be transferred",
                    no_target_user_selected_message: "No target user selected",
                    progress_error_message: "Failed to move {{count}} prospects. Please try again.",
                    title: "Transfer failed",
                },
                custom_variables_warning_title_pl:
                    "<strong>{{count}} custom variables</strong> are linked to these prospects and do not exist for this team member",
                custom_variables_warning_title:
                    "<strong>One custom variable</strong> is linked to these prospects and do not exist for this team member",
                custom_variables_warning_toggle: "Transfer custom variables",
            },
            restore_prospects: {
                confirm_btn: "Restore {{count}} prospects",
                sidepanel_title: "Restore prospect ?",
                title: "Restore {{count}} prospects",
                description: "These prospects will be able to be added to a campaign again and receive Waalaxy actions.",
                confirmation_title: "Restore {{count}} prospects to",
                success_toast_title: "{{count}} prospects restored",
                success_toast_description: "These prospects can be added to a campaign again",
            },
            trigger_error: "Error when updating auto-import",
            trigger_paused: "Pause",
            trigger_play: "Play",
        },
        queue: {
            action_later: "later",
            cta_primary: "See my quotas",
            cta_secondary: "Update activity",
            email_finder_tips_card:
                "The progress of the Email Finder step <strong>is not visible in the queue.</strong> The email search runs in the background.",
            emptyQueue: {
                loading_actions: "Loading Actions",
                no_actions: "No action for the moment",
                with_search: "No prospect matched the filters used",
            },
            linkedin: {
                header: {
                    campaign: "Campaign",
                    prospect: "Prospect",
                    time: "Time",
                    type: "Action",
                },
            },
            mail: {
                header: {
                    campaign: "Campaign",
                    prospect: "Prospect",
                    provider: "Email",
                    time: "Time",
                },
                no_provider: "No provider to select",
            },
            quotas_reached: {
                cta: "Upgrade now & increase your quota limit",
                subtitle: "<strong>Upgrade now</strong> to keep your actions running:",
                title: "You've reached your maximum quota today! ",
            },
            tab_linkedin: "LinkedIn",
            tab_mail: "Email",
        },
        quotas: {
            back: "Back to all quotas",
            connect_description: "invitations you can send today",
            connect_queue_action: "Invitation actions in queue",
            connect_quota_text: "Quotas of invitations",
            connect_title: "INVITATIONS",
            description: "These quotas are updated on a daily basis.",
            enrichment_description: "email addresses you can find this month",
            enrichment_text: "Email finder",
            follow_description: "prospects you can follow today",
            follow_queue_action: "Action of follow in queue",
            follow_quota_text: "Quotas of follow",
            follow_title: "FOLLOWS",
            learn_more_tooltip: "To learn more about the update of your quotas, click here",
            linkedin_quotas: "LinkedIn",
            mail_description: "emails you can send with this adress today",
            mail_queue_action: "Action of send mail in queue",
            mail_title: "EMAIL",
            mails_quotas: "Emails",
            message_description: "message you can send today",
            message_queue_action: "Action of messages in queue",
            message_quota_text: "Quotas of messages",
            message_request_description: "Message request you can send today",
            message_request_queue_action: "Actions of message requests in queue",
            message_request_quota_text: "Quotas of message requests",
            message_request_title: "MESSAGE REQUESTS",
            message_title: "MESSAGES",
            nb_done: "This is the number of emails you have found this month",
            reached: "Reached",
            reached_tooltip: "To learn more about renewing your quotas, click here.",
            visit_description: "profiles you can visit today",
            visit_queue_action: "Action of visits in queue",
            visit_quota_text: "Quotas of visits",
            visit_title: "PROFILE VISITS",
        },
        sequence: {
            add_prospects: "Add prospects",
            add_prospects_description: "Add some prospects from your lists or by setting up an auto-import.",
            back_to_campaigns: "Go back to campaigns list",
            back_to_overview: "Back to overview",
            can_receive_message_request: "Can receive message request",
            cannot_receive_message_request: "Cannot receive message request",
            connected: "Connected",
            did_not_accept_invite: "Invitation not accepted",
            draft_title: "Draft campaign edition",
            edit_sequence: "Complete your sequence",
            edit_sequence_description: "Edit your message(s), note(s) and email(s) by clicking on it.",
            enrichment_pending: "email search in progress",
            has_email: "Has email",
            has_no_email: "Has no email",
            launch_campaign: "Check & launch",
            launch_campaign_description: "Check if everything is complete as you wish.",
            missions_description: "To launch your campaign you need to achieve the following missions:",
            not_connected: "Not connected",
            not_found: {
                description: "Filters you have applied do not match any template. \nTry again using other options.",
                title: "No template found...",
            },
            not_replied: "Not replied",
            not_seen: "Wasn't seen",
            onReply: {
                goalCard: {
                    addGoalCTA: "Send to a CRM on reply",
                    editGoalCTA: "Edit CRM sync",
                    goalSetTitle: "Action set",
                    noGoalSetTitle: "Set an action on reply",
                },
                modal: {
                    actions: {
                        webhook: {
                            edit: "Edit",
                            errors: {
                                invalid_url: "URL seems invalid",
                                test_request_failed: "Test failed. Please check your webhook and try again.",
                            },
                            success: {
                                test_request_success: "It has landed!",
                            },
                            urlInputPlaceholder: "Paste URL",
                        },
                    },
                    saveCTA: "Save",
                    title: "Send to CRM on reply",
                },
            },
            pending: "Pending",
            replied: "Replied",
            seen: "Seen",
            select_sequence: "Select a sequence",
            select_sequence_description: "Choose a sequence from our library of templates.",
            selector_title: "All campaigns templates",
            side_bar: {
                filters: {
                    titles: {
                        emails: "Emails",
                        linkedin: "Linkedin",
                        my_network: "My network",
                        out_of_network: "Out of network",
                    },
                },
                filters_sections: {
                    titles: {
                        actions: "Actions",
                        canal: "Canal",
                        emails: "Emails",
                        message_linkedin: "LinkedIn Messages",
                        target: "Target",
                    },
                },
                reset_btn: "Clear filters",
                search_placeholder: "Search for a campaign template",
                title: "Filters",
            },
            sleep: "Delay",
            survey: {
                error_message: "Please select an option",
                next_btn: "Next",
                question_1: {
                    answer_1: "Contact prospects",
                    answer_2: "Grow my LinkedIn network",
                    answer_3: "Collect professional emails",
                    question: "What is your main objective with this campaign?",
                },
                question_2_1: {
                    answer_1: "Yes, I am targeting my LinkedIn network",
                    answer_2: "No, I am targeting outside my network",
                    answer_3: "I am targeting everyone",
                    question: "Is your target audience part of your LinkedIn connections?",
                },
                question_2_2: {
                    answer_1: "Yes!",
                    answer_2: "No",
                    answer_3: "I don't know",
                    description:
                        "You can schedule LinkedIn messages to automatically contact and follow up with your prospects if they don't respond.",
                    question: "In addition to an invitation, would you like to contact these prospects?",
                },
                question_2_3: {
                    answer_1: "Yes!",
                    answer_2: "No",
                    answer_3: "I don’t know",
                    description:
                        "Thanks to the \"Email Finder\" feature, you'll get your prospects' professional email addresses, giving you the opportunity to contact them later!",
                    question: "Once their professional email is retrieved, would you like to contact them via email?",
                },
                question_3: {
                    answer_1: "On <blue>LinkedIn</blue> only",
                    answer_2: "On <blue>LinkedIn</blue> and via <purple>Email</purple>",
                    answer_3: "Via <purple>Email</purple> only",
                    answer_4: "I don't know",
                    description: "Increase your response rate by 3.5x with multichannel 🚀",
                    question: "On which channel do you want to launch your campaign?",
                },
                result_btn: "See results",
            },
            title: "Campaign edition",
            tooltip: {
                add_prospects: "Add prospects",
                edit_sequence: "Edit your message",
            },
            use_this_sequence: "Go with this one",
        },
        settings: {
            api_keys: {
                columns: {
                    created_at: "Created at",
                    name: "Name",
                    secret_api_key: "Secret API Key",
                },
                create_modal: {
                    cta: "Generate key",
                    default_name: "Secret Key",
                    description: "Give your API key a descriptive name to help you identify it later.",
                    title: "API Key generation",
                },
                create_new_api_key: "Create new API key",
                delete_modal: {
                    cancel: "No, keep this key",
                    cta: "Yes, delete this key",
                    description:
                        "Deleting this API key will <strong>immediately stop</strong> all connections using it. Any tools or automations linked to Waalaxy will no longer work.",
                    title: "Are you sure to delete this API key ?",
                },
                max_api_keys_reached: "Limit reached (10 keys). Delete one to continue.",
                paywall_description: "Generate your keys and connect Waalaxy to your internal tools.",
                rename_modal: {
                    cta: "Rename",
                    description: "Give your API key a descriptive name to help you identify it later.",
                    error: "An error occured",
                    key_name: "Key Name",
                    name_used_error: "This name is already used",
                    title: "API Key renaming",
                },
                see_modal: {
                    copied: "Copied !",
                    copy_aria_label: "Copy the API key",
                    copy_close: "Copy and close",
                    description:
                        "For security reasons, <strong>you won't be able to view it again</strong> through your Waalaxy account. If you lose this secret key, you'll need to generate a new one.",
                    save_key_description: "Please save this secret key somewhere safe and accessible.",
                    title: "API Key generated",
                },
                subtitle: "Add, modify, or delete your API Keys.",
                title: "API Keys",
                what_for: "What are API keys for ?",
                what_for_url: "https://intercom.help/waalaxy/en/articles/13743138-all-you-need-to-know-about-api-integration-tutorials",
            },
            cloud: {
                apiLogin: {
                    account_secured: "Account secured!",
                    explanation: "You're using Waalaxy on a new device or you have cleared your cookies. Please re enter your LinkedIn's IDs 👇",
                    title: "Security Verification",
                    verify: "Verify",
                },
                authAppModal: {
                    subtitle: "LinkedIn sent a 6-digit code to the authentication application associated with your LinkedIn account.",
                },
                card: {
                    error: {
                        id: "Incorrect email or password. Please try again.",
                    },
                    form: {
                        button: {
                            forgot_password: "Forgot your password?",
                            update: "Update my information",
                            view: "View",
                        },
                        error: {
                            default: "Oops, something went wrong",
                            required: "Required field",
                            wrong_email: "This email does not match your Waalaxy account. Please <support>contact support</support> to change it.",
                            linkedin_id_mismatch:
                                "The LinkedIn account you connected does not match the one registered on your account. Please <support>contact support</support>.",
                            wrong_password: "Password not valid, please try again",
                            invalid_secret: "Invalid 2FA key. Check the link below to retrieve it.",
                        },
                        inputName: {
                            password: "Password",
                            secret: "Enter your 2FA secret key",
                            username: "Email",
                        },
                        placeholder: {
                            password: "Your LinkedIn password",
                            username: "Your LinkedIn email",
                        },
                    },
                    title: "LinkedIn credentials",
                },
                connectingModal: {
                    subtitle: "This can take up to a minute, please wait.",
                    title: "Connecting your LinkedIn account…",
                },
                doubleAuth: {
                    code: "Didn't get a notification ?",
                    subtitle:
                        "You have received a notification on your LinkedIn mobile app (this may take a few seconds). Validate it to confirm your identity, then click on 'Verify'.",
                    title: "LinkedIn Double Authentication",
                    waitingSubtitle:
                        "You have received a notification on your LinkedIn mobile app (this may take a few seconds). Open the app and validate it to confirm your identity — you will be logged in automatically.",
                },
                emailModal: {
                    cancel: "Cancel",
                    code: "Didn’t get it?",
                    resend: "Resend",
                    resendError: "Couldn't resend the code, please try again.",
                    resendSuccess: "Code resent",
                    subtitle: "LinkedIn sent a 6-digit code to <strong>{{username}}</strong>.",
                    title: "Verification code",
                    verify: "Verify",
                },
                explanation: {
                    learn_more: "Learn more about the cloud",
                    subtitle1:
                        "The cloud allows your <strong>campaigns</strong> to run without the need to keep a <strong>LinkedIn tab open</strong>, and even better, when your computer is not <strong>turned on!</strong>",
                    subtitle2:
                        "Sending LinkedIn actions, emails, updating campaigns, auto-imports of prospects, respecting delays, working hours... ",
                    subtitle3: "Don't worry about a thing: <strong>once your campaigns are launched, the cloud takes care of everything.</strong> 😉",
                    title: "What is the Cloud?",
                },
                header: {
                    connect_cta: "Connect",
                    connected: "Connected",
                    disconnected: "Connection interrupted",
                    infinit_login_active_and_connected: "Connected via 2FA",
                    running: "set",
                    stand_by: "to setup",
                    tooltip_active:
                        "Your account is currently running via the cloud, you can close your computer, your campaign will continue to work.",
                    tooltip_stand_by: "To activate the Cloud, you need to enter your LinkedIn Credentials",
                },
                infiniteLoginExplanation: {
                    learn_more: "Learn more",
                    subtitle1:
                        "Waalaxy connects to your LinkedIn account via a Chrome extension. Once installed, it allows the tool to <strong>interact</strong> with your LinkedIn profile.",
                    subtitle2:
                        "This synchronisation allows your campaigns to run without needing to keep a <strong>LinkedIn tab open</strong>, and even better, even when your computer is <strong>turned off</strong>!",
                    subtitle3:
                        "Two-factor authentication (2FA) is an <strong>additional security method</strong>to protect your LinkedIn account. Enabling 2FA makes your account more secure and reduces the risk of <strong>temporary suspension</strong> by LinkedIn.",
                    title: "Securely automate LinkedIn with Waalaxy + 2FA",
                },
                infiniteloginModal: {
                    connect: "Connect account",
                    link: "https://intercom.help/waalaxy/en/articles/12830900-linkedin-connection-infinite-login",
                    secret_help: "<a>How to get my 2FA secret key ?</a>",
                    title: "You’re almost done !",
                },
                loginLoadingModal: {
                    textTitle: "Did you know?",
                },
                loginInboxLoadingModal: {
                    title: "Restoring LinkedIn session...",
                    subtitle: "Your LinkedIn session is required to access the inbox.",
                    bottomText: "Please wait, your inbox will be back in a few moments.",
                },
                loginModal: {
                    enterCredentials: "Please enter your Linkedin credentials to activate the feature.",
                    googleSsoHelpCta: "I signed up to LinkedIn with Google",
                    backToLoginForm: "Back to login",
                    goToLinkedin: "Go to LinkedIn",
                    googleSsoExplanation: {
                        text1: "With your Plan, your campaigns work even offline!",
                        text2: "But we detected that you are using <strong>Google</strong> to connect to your LinkedIn account.",
                        text3: "To <strong>activate the Cloud</strong>, please reset your LinkedIn password. Click on '<strong>Go to LinkedIn</strong>' then '<strong>Reset your password</strong>' on LinkedIn to continue.",
                        text4: "We'll be waiting for you here for the next step!",
                    },
                    googleSsoTitle: "🚀 Level up your prospection",
                    infiniteLoginButton: "Switch to infinite login (2FA)",
                    infiniteLoginDescription: "Select this option to keep your LinkedIn account always connected",
                    infiniteLoginSubtitle: "Extend your session lifetime by enabling 2FA",
                    link: "Link My Account",
                    or: "or",
                    recommended: "Recommended",
                    sessionExpiredSubtitle: "LinkedIn requires your authorization",
                    inboxSessionSubtitle: "Log back in to access your inbox.",
                    sessionExpiredTitle: "Your LinkedIn session has expired",
                    supportIntercomMessage: "I need help changing the email linked to my Waalaxy cloud account.",
                    sync: "🔗 Sync your Linkedin account",
                },
                phoneModal: {
                    subtitle: "LinkedIn sent a 6-digit code to the phone number associated with your LinkedIn account.",
                },
                topCard: {
                    title: "Pssst, fill in your LinkedIn credentials below to make sure the cloud works all the time 👇",
                },
            },
            company: {
                actions: {
                    description: "have no queued actions",
                    description_full: "All your members have actions in queue",
                    members_count: "{{membersWithoutActionInQueue}} member{{plural}}",
                    show_members_cta: "Show members",
                    title: "Actions",
                },
                analyticsMembers: {
                    header: {
                        acceptance: "Acceptance",
                        replyEmails: "Reply",
                        replyMessages: "Reply",
                        staffName: "Staff Name",
                    },
                },
                analytics_tabs: "Analytics",
                available: "Available",
                banner: {
                    accepted_leave_title:
                        "<strong>{{ displayName }}</strong> has accepted your invitation to become the new owner of team ‘<strong>{{ company }}</strong>', you have therefore successfully left the team, as requested.",
                    accepted_title:
                        "You have just accepted the invitation from <strong>{{name}}</strong>! Take a look around to discover the features 🤩",
                    pending_title: "<strong>{{name}}</strong> has invited you to their Team. Accept quickly 🤝",
                    refused_title: "You have just refused the invitation of <strong>{{name}}</strong>!",
                },
                banner_owner_invitation: {
                    accepted_title: "Congrats! You are now the owner of the team <strong>'{{company}}'</strong>",
                    canceled_title: "The invitation was cancelled by the captain of the '<strong>{{ company }}</strong>' team.",
                    pending_title: "<strong>{{ displayName }}</strong> wants to make you the new owner of the team <strong>'{{company}}'</strong> 👑",
                    refused_title: "You have declined the invitation to become the captain of the <strong>'{{ company }}'</strong> team. ",
                },
                choose_invitee_account: {
                    cancel: "Cancel",
                    invite: "Invite",
                    role: "Role: {{role}}",
                    subtitle: "Choose the account to invite",
                    title: "Several accounts match this profile",
                },
                choose_new_owner_cancel: "Cancel",
                choose_new_owner_continue: "Continue",
                choose_new_owner_subtitle: "Team members",
                choose_new_owner_title: "Choose a new owner",
                company_buy_seats_title: "Add seats",
                company_invite_member_placeholder: "Invite by LinkedIn profile URL",
                company_invite_member_title: "Invite members",
                company_manage_seats_title: "Manage seats",
                company_not_found: "Can't find your team",
                company_plan: "{{planName}} {{periodicity}} Plan",
                company_summary: "Team summary",
                company_summary_billing_cta: "Go to billing",
                duplicates: {
                    delete_duplicates: "Update {{ count }}/{{ total }}",
                    delete_duplicates_cta: "Update",
                    delete_duplicates_subtitle: "These prospects will be deleted from the app of the other members",
                    delete_duplicates_title: "Are you sure?",
                    header: {
                        company: "Company",
                        job: "Job",
                        member: "Member",
                        user_name: "Name",
                    },
                    keep_recommended_duplicates: "Keep all in recommended",
                    keep_recommended_duplicates_cta: "Yes, update",
                    keep_recommended_duplicates_subtitle:
                        "This will keep the prospects into the selected members’ CRM, and delete them everywhere else.",
                    keep_recommended_duplicates_title: "Are you sure?",
                    no_duplicates: "No duplicates",
                    select_member_placeholder: "Select member",
                    subtitle: "Select in which account you want to keep these prospects.",
                    title: "Duplicate{{ plural }} ({{ count }})",
                    tooltips: {
                        partial_profile_explanation:
                            "This prospect comes from a CSV file. Information will be retrieved once you perform an action (visit/follow/invitation/message) for this prospect",
                    },
                },
                duplicates_tabs: "Duplicates",
                inbox: "Inbox",
                inbox_cta: "Add",
                invite: "Invite",
                invite_member_required: "This field is required.",
                invite_member_wrong_format: "Please enter the URL of the LinkedIn profile",
                leave: "Leave the team",
                leave_the_team: "Leave the team",
                leave_the_team_confirm: "Are you sure?",
                leave_the_team_cta: "Yes, leave",
                members: "Member{{ plural }}",
                members_cta: "Manage members",
                name_input_placeholder: "Team name",
                no_company: {
                    card: {
                        items: {
                            subTitle_1: "All your data in one place",
                            subTitle_2: "Share prospects easily",
                            subTitle_3: "This person looks familiar...",
                            subTitle_4: "To help your teammate if they struggle",
                            title_1: "Centralized account management",
                            title_2: "Cross-account lead import",
                            title_3: "Anti-Duplication Security",
                            title_4: "Access to other Team accounts",
                        },
                    },
                    team_trial_cta_card: {
                        cta: "Test Waalaxy with my colleagues",
                        items: {
                            subTitle1: "Track your team's performance in one place",
                            subTitle2: "Manage leads from one account to another in just a few clicks",
                            subTitle3: "Easily switch between accounts and manage their campaigns",
                            subTitle4: "Never contact the same person as another team member",
                            subTitle5: "Set up team roles and campaigns in just one click",
                            title1: "Shared statistics",
                            title2: "Inter-account import and lead transfer",
                            title3: "Simplified collaboration",
                            title4: "Anti-duplicate security",
                            title5: "Manage your team members' accounts",
                        },
                        message: "I would like to try Waalaxy with my team",
                    },
                    title: "You don’t have a Team 👀",
                },
                not_owner_buy_seats_tooltip: "Only the team owner can add extra seats",
                overview_tabs: "Overview",
                owner_invitation_confirm_modal: {
                    continue: "Continue",
                    subtitle: 'You\'ve already sent an invitation to "<strong>{{ displayName }}</strong>" to be the new owner of this team.',
                    title: "You've already sent an invitation",
                    warning: "If you continue, his/her invitation will be cancelled and replaced by this one.",
                },
                owner_invitation_sent: "Owner invitation sent",
                pending_status: "Pending",
                plan_over: {
                    go_to_my_team: "Go to my team",
                    member_texts: {
                        plan_over_text: "Access to Team features is no longer possible. You have been retrograded to Freemium plan.",
                        tip_plan_over: "<strong>Tip</strong>: You can ask the team owner to Upgrade and get your work back on track!",
                        tip_plan_over_normal: "Tip: You can ask the team owner to Upgrade and get your work back on track!",
                    },
                    owner_texts: {
                        plan_over_text: "Access to Team features is no longer possible. All members have been retrograded to Freemium plan.",
                        tip_plan_over: "No worries! You can still <strong>Upgrade your team</strong> and get your work back on track!",
                    },
                    plan_expired_title: "Your team plan has expired",
                },
                remove_member: "Remove member",
                remove_member_cancel_cta: "No, cancel",
                remove_member_cta: "Yes, remove",
                remove_member_subtitle: "You are going to remove ‘{{ displayName }}’ from the team",
                remove_member_title: "Are you sure?",
                remove_owner_invitation_subtitle: "Your invitation will be removed and you will stay the owner of the team.",
                remove_owner_invitation_title: "Remove the owner invitation sent to {{ displayName }} ?",
                rename: "Rename",
                roles: {
                    admin: "Admin",
                    admin_description:
                        "Can add and remove members, update permissions, manage team duplicates, import into and get access to members’ app.",
                    admin_with_icon: "🚀 Admin",
                    custom: "Custom",
                    custom_description: "Define the permission of this member.",
                    custom_with_icon: "✨ Custom",
                    member: "Member",
                    member_description: "Can see other members and access to team analytics.",
                    member_with_icon: "👤 Member",
                    owner: "Owner",
                },
                search_members: "Search members",
                seats: {
                    actions: "actions",
                    actions_in_queue: "actions in queue",
                    credits_used: "credits used",
                    credits_used_tooltip: "Credits used since {{creditUsedSince}}",
                    go_to_account_cta: "Go to account",
                    no_action_in_queue_filter: "No actions in queue",
                    role: "role",
                    user_name: "name",
                },
                see_billing_cta: "See billing",
                settingsModal: {
                    invite_member: {
                        available_seats: "You have {{nbAvailableSeats}} seat{{plural}} available in your team.",
                        no_available_seats: "No seats avaialble.",
                    },
                    members_tab: {
                        title: "Team members ({{membersCount}})",
                    },
                    team_name: {
                        update_btn: "Update name",
                    },
                },
                title: "Team",
                title_as_owner: "Manage your team",
                toasts: {
                    error_accept_ownership_invitation: "An error occurred while changing the team owner",
                    error_appsumo_user_not_compatible:
                        "You cannot add this user to your team because their account was created before the AppSumo offer.",
                    error_cancel_ownership_invitation: "An error occurred while removing the invitation.",
                    error_delete_duplicates: "Error while deleting duplicates",
                    error_fetching_seats: "Error while fetching team members",
                    error_inviting: "Error while sending the invitation",
                    error_inviting_already_in_company: "Invited user already in the Team",
                    error_inviting_already_invited_in_company: "Invited user already pending in the Team",
                    error_inviting_no_empty_seat: "You need to add more seats in order to invite a member",
                    error_keep_recommended_duplicates: "Error while updating duplicates",
                    error_leaving: "Error while leaving the team",
                    error_remove_member: "Error while removing the member",
                    error_rename: "Error when updating your Team name",
                    error_transfer_ownership: "An error occurred while updating your ownership",
                    error_update_permissions: "Error while updating the permissions",
                    error_withdraw_invitation: "Error while withdrawing the invitation",
                    success_accept_ownership_invitation: "You are the new team owner",
                    success_cancel_ownership_invitation: "The invitation has been removed.",
                    success_create_ownership_invitation: "An invitation has been sent to {{ displayName }}.",
                    success_decline_ownership_invitation: "You have declined the invitation to become owner of the team",
                    success_delete_duplicates: "{{ count }} duplicate{{ plural }} have been deleted",
                    success_inviting: "An invitation has been sent to {{ firstName }} on Waalaxy",
                    success_keep_recommended_duplicates: "The duplicates have been updated!",
                    success_leaving: "You left your Team",
                    success_remove_member: "{{ displayName }} has been removed from the team",
                    success_withdraw_invitation: "The invitation to {{ displayName }} has been withdrawn",
                    user_not_found_on_linkedin: "User not found on LinkedIn",
                    user_not_found_on_waalaxy: "User not found. To be able to add this person, ask them to download Waalaxy and create an account.",
                },
                tooltips: {
                    duplicates: "Prospects in common with at least 2 members",
                    invite_member:
                        "The invitation will be sent on Waalaxy. The future member needs a Waalaxy account to receive the invite. Fill in the LinkedIn profile URL of the member to invite in the field below.",
                    select_seat_upgrade_plan: "Select the number of seats you want for your Team",
                },
                transfer_ownership: "Make owner",
                transfer_ownership_modal: {
                    cancel: "Cancel",
                    cta: "Transfer ownership",
                    description_1: "👉 A request will be sent to this member, who will have to accept it to become the new owner.",
                    description_2: "👉 This action will change your status to Member and make you lose your owner rights.",
                    description_3: "👉 Billing data and payment will be transferred to the new captain.",
                    description_title: "What will happen?",
                    title: "Change the team owner",
                },
                update_permissions: "Update permissions",
                update_permissions_subtitle: "Choose what {{firstname}} {{lastname}} is allowed to do",
                want_to_leave_title: "Want to leave the team ?",
                withdraw_invitation: "Withdraw invitation",
                withdraw_invitation_cancel_cta: "No, cancel",
                withdraw_invitation_cta: "Yes, withdraw",
                withdraw_invitation_subtitle: "You are going to withdraw the invitation sent to {{ displayName }}",
                withdraw_invitation_title: "Are you sure?",
                withdraw_owner_invitation: "Remove owner invitation",
            },
            crm_sync: {
                cannot_delete_crm: "This account is used in at least one campaign, and cannot be removed.",
                confirm_remove_content: 'Are you sure to remove "<strong>{{email}}</strong>"?<br />\nThis will unlink this CRM account from Waalaxy.',
                confirm_remove_cta: "Remove the account",
                confirm_remove_title: "Remove this CRM account?",
                crm_integrations: "Integrations",
                ai_connector: {
                    title: "IA Connector (MCP)",
                    description:
                        "Import prospects and add them to campaigns with Claude, ChatGPT and other AI models through the MCP Waalaxy connector",
                    cta: "How to connect ?",
                    link_url: "https://waalaxy-omicron-8ce699a.zuplo.site/mcp-server",
                },
                no_access: {
                    features: {
                        automation: {
                            description: "Don't think about it anymore, let Waalaxy do it",
                            title: "Automate the transfer of your data",
                        },
                        customize: {
                            description: "A precise choice of data to be transferred",
                            title: "Customise the data collected",
                        },
                        productivity: {
                            description: "Enhance your efficiency by syncing your CRM",
                            title: "Increase your productivity",
                        },
                        reduce: {
                            description: "All your data in one place",
                            title: "Reduce manual data entry",
                        },
                    },
                    what_for: "Discover all features",
                    what_for_url: "https://intercom.help/waalaxy/en/articles/13842668-connect-waalaxy-to-your-stack",
                },
                no_crm_presentation:
                    '[noCRM.io](https://www.nocrm.io/?fpr=waalaxy) is an action-based lead management tool designed to help your sales team with their primary goal: convert prospects into customers.\n\n**Link your account in order to send information from your Waalaxy campaigns directly to noCRM.io.**\n\n*Tip: Use a sequence with "CRM Sync" step.*',
                settings_saved: "Settings saved!",
                setup_later: "Setup later",
                switch_modal: {
                    confirm_cta: "Connect a new CRM",
                    confirm_message: "Are you sure you want to <strong>replace {{crmName}} with a new CRM ?</strong> ",
                    current_connection: "You are currently connected to {{crmName}}.",
                    title: "Connect to a new CRM ?",
                    unlink_message: "This will unlink this CRM account from Waalaxy.",
                    warning_message_line1: "Connecting another CRM will automatically disconnect the current one.",
                    warning_message_line2: "This CRM is used in at least one campaign, this action will disable the CRM sync in all your campaigns.",
                },
            },
            email_accounts: {
                account_section: {
                    email_address: "Email address",
                    provider: "Provider",
                    sender_name: "Sender name",
                    subtitle: "Add, edit, or delete your email accounts.",
                    title: "Accounts",
                },
                add_account: "Add an email address",
                cancel: "No, cancel",
                cannot_delete_provider: "This account email is used in at least one campaign and can not be deleted",
                confirm_remove_content_text: "The selected email address will be permanently deleted.",
                confirm_remove_cta: "Yes, remove",
                confirm_remove_title: "Remove this email address ?",
                delete_and_reset_cta: "Got it!",
                edit_display_name_modal: {
                    cancel: "Cancel",
                    input_label: "Sender name",
                    subtitle: "This name will appear as the sender for the address ",
                    title: "Edit the sender name",
                    validate: "Save",
                },
                failed_to_load_providers: "Unable to load email accounts",
                form: {
                    activate_double_auth: "You need to activate double authentication",
                    alias_label: "Email alias",
                    alias_placeholder: "donald.duck-alias@mail.com",
                    email_label: "Email*",
                    email_placeholder: "donald.duck@mail.com",
                    gmail_tutorial_link: "https://blog.waalaxy.com/en/sync-gmail-account-waalaxy/",
                    help_configure_gmail: "How to sync a Gmail account with Waalaxy?",
                    help_configure_outlook: "How to synchronize an Outlook account on Waalaxy ?",
                    help_text_gmail:
                        "You need to activate two-factor authentication and generate an application password to synchronize your Gmail account.",
                    imap_host_label: "IMAP Host*",
                    imap_host_placeholder: "Search on google",
                    imap_port_label: "IMAP Port*",
                    imap_port_placeholder: "xxx",
                    imap_title: "IMAP connection",
                    outlook_tutorial_link: "https://blog.waalaxy.com/en/outlook-waalaxy/",
                    password_label: "Password*",
                    password_placeholder: "Enter your password",
                    sender_name_label: "Sender Name",
                    sender_name_placeholder: "Donald Duck Official",
                    show_advanced_settings: "Advanced settings",
                    smtp_host_label: "SMTP Host*",
                    smtp_host_placeholder: "Search on google",
                    smtp_port_label: "SMTP Port*",
                    smtp_port_placeholder: "xxx",
                    smtp_title: "SMTP connection",
                },
                no_access: {
                    features: {
                        automate: {
                            description: "Choose when your emails are sent",
                            title: "Automated Emailing",
                        },
                        customize: {
                            description: "Get access to a wide range of templates",
                            title: "Customize your email content",
                        },
                        stats: {
                            description: "Know easily what works and what doesn't",
                            title: "Follow your Stats",
                        },
                        sync: {
                            description: "We’ll send your emails on your behalf",
                            title: "Sync your account",
                        },
                    },
                },
                retry_loading_cta: "Retry",
                signature: {
                    delete_modal: {
                        error: "This signature is used in one or more active campaigns and therefore cannot be deleted.",
                        subtitle: "The selected signature will be permanently deleted.",
                        title: "Delete this signature?",
                    },
                    edit_modal: {
                        error_already_used: "A signature with this name already exists",
                        error_empty: "The name cannot be empty",
                        name_input_placeholder: "Signature name",
                        title: "Choose a name for the signature",
                    },
                    error_update: "Error while updating the signature",
                    left_panel: {
                        add_signature: "Add a signature",
                        delete: "Delete",
                        input_label: "Default signature",
                        input_placeholder: "No signature",
                        list_label: "Your signatures",
                        no_signature: "No signature",
                        rename: "Rename",
                    },
                    right_panel: {
                        create_signature: "Create a signature",
                        subtitle: "Add, edit, and organize all your email signatures in one place.",
                        title: "Find your signatures here",
                    },
                    save: "Save",
                    subtitle: "Add your signature at the end of every email you send",
                    success_update: "Signature updated",
                    title: "Signatures",
                },
                reconnect: "Reconnect",
                reconnect_success: "This email address has been connected successfully",
                title: "Manage my email accounts",
            },
            import_history: {
                date_and_time: "Date and time",
                duplicate: "Duplicate",
                false_positives: "False positives",
                import_type: "Import type",
                list: "List",
                list_name_fallback: "List deleted",
                scanned: "Scanned",
                success: "Success",
                title: "Import history",
                tooltip: {
                    duplicate: "Prospects already in a list or team",
                    false_positives: "Prospects deleted via the “Clean my list” feature",
                    scanned: "Total initial prospects",
                    success: "Imported prospects",
                },
            },
            last_report: {
                no_report_available_text:
                    "To perform an import, you need to go to a LinkedIn page (e.g. search results, a profile, your connections page) where there are prospects.",
                no_report_available_title: "You have yet to import prospects",
            },
            my_account: {
                affiliation: {
                    subtitle: "Enter your ambassador’s affiliation code",
                    title: "Affiliation",
                    toasts: {
                        error: "The affiliation code is incorrect. Please try again or ask your ambassador to provide you with the code again.",
                        error_ambassador_banned:
                            "The ambassador you're trying to affiliate with is banned. Therefore, you cannot affiliate with this ambassador.",
                        error_same_company: "You cannot affiliate with this ambassador because it looks like you belong to the same company",
                        success: {
                            advantage_30: "Affiliation benefit applied 🎉. You now have access to 2 month of free trial.",
                            advantage_30_discount:
                                "Affiliation benefit applied 🎉. You now have access to 14 days of free trial and 20% off your future subscriptions.",
                            advantage_50: "Affiliation benefit applied 🎉. You now have access to 1 month of free trial.",
                        },
                    },
                },
                affiliations_benefits: {
                    title: "Pssst, complete your affiliate code below to receive your benefits 👇",
                },
                email_form: {
                    title: "About you",
                },
                email_preference: {
                    btn: {
                        manage: "Manage my email preferences",
                    },
                    subtitle: "Choose the emails you want to receive from us",
                    title: "Email preferences",
                },
                language: {
                    subtitle: "Choose your preferred language to use Waalaxy",
                    title: "Application language",
                },
                title: "My account",
            },
            my_invoices: {
                billing_details: "Billing details",
                cancel_trial: {
                    cta: "Cancel my free trial",
                },
                credits: {
                    credits: "{{paid}} credits + {{free}} free",
                    free_credits: "{{free}} free credits",
                    renewal: "renewal on next {{date}}",
                    title: "Credits Plan",
                },
                current_subscription_plan: "Current subscription plan",
                current_subscription_seats: "{{ count }} seat{{ plural }}",
                description: "Download invoices and manage billing details securely in Stripe.",
                download: "Download",
                list: {
                    amount: "Amount",
                    bill_file: "Invoice",
                    bill_number: "Invoice no.",
                    date: "Date",
                    type: "Type",
                },
                manage_payment: "Manage payments",
                manage_payment_information: "Manage Billing Information",
                next_payment: "Next payment",
                no_product: "No product",
                on_date: "on {{date}}",
                payment_failed: "Payment failed",
                pending: "Payment pending validation...",
                pending_hover: "Payment validation may take up to 5 working days.",
                see_all_invoices_button: "See all my invoices",
                take_break: {
                    cta: "Manage your subscription",
                    subtitle: "Manage your subscription here",
                    title: "Need to take a break?",
                },
                title: "Invoices",
            },
            quota: {
                connect_linkedin: "Invitations",
                edit_quota_subtitle: "Specific limit : Linkedin allows only 200 invitations max. per week",
                edit_quota_title: "Edit your max daily quota",
                email: "Email",
                follow_linkedin: "Follows",
                increase: "Increase daily quotas",
                maximize: "Maximise your results",
                message_linkedin: "Messages",
                message_request: "Message requests",
                restore_default_values: "Restore default values",
                toast: {
                    max_value_too_high: "You have exceeded your max quota. If you're in free plan, you can upgrade to increase this limit.",
                    reset_all_failed: "An error occurred while restoring your maximum daily quotas with the default values",
                    reset_all_success: "Your maximum daily quotas have been restored to their default values",
                    update_max_value_failed: "An error occurred while updating your maximum daily quota of {{type}}",
                    update_max_value_success: "Your maximum daily quota of '{{type}}' has been updated. It will be effective tomorrow.",
                },
                tooltip: {
                    active_tomorrow: "Will be active tomorrow",
                    title_information:
                        "Set the maximum value that your quotas can reach. Each time your quotas are updated, the new value will be between the maximum value and 80% of the maximum value. The modifications will be active tomorrow.",
                },
                type: {
                    email: "Email",
                    linkedin: "LinkedIn",
                },
                upgrade_btn: "Upgrade",
                visit_linkedin: "Profile visits",
            },
            upgrade_plan: {
                addons: {
                    body: {
                        discover_cta: "Discover",
                        discover_url: "https://www.waalaxy.com/linkedin-messaging",
                        suscribe_cta: "Subscribe",
                        text: "LinkedIn messaging, but better. More features and more filters.",
                        title: "Inbox Waalaxy",
                    },
                    title: "Improve your prospecting with add-ons",
                },
                app_sumo_tooltip: "Not available with your AppSumo deal",
                confirm_modals: {
                    access_denied_BF: {
                        message_line_1: "Hello",
                        message_line_2: "There’s a Black Friday offer at 50% off today, so it might be worth updating our subscription.",
                        message_line_3: "I can’t make the change myself — could you handle it for the team?",
                        message_line_4: "Thanks in advance,",
                        message_title: "💬 Message:",
                        subtitle: "Please contact your team captain. They manage purchases for team members.",
                    },
                    access_denied_V2: {
                        message_line_1: "Hello",
                        message_line_2: "I tried to update our subscription, but apparently only you can make this change.",
                        message_line_3: "Insert the desired plan and a strong argument here.",
                        message_line_4: "Could you handle it for us?",
                        message_line_5: "Thanks in advance,",
                        message_title: "💬 Message:",
                        subtitle: "Please contact your team captain. They manage purchases for the team members.",
                    },
                    after_hello_description: "your boss’s name",
                    cancel: "Exit",
                    cta: "Copy the message",
                    cta_clicked: "Copied",
                    title: "Only the team owner can modify the subscription",
                },
                contact_sales: "Talk to Sales",
                featured_plan_header: "x2,5 more results than PRO",
                forever: "forever",
                free_trial: "Current trial",
                get_cart_data: {
                    errors: {
                        current_product_not_found: "Currently owned product not found",
                        failed_to_get_cart_data: "Failed to get cart data",
                        failed_to_get_products_data: "Failed to retrieve products data",
                        failed_to_get_subscription_data: "Failed to retrieve subscription data",
                        invalid_cart_url: "Invalid cart data",
                        maximum_amount_reached: " Amount must be at most €30,000.00 EUR.  Contact us",
                        new_product_not_found: "Upgrade product not found",
                        unknown_error: "Unknown Error",
                        user_has_no_active_subscription: "No active subscription",
                        user_has_no_permission: "No user permission not found",
                        user_permission_mirage_id_missing: "Missing client identifier",
                    },
                },
                instant_upgrade: {
                    errors: {
                        card_declined: "Your card has been declined.",
                        client_has_open_invoices: "You already have an open invoice. You can pay it in Settings > Invoices > Manage my payments",
                        company_not_found: "User company not found",
                        default_payment_method_not_found: "Your default payment method cannot be found",
                        failed_to_get_subscription_data: "Failed to retrive subscription data",
                        invalid_cart_url: "Invalid cart data",
                        start_payment_request_failed: "Payment failed",
                        unknown_error: "Unable to upgrade. Please check your payment information.",
                        unkown_error_plan_change: "Unable to change plan. Please contact support.",
                        user_has_no_permission: "User permission not found",
                        user_permission_mirage_id_missing: "Missing client identifier",
                    },
                    sucess_plan_change: "You've change plan successfully 🎉",
                },
                invitations_quota_by_month_without_count: "invitations per month",
                month: "month",
                my_plan: "My plan",
                not_available: "Not Available",
                saving: "Save {{amount}}%",
                title: "Join Waalaxy - best prices in the galaxy 😎",
            },
            working_hours: {
                active: "Currently active",
                days: {
                    friday: "Friday",
                    monday: "Monday",
                    saturday: "Saturday",
                    sunday: "Sunday",
                    thursday: "Thursday",
                    tuesday: "Tuesday",
                    wednesday: "Wednesday",
                },
                global: "Daily custom mode",
                inactive: "Not active",
                input: {
                    from: "From",
                    to: "To",
                },
                subtitle: "Choose when you want your Waalaxy actions to be sent",
                timezone: "Select time zone",
                workingDays: "Select Working days",
                zeroDays: "No day selected",
            },
        },
    },
    paused: "Paused",
    pending_payment_modal: {
        button_text: "Regularize my payment",
        description: "You must regularize this payment to be able to make changes to your plan or options again.",
        reminder_text: "💡 Remember to refresh this page once the adjustment has been made.",
        title: "You have a payment pending settlement",
    },
    period_filters: {
        all_time: "All time",
        last_30_days: "Last 30 days",
        last_3_months: "Last 3 months",
        last_7_days: "Last 7 days",
        last_day: "Today",
        last_month: "This month",
        more: "More...",
        this_week: "This week",
    },
    periodicity: {
        lifeTime: "Lifetime",
        monthly: "Monthly",
        quarterly: "Quarterly",
        yearly: "Yearly",
    },
    phoneVerification: {
        error: {
            cancel: "Something didn't work on our side, please refresh the page and try again",
            resend: "Unable to resend verification code. Please try entering your credentials again",
            verification: "Wrong verification code. Please try again",
        },
        success: {
            resend: "Verification code resent by phone",
            verification: "Phone number verified!",
        },
    },
    plan: "plan",
    plan_comparison_modal: {
        best_value: "Best value",
        current_plan: "Current plan",
        email: {
            plans: {
                advanced: {
                    description: "Access to LinkedIn only.",
                    features: {
                        linked_in_prospection_only: "LinkedIn prospection only",
                        quota: "800 monthly invitations max",
                    },
                    features_title: "Limited features",
                },
                business: {
                    description: "Maximize responses by combining LinkedIn and email. No prospect is left behind.",
                    features: {
                        automated_email_campaigns: "Automated emails campaigns",
                        collaboration: "Team collaborations & Multiple senders",
                        credits: "500 free Email Finder credits",
                        quota: "800 monthly invitations max",
                    },
                    features_title: "Unlimited features and quotas",
                },
                freemium: {
                    description: "Discover Waalaxy: 80 invitations per month. That's it.",
                    features: {
                        follow_up_messages: "Automated follow-up messages",
                        quota: "80 monthly invitations max",
                    },
                    features_title: "Free, but (very) limited features",
                },
                pro: {
                    description: "Take the time to expand your network.",
                    features: {
                        crm_sync: "CRM Synchronisation",
                        quota: "300 monthly invitations max",
                    },
                    features_title: "Limited features",
                },
            },
            subtitle: "Maximize your response rate by combining LinkedIn and emails.",
            title: "Need to automate your <highlight>email campaigns ?</highlight>",
        },
        end_free_trial: {
            plans: {
                advanced: {
                    description: "Save time by sending up to 800 invitations per month",
                    features_title: "Everything in PRO, plus...",
                },
                business: {
                    description: "Maximize replies by combining LinkedIn and email. No lead left behind.",
                    features_title: "Everything in ADVANCED, plus...",
                },
                pro: {
                    description: "Start your prospecting with 300 invitations per month.",
                    features_title: "Limited features and quotas",
                },
                freemium: {
                    description: "Discover Waalaxy: 80 invitations per month. That's it.",
                    features_title: "Free, but (very) limited features",
                },
            },
            subtitle: "Prospect 2.5× faster by upgrading to a higher plan",
            title: "Want to unlock <highlight>all features ?</highlight>",
        },
        feature: {
            plans: {
                advanced: {
                    description: "Perfect for quickly expanding your network and outreach — at the best price.",
                    features: {
                        api_keys: "API Keys",
                        mcp: "IA Connector (MCP)",
                        campaign_launch: "Launch campaigns",
                        cloud_sync: "Cloud Solution",
                        crm_sync: "CRM Synchronisation",
                        prospect_refresh: "Refresh prospect status",
                        profiles_auto_import: "Profile Auto-import",
                        quota: "800 monthly invitations max",
                    },
                    features_title: "All features and full quotas",
                },
                freemium: {
                    description: "Discover Waalaxy: 80 invitations per month. That's it.",
                    features: {
                        csv_import: "CSV import only",
                        follow_up_messages: "Automated follow-up messages",
                        manage_prospects: "Manage your prospects",
                        prepare_campaign: "Prepare campaigns (without launch)",
                        quota: "80 monthly invitations max",
                    },
                    features_title: "Free, but (very) limited features",
                },
                pro: {
                    description: "Ideal if you have a strong LinkedIn network and want to turn your connections into conversations.",
                    features: {
                        campaign_launch: "Launch campaigns",
                        cloud_sync: "Cloud Solution",
                        crm_sync: "CRM Synchronisation",
                        prospect_refresh: "Refresh prospect status",
                        profiles_auto_import: "Profiles Auto-import",
                        quota: "300 monthly invitations max",
                    },
                    features_title: "Limited features and quotas",
                },
                business: {
                    description: "Maximize replies by combining LinkedIn and email. No prospect is left behind.",
                    features: {
                        automated_email_campaigns: "Automated emails campaigns",
                        collaboration: "Team collaborations & Multiple senders",
                        credits: "500 free Email Finder credits",
                        quota: "800 monthly invitations max",
                    },
                    features_title: "Maximum power",
                },
            },
            subtitle: "Increase your productivity by upgrading to a higher plan",
            title: "Need to unlock <highlight>all features ?</highlight>",
        },
        freemium_plan_price_details: "forever",
        freemium_price: "Free",
        paid_plan_price_details: "per user, per month",
        plans: {
            freemium: {
                title: "Freemium",
            },
            pro: {
                title: "Pro",
            },
            advanced: {
                title: "Advanced",
            },
            business: {
                title: "Business",
            },
        },
        quota: {
            plans: {
                advanced: {
                    description: "Save time by sending up to 800 invitations per month",
                    features: {
                        crm_sync: "CRM Synchronization",
                        csv: "CSV Imports and Exports",
                        offline_mode: "Offline mode",
                        quota: "100 invitations per day",
                    },
                    features_title: "Boosted quotas !",
                },
                freemium: {
                    description: "Discover Waalaxy: 80 invitations per month. That's it.",
                    features: {
                        quota: "3 quotas per day per action",
                    },
                    features_title: "Free, but limited features",
                },
                pro: {
                    description: "Start your prospecting with\n300 invitations per month",
                    features: {
                        crm_sync: "CRM Synchronization",
                        csv: "CSV Imports and Exports",
                        offline_mode: "Offline mode",
                        quota: "11 invitations per day",
                    },
                    features_title: "A few quotas...",
                },
                business: {
                    description: "Maximize replies by combining LinkedIn and email. No prospect is left behind.",
                    features: {
                        automated_email_campaigns: "Automated emails campaigns",
                        collaboration: "Team collaborations & Multiple senders",
                        credits: "500 free Email Finder credits",
                        quota: "800 monthly invitations max",
                    },
                    features_title: "Maximum power",
                },
            },
            subtitle: "Multiply your opportunities by prospecting 2.5 times faster",
            title: "Want to boost your prospecting with higher <highlight>quotas ?</highlight>",
        },
        see_all_features: "See all features",
        see_all_plans: "View all plans & features",
        upgrade_cta: "Upgrade to {{plan}}",
    },
    plan_feature: "{{plan}} plan feature",
    plan_transfer: {
        button: "Transfer",
        title_1: "ProspectIn User?",
        title_2: "Transfer your data and your plan!",
        title_2_data_only: "Transfer your data!",
        title_2_plan_only: "Transfer your plan!",
        toast_error: "Something went wrong... looks like your case is special, please contact the support team!",
        toast_info: "You can access this feature in the settings",
        toast_success: "Your ProspectIn plan has been successfully transferred to Waalaxy!",
    },
    policy: {
        privacy: "https://www.waalaxy.com/use-of-data",
        termsAndConditions: "https://www.waalaxy.com/terms-conditions",
    },
    post_url_input: "Enter the URL of the post",
    postponed: "Postponed",
    premium_ad: {
        text: "Unlock all the features",
        title: "Subscribe",
    },
    premium_restrictions: {
        email: {
            analytics: "Manage e-mails analytics",
            automation: "Manage e-mails automation",
        },
    },
    preview: "Preview",
    previous: "Previous",
    pricing: "Pricing",
    product_improvements: {
        column_prospect_list_description_1: "Add prospects to a campaign and find their professional email with one click.",
        column_prospect_list_description_2: "Show or hide columns in the view editor 👇",
        column_prospect_list_video_url: "https://my-public-bucket-prod.s3.eu-west-1.amazonaws.com/prospect_list_new_columns_en.mp4",
        cta: {
            got_it: "Got it",
        },
        import_with_email: "New on CSV import: Now you can import emails in addition to LinkedIn URLs!",
        new: "New",
        redo_world_template_questionnaire:
            "Your questionnaire answers allowed us to better filter the campaign templates ⚡\n\nChanging your objective? No worries, redo the questionnaire to refine your search.",
        sentiment_filter: "New: Waalaxy's AI analyzes your prospects' answers to identify those who are interested!",
    },
    prospect: "Prospect{{plural}}",
    prospect_detail: {
        choose_a_status: "Choose a state",
    },
    prospect_list_input_placeholder: "Name your list",
    prospect_origin: {
        affiliate_import: "Ambassador Import",
        ai_enrich: "AI Prospect Finder",
        automatic: "Auto-import",
        csv: "CSV",
        first_relations_import: "First relations import",
        follow_up_webhook: "Follow Up LinkedIn Webhook",
        group_import: "LinkedIn Group",
        import: "Import",
        lead_generator: "Lead Generator",
        linkedIn: "LinkedIn Search",
        make: "from Make",
        mcp: "from MCP",
        n8n: "from n8n",
        post_comments: "Linkedin Post",
        post_reactions: "Linkedin Post",
        prospect_batch: "Prospect list",
        post_reposts: "Linkedin Post",
        integration: "Integration",
        prospectin: "ProspectIn",
        recruiter_lite_import: "Recruiter Lite",
        sales_import: "Sales Navigator Search",
        talent: "LinkedIn Recruiter",
        trigger: "Auto-import",
        zapier: "from Zapier",
    },
    prospect_search: "Search a prospect",
    prospect_status: {
        deleted: "Deleted",
        error: "Error",
        finished: "Finished",
        frozen: "Frozen",
        hasReplied: "Has replied",
        has_accepted_invitation: "Invitation accepted",
        has_been_enriched: "Has pro email",
        has_not_accepted_invitation: "Invitation not accepted",
        has_not_been_enriched: "Has not pro email",
        has_not_replied: "Not replied",
        has_replied: "Has replied",
        has_replied_interested: "Interested",
        has_replied_later_interested: "To follow-up",
        has_replied_not_interested: "Not interested",
        interested: "Interested",
        later_interested: "To follow-up",
        not_interested: "Not interested",
        paused: "Paused",
        postponed: "Postponed",
        stopped: "Exited",
        traveling: "Ongoing",
    },
    prospect_status_reason: {
        account_blocked:
            "The sending of invitation with notes are reserved for LinkedIn Premium users. You can remove the connection note, and add back your prospects in the campaign.",
        action_creation_failed_duplicate_action: "We tried to create an action in the queue, but there was already the same action in the queue. ",
        already_connected: "This prospect can’t receive an invitation because you’ve already invited them.",
        already_pending: "This prospect can’t receive a connection request, because they already have a pending invitation.",
        cant_get_content_reference: "The email could not be sent because we couldn’t retrieve its content.",
        connect_limit_reached: "The limit of 200 invitations/week imposed by Linkedin has been reached. Your actions will resume early next week.",
        connect_note_restricted:
            "Since a recent update, only LinkedIn Premium members can include notes in their invitations. Your invitations are on hold, you can relaunch them from the 'Campaign list' page",
        could_not_send_to_any_context_urn: "The monthly quota set by LinkedIn for message requests has been reached.",
        couldnt_send_message_request_to_any_of_the_contextUrns: "You’re not allowed to send message requests. ",
        couldnt_send_to_any_context_urn: "You have reached the maximum number of message requests you can send this month.",
        create_contact_failed: "We couldn’t create the contact on HubSpot.",
        current_stop_failed: "An error occurred on current step",
        duplicate_traveler: "This prospect has been added several times in the campaign, and the duplicate has been kicked out of the campaign.",
        email_bounced: "Email not delivered (bounced)",
        email_failed_to_send: "Email failed to send",
        email_failed_to_send_self_signed_certificate: "The email address used is not safe, please use another email address. Please contact support.",
        email_replied: "Email replied",
        enrichment_failed_to_send: "Email finder failed to send",
        error_fetching_content: "An error occurred with the template of your message. Please contact support team for more information.",
        error_fetching_content_service_unavailable: "The message could not be sent because we couldn’t retrieve its content.",
        error_occured: "An error has occurred while executing this action.",
        failed_to_fetch_attachments: "An error has occurred when sending the attachment. Please contact support team.",
        failed_while_creating_monitored_email: "An error has occurred while executing this action.",
        hubspot_contact_limit_reached: "You have reached the maximum number of prospects in your HubSpot account. ",
        interpolation_failed: "The message could not be sent due to an error in the variable(s) used. Please contact support.",
        invalid_to: "No mail found",
        linkedin_action_failed_to_execute: "LinkedIn action failed to execute",
        mailbox_inactive: "The email could not be sent because the account used is not active anymore.",
        member_is_restricted: "The prospect has been banned on LinkedIn, or has blocked you.",
        message_action_expired: "We tried to send a message, but this message has already been sent to the prospect.",
        no_context_urn_found: "This prospect can’t receive a message request because they do not share a group or an event with you. ",
        no_success: "We couldn’t retrieve the content of the message, the note or the email. ",
        not_connected_anymore: "This prospect can’t receive your message because he’s not in your network.",
        prospect_already_received_message: "Prospect already received this message",
        prospects_campaign_limit_reached:
            "You have reached the maximum number of prospects in this campaign (5,000). Prospects will progress through the campaign as others exit. In the meantime, you can launch a new campaign or free up space by removing prospects",
        prospects_campaign_limit_reached_freemium:
            "You have reached the maximum number of prospects allowed in this campaign. Upgrade your plan to add up to 5,000 prospects.",
        reinvite_three_weeks_delay:
            "After deleting a pending invitation, you need to wait for three weeks before being able to send a new invitation.",
        could_not_get_email_attachment: "We could not get the email attachment",
        send_mail_error_invalid_login: "We could not send the email because your credentials have changed. ",
        send_message_failed:
            "We couldn’t send the message. This can happen if you have deleted the conversation, or if the prospect has not the right connection status.",
        status_unknown: "The prospect status is unknown. To retrieve it, add the prospect into a visit or follow sequence.",
        stop_was_failed_but_traveler_is_still_traveling: "An error has occurred while executing this action.",
        this_profile_cant_be_accessed: "Unable to access prospect profile (i.e. profile deleted, URL changed, account blocked)",
        timed_out: "The prospect has been in the campaign for more than 30 days without moving: he has been exited automatically from the campaign.",
        webhook_failed_to_send: "Webhook failed to send",
    },
    prospectin_transfer: {
        data_transfer: {
            item_1: "Prospect lists",
            item_2: "Message templates/invitation notes",
            item_3: "Tags",
            title: "Transfer my data",
            toasts: {
                finished: "ProspectIn data has been transferred",
                progression_text: "ProspectIn Data transfer progression",
                progression_title: "Transfer progression",
            },
        },
        plan_transfer: {
            text: "Be aware, you will lose your plan on ProspectIn.",
            title: "Transfer my plan",
        },
        submit_button: "Transfer",
        title: "Please note that the scenarios and the history of the prospects will not be kept.",
    },
    prospects: "Prospect{{plural}}",
    prospects_secondary_menu: {
        add_list_button: "Add list",
        all_prospects: "All prospects",
        search: {
            clear: "Clear search",
            no_result_text: "Try adjusting or clearing the keywords to display better results.",
            no_result_title: "No results found 😿",
        },
        sort: {
            alphabetical: "Alphabetical (A-Z)",
            recently_created: "Recently created",
            recently_updated: "Recently used",
        },
        sort_by: "Sort by:",
        title: "Lists",
    },
    provider_picker: {
        create_provider: "Add a mail account",
    },
    queue: "Queue",
    queue_delete_confirm: {
        cancel: "No, cancel",
        confirm: "Yes, delete",
        dont_show_again: "Don't show this message again",
        text_action_paused: "By removing this action from the queue, it will be paused.",
        text_prospect_remain_campaign: "The prospect will remain in your campaign, until you relaunch the action.",
        title: "Are you sure you want to delete this action from the queue ?",
    },
    quick_launch: {
        browse_all_campaign_models: "All campaign models",
        category: {
            last_models_used: "Last models used",
        },
        dropdown: {
            email_finder_variant: "Find Emails",
            template_variant: "Explore all templates",
        },
        errors: {
            interpolation:
                "/!\\ One or more variables are incorrect. Please check what you have put between braces, and prefer to use the button to insert a variable to avoid errors /!\\ ",
        },
        form: {
            auto_import: {
                already_added: "Already existing auto import",
            },
            campaign_delay: {
                breadcrumbSubTitle: "Wait for",
                breadcrumbTitle: "Delay",
                cannot_update_after_launch: "Delays cannot be modified after your campaign has been launched.",
                update_take_time: "Updating the delay may take up to 3 hours.",
                connect: {
                    delay_selector: "Wait for <select/> after the invitation is accepted.",
                    sub_title: "Once your prospect has accepted the invitation, choose the time to wait before performing the next action",
                    title: "Edit delay after the invitation",
                },
                delay_is_zero_day: "As soon as their status will be checked (every 2 hours), the prospects will directly go to the next step  ",
                email: {
                    delay_selector: "Wait for <select/> after sending the email.",
                    sub_title: "Once you have sent your email, choose the time to wait before performing the next action",
                    title: "Edit delay after the email",
                },
                email_finder: {
                    delay_selector: "Wait for <select/> after executing the Email Finder.",
                    sub_title: "Once you have done your Email Finder, choose the time to wait before performing the next action",
                    title: "Edit delay after the Email Finder",
                },
                follow: {
                    delay_selector: "Wait for <select/> after following the profile.",
                    sub_title: "Once you have followed the profile of your prospect, choose the time to wait before performing the next action",
                    title: "Edit delay after the profile follow",
                },
                message: {
                    delay_selector: "Wait for <select/> after sending the message.",
                    sub_title: "Once you have sent your message, choose the time to wait before performing the next action",
                    title: "Edit delay after the message",
                },
                message_request: {
                    delay_selector: "Wait for <select/> after sending the message request.",
                    sub_title: "Once you have sent your message request, choose the time to wait before performing the next action",
                    title: "Edit delay after the message request",
                },
                visit: {
                    delay_selector: "Wait for <select/> after visiting the profile.",
                    sub_title: "Once you have visited the profile of your prospect, choose the time to wait before performing the next action",
                    title: "Edit delay after the profile visit",
                },
                webhook: {
                    delay_selector: "Wait for <select/> after sending to the CRM.",
                    sub_title: "Once you have sent the data to the CRM, choose the time to wait before performing the next action",
                    title: "Edit delay after the CRM Sync",
                },
            },
            campaign_name: {
                error_name_empty: "Choose a campaign name",
                error_name_taken: "This campaign name already exists",
                stepTitle: "Name your campaign",
            },
            connect: {
                breadcrumbSubTitle: "No note",
                breadcrumbTitle: "Invitation",
                breadcrumbTooltip: "{{count}} prospects will receive an invitation on LinkedIn",
            },
            connect_2_messages_link: "https://blog.waalaxy.com/en/email-enrichment-dropcontact/",
            email: {
                breadcrumbTitle: "Email",
                breadcrumbTooltip: "{{count}} prospects will receive an email",
                stepTitle: "Edit Email",
            },
            email_finder: {
                breadcrumbTitle: "Email Finder",
                breadcrumbTooltip: "{{count}} prospects will be enriched in order to find their email address",
                credits: "Credits",
                description: "(There is nothing to set up here)",
                infos: {
                    text: "When your limit is reached, prospects at the Email Finder step will be frozen until your renewal. ",
                    title: "You have more prospects than credits in your balance",
                },
                stepTitle: "Email finder",
                subtitle: "Retrieve the email addresses of your prospects with Dropcontact",
                tips_card:
                    "The progress of the Email Finder step <strong>is not visible in the queue.</strong> The email search runs in the background.",
            },
            finished: {
                breadcrumbTitle: "Finished",
                breadcrumbTooltip: "{{count}} prospects have finished the campaign",
            },
            follow: {
                breadcrumbTitle: "Follow",
                breadcrumbTooltip: "{{count}} prospects will have their LinkedIn profile followed",
                description: "(There is nothing to set up here)",
                stepTitle: "Follow LinkedIn Profile",
                subtitle: "You will follow the profiles of your prospects with your LinkedIn Account.",
            },
            header_title: "CAMPAIGN CREATION",
            header_title_update: "CAMPAIGN EDITION",
            invitation: {
                button_add: "Yes, add a note",
                button_without: "No, continue",
                no_note_summary: "Invitation with no note",
                note_title: "Edit LinkedIn invitation note",
                stepTitle: "Invitation - Add a note?",
                sub_info: "Did you know? Invitations without notes are accepted 10% more often.",
                sub_title: "You can add a note to personalize your invitation.",
            },
            message: {
                breadcrumbTitle: "Message",
                breadcrumbTooltip: "{{count}} prospects will receive a message on LinkedIn",
                stepTitle: "Edit message",
            },
            message_request: {
                breadcrumbTitle: "Message request",
                breadcrumbTooltip: "{{count}} prospects will receive a message request on LinkedIn",
                preview: "Preview",
                stepTitle: "Edit Message Request",
                sub_title:
                    "A message request is a message you can send to members of the same LinkedIn group or event as you, without needing to be connected with them.",
            },
            previous: "Previous",
            prospect_list: {
                add_prospect: "Add prospects",
                already_added: "This prospect list is already added",
                autoImportStepTitle: "Please select a list to which prospects will be added",
                breadcrumbSubTitle: "{{count}} prospects",
                breadcrumbTitle: "Add prospects",
                conditions_modal: {
                    body1: "You are using the sequence <strong>'{{sequenceName}}'</strong>.",
                    body2: "You can only select prospects matching the following conditions:",
                    title: "Which prospects can enter my campaign?",
                },
                connect_quota_limit:
                    "LinkedIn only allows a maximum of 200 invitations per week.<br />\nTherefore some invitations can be deferred, extending the duration of your campaign.",
                how_to_import: "How to import prospects?",
                import_launched: {
                    description:
                        "You’ve launched an import of prospects! You can continue to set up your campaign while the import is progressing...",
                    success: "Import launched!",
                    title: "Import your leads from a LinkedIn search",
                },
                import_linkedin: {
                    description: "You need to launch an import of prospects from LinkedIn to go to the next step.",
                    open_tab: "Open a LinkedIn Search Tab",
                    title: "Import your prospects from a LinkedIn search",
                },
                import_linkedin_gif: "Import from a LinkedIn search using the Waalaxy extension, and come back here!",
                import_question: {
                    title: "How do you want to add your prospects?",
                },
                no_access: {
                    features: {
                        sales_nav: {
                            description: "Add prospects from a saved list or search",
                            title: "Connected to Sales Navigator",
                        },
                        update: {
                            description: "Enables latecomers to be included in your campaign",
                            title: "Update every 12 hours",
                        },
                        visit: {
                            description: "Add prospects based on what they do on LinkedIn",
                            title: "Visit, Connect, Comment...",
                        },
                    },
                },
                prospect_source_title: "Prospects added history",
                prospects: {
                    button_add_all_with_count: "Yes, add all prospects ({{count}})",
                    button_custom: "No, let me select",
                    custom_title: "Select your prospects",
                    description:
                        "You can choose to select all the prospects on your list who meet the conditions for this campaign, or just some of them.",
                    pro_email: "Only prospects who don’t have a professional email address will be included in the campaign.",
                    title: "Do you want to add all the prospects from this list?",
                },
                select_conditions: "You can only select prospects matching conditions of the sequence <strong>'{{sequenceName}}'</strong>.",
                select_conditions_see_details: "See details",
                selection: {
                    auto_import: "From auto-import",
                    list: "From my lists",
                    regular: "From LinkedIn",
                },
                stepTitle: "Select a list of prospects to add",
            },
            reply_goal: {
                breadcrumbSubTitle: "Send to {{webhookName}}",
                breadcrumbTitle: "CRM sync on reply",
                breadcrumbTooltip: "{{count}} prospects have replied and will be sent to a CRM",
                stepTitle: "CRM sync on reply",
            },
            summary: {
                breadcrumbTitle: "Check Up",
                content: "Your content(s)",
                email_completed: "{{numberEmails}} emails completed",
                email_completed_alone: "1 email completed",
                error_prospects_not_selected: "You must select prospects",
                from_prospect_lists: "{{prospectsCount}} prospects from {{prospectListCount}} lists",
                imports: "{{importNumber}} import",
                keep_open:
                    "You need to keep a <strong> LinkedIn tab & Waalaxy open </strong> for your campaign to run. <br />\nWant it to run offline?  <a> Upgrade for the Cloud feature 👑 </a>",
                lauch_campaign: "Launch my campaign",
                message_request: "1 Message request",
                messages_completed: "{{numberMessages}} messages completed",
                messages_completed_alone: "1 message completed",
                note_completed: "Note completed",
                note_not_completed: "Invitation with no note",
                prospects: "Your prospect(s)",
                prospects_description: "{{prospectsCount}} prospects from {{listName}}",
                respond_automaticly: "Prospects who respond automatically exit the campaign.",
                resume: "Summary of your campaign",
                save_changes: "Update my campaign",
                sequence: "Your sequence",
                stepTitle: "Your campaign is ready to be launched! 🚀",
                triggers: "{{triggersCount}} auto import",
                no_prospects_modal: {
                    title: "This campaign contains no prospects 😯",
                    subtitle: "If you launch it now, no actions can be sent.",
                    line_1: "You can launch it if you wish to add your prospects later (via our API, a colleague's account, etc.)",
                    line_2: "Otherwise, it is recommended to add your prospects before launching it.",
                    add_prospects_button: "Add prospects",
                    launch_anyway_button: "Launch anyway",
                },
            },
            tooltip: {
                import_already_added: "An import is already in progress.",
                nocrm_invalid_form: "The title or description is invalid",
                reply_goal_test_before: 'You need to click on "test" before being able to save',
            },
            visit: {
                breadcrumbTitle: "Visit",
                breadcrumbTooltip: "{{count}} prospects will have their LinkedIn profile visited",
                description: "(There is nothing to set up here)",
                stepTitle: "Visit LinkedIn Profile",
                subtitle: "You will visit the profiles of your prospects with your LinkedIn Account.",
            },
            webhook: {
                breadcrumbSubTitle: "Send to {{webhookName}}",
                breadcrumbTitle: "CRM Sync",
                breadcrumbTooltip: "{{count}} prospects will be sent to a CRM",
                hubspot_description: "Send information about your prospects directly to HubSpot",
                nocrm_description: "Send information about your prospects directly to noCRM.io",
                pipedrive_description: "Send information about your prospects directly to Pipedrive",
                stepTitle: "CRM sync",
                webhook_description: "Send your prospects infos to a custom webhook",
                zapier_description:
                    "Send information about your prospects to Zapier to synchronize with other apps (ex: another CRM, spreadsheets, etc.)",
            },
        },
        next_button: "Next",
        optional: "Optional",
        quick_launch_title: "Quick launch",
        quick_models: "Quick access to models",
        save_changes: "Save Changes",
        add_prospects_later: "Add prospects later",
        webhook: {
            blog: {
                hubspot: "https://blog.waalaxy.com/en/sync-waalaxy-hubspot-zapier/",
                nocrmio: "https://blog.waalaxy.com/en/nocrm-io-synchronization/",
                other: "https://blog.waalaxy.com/en/synchronize-waalaxy-crms/",
                pipedrive: "https://blog.waalaxy.com/en/how-to-sync-waalaxy-with-pipedrive-zapier/",
                salesforce: "https://blog.waalaxy.com/en/synchronize-sales-force/",
                sheet: "https://blog.waalaxy.com/en/synchronize-waalaxy-crms/",
                zoho: "https://blog.waalaxy.com/en/how-to-sync-waalaxy-x-zohocrm/",
            },
            how_to_use: "How to use?",
            open_zapier: "Open in Zapier",
            step1: "STEP 1: Open our Zapier template (or make your own Webhook on any app)",
            step2: "STEP 2: Paste the Webhook URL",
            step2_other: "Paste your Webhook URL",
        },
    },
    quota_left_this_month: "left this month",
    quota_left_today: "left today",
    quotas: {
        upgrade_to_increase: "Upgrade to increase my quota",
    },
    quotas_modal: {
        executed: "Executed",
        next_update: "Next update of quotas",
        resume_credits: "{{credits}} left on {{quota}} daily quota",
        resume_credits_monthly: "{{credits}} left on {{quota}} monthly quota",
        total: "Total quota",
    },
    rate_limit_error: "Too many requests! Please wait a bit and try again later",
    reached_end: "Reached end",
    reaching_server: {
        button: "Contact support",
        text_1: "Wait a few minutes and refresh your page.",
        text_2: "If the problem is not solved, contact our support 👇",
        title: "We cannot reach your planet...",
    },
    recommended: "Recommended",
    refresh_extension: "Refresh extension",
    refresh_linkedin_tabs: {
        open_linkedin_button: "Open a LinkedIn tab",
        title: "Please wait a few seconds. If you have a LinkedIn tab open and cannot access the page, check to see if you have an ad blocker or competing tool. If you do, disable them",
    },
    refresh_page: {
        button: "Refresh",
        title: "Please refresh the page to enter the Waalaxy",
    },
    relationPicker: {
        no_result: "No result found",
    },
    reloading: "Reloading",
    remove: "Remove",
    rename: "Rename",
    reset: "Reset",
    retry: "Retry",
    running: "Running",
    sales_lead_list_picker: "Select a saved list",
    sales_navigator_is_required: "Sales Navigator is required",
    linkedin_recruiter_is_required: "LinkedIn Recruiter is required",
    sales_saved_search_picker: "Select your saved search",
    save: "Save",
    save_changes: "Save changes",
    savedReply: {
        navigation: {
            escape: "esc",
            to_close: "to close",
            to_navigate: "to navigate",
            to_select: "to select",
        },
        search_placeholder: "Search or create a new reply",
        title: "Create a saved reply",
    },
    scheduleMessage: {
        modal: {
            okay: "Okay!",
            reminder: "Re-set a reminder",
            schedule: "Re-schedule a message",
            title: "Schedule a message",
        },
    },
    search: "Search",
    search_tag: "Type to search or create a new tag",
    see_conditions: "See conditions",
    see_how: "See how",
    see_more: "See more",
    see_plans: "See plans",
    select: "Select",
    select_clear: "Clear",
    select_create: "Create",
    select_lead_list: "Select a saved list",
    select_no_options: "No options",
    select_placeholder: "Search...",
    select_prospect_lists_modal: {
        cancel_button: "Cancel",
        select_prospect_list: "Select or create a prospect list",
        select_which_list: "Select the list to import to",
        title: "CSV file import",
        title_csv: "CSV file import",
        title_event: "Event Import",
        title_group: "Group Import",
        title_sales_leads: "Import from a leads list Sales Nav",
        title_sales_searches: "Import from a saved search",
        valid_button: "Confirm",
    },
    select_saved_search: "Select your saved search",
    select_selected: "Selected",
    selected_items_title: "selected",
    sequence_tag: {
        uses_cases: "Use cases",
    },
    settings_page: {
        custom_properties: "Custom properties",
        account_activity: "Account activity",
        cloud: "Cloud",
        crm_sync: "Integrations",
        email_accounts: "Email accounts",
        import_history: "Import history",
        linkedin_account: "LinkedIn Account",
        my_account: "My account",
        my_invoices: "Invoices",
    },
    custom_properties_page: {
        how_to_use_link: "https://intercom.help/waalaxy/en/",
        how_to_use: "How to use these properties ?",
        name: "Name",
        variable: "Variable",
        empty_state: {
            title: "Empty space",
            description: "Create your first custom property",
        },
        delete_modal: {
            title: "Delete this property ?",
            description: "The selected property will be permanently deleted.",
            cancel: "No, cancel",
            confirm: "Yes, delete",
            used_in_campaigns_warning: "This property is used in one or more active campaigns.",
            used_in_campaigns_warning_tips: "Remove the associated variable from the following campaigns and try deleting again afterwards.",
        },
    },
    sidepanel: {
        inbox_conversation: {
            view_conversation: "View conversation",
            new_conversation: "New conversation",
            not_connected_tooltip: "You must be connected with this prospect to send a message",
        },
    },
    sidebar: {
        footer: {
            privacy: "Privacy",
            termsAndConditions: "Terms & Conditions",
        },
        paths: {
            ambassador: "https://ambassadors.waalaxy.com/",
            tutorials: "https://www.youtube.com/watch?v=tFC6Fn3D4jY",
        },
        right_component: {
            tag_new: "New",
        },
        route: {
            ambassador: "Affiliate program",
            campaigns: "Campaigns",
            home: "Home",
            isAlreadyAmbassador: "Ambassador Space",
            linkedin_messenger: "Inbox",
            prospects: "Prospects",
            queue: "Queue",
            sequence_creator: "Sequence creator",
            settings: "Settings",
            team: "Team",
            tutorials: "See Demo",
        },
        sub_route: {
            list_campaigns: "Campaigns List",
            messages_template: "Message Templates",
        },
    },
    sleep: "Delay",
    start_point: "Start point",
    subscribe: "Subscribe",
    subscribe_inbox_form: {
        description: {
            inbox: "Inbox",
            linkedIn_inbox_better: "LinkedIn messaging, only better.",
        },
        preview: {
            by_month: "/month",
            by_month_by_member: "/month by member",
            show_details: "Show details",
            sub_title: "Inbox by Waalaxy",
            title: "Subscribe to Inbox",
        },
    },
    subscription: {
        reactivate: {
            button: "Reactivate subscription",
            description: "You'll lose premium features in {{count}}  day{{plural}}",
            title: "Re-subscribe",
            toast: {
                error: "Failed to reactivate subscription",
                success: "Welcome back! 🎉 Your subscription is live again!",
            },
            tooltip: "Reactivate subscription",
        },
    },
    tags: {
        actions: {
            delete: "Delete",
        },
        confirm_delete: {
            cta_confirm: "Yes, delete",
            text: "Are you sure you want to delete this tag?",
            title: "Delete tag '{{tagName}}'",
        },
        create_tag_name: "Create a new tag : '{{tagName}}'",
        input_placeholder: "Name of the tag",
        no_tag: "No tag",
        required: "The tag name is required",
    },
    templates: {
        "2_emails_invitation_message": {
            description: "Send 2 emails. If prospect is not connected, send an invitation then a message.",
        },
        "3_emails_invitation_message": {
            description: "Send 3 emails. If prospect is not connected, send an invitation then a message.",
        },
        "4_messages_email_finder_4_emails": {
            description: "If connected, send 4 messages. Then search prospect's email and send 4 emails.",
        },
        ad_astra: {
            description: "Visit the LinkedIn profile of your prospects, send an invitation if you are not connected, and find their email addresses",
            short_description: "Visit, send a LinkedIn invitation and find email",
        },
        area_51: {
            description:
                "Visit a prospect to populate his data, find his email. If we find one, email him and then send an invitation-message-message. Useful when you want to start by an email and then follow-up your prospect on LinkedIn.",
            short_description: "Email your prospect and then send an LinkedIn sequence of invitation & messages.",
        },
        arion: {
            description:
                "A basic but powerful LinkedIn campaign, with follow, invitation, message, message. Easy to use and recommended to start with Waalaxy.",
            short_description: "A basic but powerful LinkedIn campaign, with follow, invitation, message, message. Recommended for beginners. ",
        },
        arrival: {
            description:
                "Visit and email finder if you don't have the email. Send a first email, a LinkedIn invitation, then 2 messages if accepted, and 3 emails.",
            short_description: "Visit, Email finder, 1 Email, Invitation, 2 Messages, 3 Emails",
        },
        artemis: {
            description:
                "Visit and search your prospect's email. If found, send it to your CRM, otherwise send an invitation and messages on LinkedIn.",
        },
        auto_import: {
            description: "Can only be used with the auto-import feature. Allow to add prospects to a list without executing any other action.",
        },
        blade_runner: {
            description: "If connected, visit, then if you have the email address, send 4 emails. Otherwise, send 4 messages on LinkedIn",
            short_description: "If connected, visit, then if you have the email address, send 4 emails. Otherwise, send 4 messages",
        },
        blade_runner_invitation: {
            description:
                "Visit, Invitation. If you have the email address, send 4 emails. Otherwise, if the invitation is accepted, send 4 messages on LinkedIn",
            short_description: "Visit, Invitation. If you have the email, send 4 emails. Otherwise, if the invitation is accepted, send 4 messages",
        },
        book_call_demo: {
            description:
                "Objective : Attract a prospect to discuss during a 15mn phone or video exchange\n\nAdvantages: \n\n- Requires little customization\n\nPrerequisites: None",
            message_1: {
                content:
                    "Greetings {\\{firstName}\\}, \n\nIt’s a pleasure to get in touch with you. Given your position, I thought that {[the problem you are solving; e.g., finding new clients]} was an important issue for you. Is this the case? \n\nAt {[your company name; e.g. Waalaxy]}, this is our expertise.\nI would love to discuss this further with you and see how we can help you with this matter.\nYou will find my availability here : {[link to your calendly]}",
            },
            message_2: {
                content:
                    "Hello again {\\{firstName}\\},\n\nWere you able to read my previous message? Is {[the problem you are solving; e.g., finding new customers]} an issue for your company? If so, how do you deal with it?\n\nOther players in your sector such as {[name 3 relevant current clients; ex: AppVizer, Agicap or Axeptio]} had the same issues. By working with us, they have seen an average increase {[key figure; e.g. 30% increase in customer acquisition]}.\n\nSo I would be thrilled to see if together we can achieve the same results for {\\{company.name|}\\}.",
            },
            message_3: {
                content:
                    "I would like to come back to you, yet not intending to be come across as over insistent, I sincerely think that we can contribute to {\\{company.name|}\\} in its problems of {[problematic; ex: \"customer acquisition\"]}\nIf it doesn't seem relevant, let me know, I won't bother us anymore 😀 ",
            },
            short_description: "Attract a prospect to discuss during a 15mn phone or video exchange",
        },
        buzz_lightyear: {
            description: "Visit, invitation. If accepted, Message - Email, if not then Email finder and 2 Emails",
            short_description: "Visit, invitation. If accepted, Message - Email, if not then Email finder and 2 Emails",
        },
        buzz_lightyear_2: {
            description: "Visit, invitation. If accepted, 2 Messages - Email, if not then Email finder and 2 Emails",
            short_description: "Visit, invitation. If accepted, 2 Messages - Email, if not then Email finder and 2 Emails",
        },
        cape_canaveral: {
            description: "If you already have the email address, send 2 emails. Then if you are connected on LinkedIn, send a message",
            short_description: "2 emails then 1 LinkedIn message",
        },
        category: {
            all: "All",
            beginner: "Beginner",
            last_used: "Last used",
            linkedin: "LinkedIn",
            linkedin_plus_email: "LinkedIn + Email",
            recommended: "Recommended",
        },
        chewbacca: {
            description:
                "Visit-Follow-Invitation. Equivalent to Arrow on ProspectIn. The best for having an high converting rate and growing your network.",
            short_description: "Visit-Follow-Invitation. Equivalent to Arrow on ProspectIn.",
        },
        chewbacca_1: {
            description: "Visit-Follow-Invitation-Message",
            short_description: "Visit-Follow-Invitation-Message",
        },
        chewbacca_2: {
            description: "Visit-Follow-Invitation-Message-Message. Perfect for a smooth approach.",
            short_description: "Visit-Follow-Invitation-Message-Message. Perfect for a smooth approach.",
        },
        constellation: {
            description: "Visit - Follow - Invitation - Email Finder. Then send 3 LinkedIn messages if no email found and connected",
            short_description: "Visit - Follow - Invitation - Email Finder. Then send 3 LinkedIn messages if no email found",
        },
        dark_vador: {
            description: "6-message sequence on LinkedIn. This sequence is very useful when you want to spam people. Use it carefully.",
            short_description:
                "6-message sequence on LinkedIn. Very useful if you want to spam people on LinkedIn. Equivalent to Better Call Saul & Silicon Valley on ProspectIn.",
        },
        dark_vador_invitation: {
            description:
                "Send an invitation, then 6 messages on LinkedIn. This sequence is very useful when you want to spam people. Use it carefully.",
            short_description:
                "Invitation then 6-message sequence on LinkedIn. Very useful if you want to spam people on LinkedIn. Equivalent to Better Call Saul & Silicon Valley on ProspectIn.",
        },
        death_star: {
            description: "Send 4 LinkedIn Messages to people you are already connected with.",
            short_description: "4 LinkedIn Messages",
        },
        death_star_invitation: {
            description: "Send a LinkedIn invitation, then 4 Messages if the invitation is accepted.",
            short_description: "Invitation + 4 LinkedIn Messages",
        },
        doctor_who: {
            description: "Send an invitation to your prospects, and find their email addresses",
            short_description: "Send an invitation and find the email",
        },
        e_t: {
            description: "Visit-Follow-Invitation & 3 messages if accepted.",
            short_description: "Visit-Follow-Invitation & 3 messages if accepted.",
        },
        earth_2: {
            description: "Send two emails to your prospect if he has one. Useful if you want to email your 1st relations on LinkedIn for example.",
            short_description: "Send 2 emails",
        },
        earth_3: {
            description: "Send three emails to your prospect if he has one. Useful if you want to email your 1st relations on LinkedIn for example.",
            short_description: "Send 3 emails",
        },
        earth_4: {
            description: "Send four emails to your prospect if he has one. Useful if you want to email your 1st relations on LinkedIn for example.",
            short_description: "Send 4 emails",
        },
        earth_5: {
            description: "Send 5 emails to your prospect if he has one. Useful if you want to email your 1st relations on LinkedIn for example.",
            short_description: "Send 5 emails",
        },
        elysium: {
            description:
                "Send an invitation if you are not connected, and a message if you are. Perfect for lead magnets, using auto-import from a LinkedIn post.",
            short_description: "Send an invitation if you are not connected, and a message if you are. Perfect for lead magnets.",
        },
        elysium_2: {
            description:
                "Send an invitation if you are not connected, then a message. Send two messages if you are already connected. Perfect for lead magnets, using auto-import from a LinkedIn post.",
            short_description:
                "Send an invitation if you are not connected, then a message. Send two messages if you are already connected. Perfect for lead magnets.",
        },
        elysium_3: {
            description:
                "Send an invitation if you are not connected, then 2 messages. Send 3 messages if you are already connected. Perfect for lead magnets, using auto-import from a LinkedIn post.",
            short_description:
                "Send an invitation if you are not connected, then 2 messages. Send 3 messages if you are already connected. Perfect for lead magnets.",
        },
        email_finder: {
            short_name: "Find Emails",
        },
        enrichment_crm: {
            description: "Retrieve your prospects' professional emails and send the data to your CRM automatically",
        },
        europa: {
            description: "Send a LinkedIn message to your prospects, then an email (personal address)",
            short_description: "LinkedIn message + personal email",
        },
        europa_invitation: {
            description: "Send an invitation, a LinkedIn message to your prospects, then an email (personal address)",
            short_description: "Invitation, LinkedIn message + personal email",
        },
        event_horizon: {
            description: "Invitation, then 3 Messages, with possibility of variation if the message has been seen or not seen",
            short_description: "Invitation, then 3 Messages, with possibility of variation if the message has been seen or not seen",
        },
        event_horizon_2: {
            description: "Invitation, then 2 Messages, with possibility of variation if the message has been seen or not seen",
            short_description: "Invitation, then 2 Messages, with possibility of variation if the message has been seen or not seen",
        },
        event_horizon_mail: {
            description: "Invitation, then 3 Messages and 1 Email, with possibility of variation if the message has been seen or not seen",
            short_description: "Invitation, then 3 Messages and 1 Email, with possibility of variation if the message has been seen or not seen",
        },
        event_promotion: {
            description:
                "Objective: Invite people to an event (webinar, conference, other) that might be relevant to them.\n\nNote :  \n\nAdvantages: \n\n- Great way to get a large number of participants to an event you are organizing.\n- Broad and easy-to-use approach\n\nPrerequisites: \n\n- The subject of the event must be relevant to the target\n- The event must provide value (an event to talk only about your solution is not a good idea)\n- For the campaign to be effective, plan at least 2-3 weeks in advance",
            event_link: "registration link",
            event_title: 'title of the event; ex: "How to make Linkedin your #1 source of leads',
            event_topic: "webinar topic; ex: lead generation on LinkedIn",
            message_1: {
                content:
                    'Hello {\\{firstName}\\}, thank you for accepting my invitation.\nI saw that you are {[targeted role; ex: business developer]}. Are you sensitive to the topic of {[webinar topic; ex: lead generation on LinkedIn]}?\n\nWe are organizing an event soon on {[title of the event; ex: "How to make Linkedin your #1 source of leads]}\n\nIf this interests you, here is the registration link: {[registration link]}',
            },
            message_2: {
                content:
                    "Hello {\\{firstName}\\}, did you have time to see my message? Would you be interested in this event?\nIf not, why? \n\nI can't wait to hear from you!",
            },
            short_description: "Invite people to an event (webinar, conference, other) that might be relevant to them.",
            targeted_position: "targeted role; ex: business developer",
        },
        final_space: {
            description: "Send 2 LinkedIn messages to your prospects, then an email (personal address)",
            short_description: "2 LinkedIn messages, then 1 personal email",
        },
        final_space_invitation: {
            description: "Invitation if you are not connected. Then send 2 LinkedIn messages to your prospects, then an email (personal address)",
            short_description: "Invitation, 2 LinkedIn messages, then 1 personal email",
        },
        find_beta_testers: {
            description:
                "Objectives : Find best testers for a online tool \n\nDescription : Designed to find beta testers, you can also use this sequence to find first users or ask feedback about your new website for example \n\nAdvantages : \n\n- asking help is always giving better results than saling something\n\nPrerequisites : \n\n- A well segmented list of prospects\n- An online form to register for beta\n\nLink: \n\n- Learn how to achieve a good search on LinkedIn https://blog.waalaxy.com/en/how-to-master-the-linkedin-standard-search-feature",
            message_1: {
                content:
                    'Hello {\\{firstName}\\},\n \nAs a {[position held; e.g., "freelance"]} how do you handle {[problem the beta solves; e.g., "looking for new assignments"]}?\n\nWe\'re about to launch a solution that allows {[solution; e.g. "to prospect 100 people a week for free on LinkedIn]}.\n\nWe are looking for beta testers, would you be interested?\n\nIf so, register here: {[link to sign up for the beta]}',
            },
            message_2: {
                content:
                    "I forgot to mention that we are looking for all possible feedback from future users. Our goal is to co-construct the solution.\n\nI'm particularly interested in anything to do with {[problem the beta solves; e.g., \"looking for new assignments]}.\n\nThank you in advance for your feedback!",
            },
            message_3: {
                content:
                    "Hello {\\{firstName}\\}, \n\nWere you able to sign up for the beta? Is it relevant to you? If not, could you tell me why?\nYour feedback is precious to us. \n\nThanking you in advance!",
            },
            message_4: {
                content:
                    'The self-imposed deadlines are coming to an end and we still lack feedback from potential users.\n\nIf you have 5 minutes to give me feedback on our {[solution; e.g. "free automated prospecting for solopreneurs"]}, it would be a huge help. 🙏\n{[link to sign up for the beta]}',
            },
            position_held: 'position held; e.g., "freelance"',
            problem_solved: 'problem the beta solves; e.g., "looking for new assignments\n',
            product_link: "link to sign up for the beta",
            product_solution: 'solution; e.g. "free automated prospecting for solopreneurs"',
            short_description: "Find beta testers",
            value_proposition: 'solution; e.g. "to prospect 100 people a week for free on LinkedIn',
        },
        futurama: {
            description: "Visit & 2 messages",
            short_description: "Visit & 2 messages",
        },
        futurama_invitation: {
            description: "Visit - Invitation & 2 messages if accepted",
            short_description: "Visit - Invitation & 2 messages if accepted",
        },
        ganymede: {
            description:
                "Visit, follow and send an invitation. If invitation accepted then send a message, else it will search for your prospect's email and send the details to your CRM if email found.",
        },
        ganymede_simplified: {
            description:
                "Send an invitation. If invitation accepted then send a message, else it will search for your prospect's email and send the details to your CRM if email found.",
        },
        get_feedbacks_product: {
            content_link: 'site link; e.g.: "waalaxy.com"',
            content_type: "what you want feedback on; e.g.: my website",
            description:
                "Objectives :  Get constructive feedback on your product, content, website or anything else \n\nNote : Can potentially lead to a sale: your prospect visit your website and like the value proposition. \n\nAdvantages :  \n\n- give high answer rates because people love to help\n\nPrerequisites : \n\n- a position segmented list of prospects\n\nLink : \n\n- Learn how to achieve a good search on LinkedIn https://blog.waalaxy.com/en/how-to-master-the-linkedin-standard-search-feature",
            message_1: {
                content:
                    'Hello {\\{firstName}\\}, \n\nI just launched {[what you want feedback on; ex: my website]}.\n\nAs a {[prospect\'s position; e.g., "marketing manager"]} I am wondering if you would have 2 minutes to give me feedback on {[what you want feedback on; e.g., "clarity of the value proposition"]}?\n\n{[site link; ex: "waalaxy.com"]}.\n\nThank you in advance for your time!',
            },
            message_2: {
                content:
                    'I would like to ask you again if you had the time to look at the link sent.\n\nWe all need and benefit from feedback to improve, yours would particularly help me a lot.\n\nBy the way, after following the link, what would be the probability on a scale of 1 to 10 that {[what you expect from the product or site; e.g., "work with me on a graphic design service"]}?',
            },
            message_3: {
                content: "Were you able to read my message?",
            },
            prospect_position: 'prospect\'s position; e.g., "marketing manager"',
            question: 'what you expect from the product or site; e.g., "work with me on a graphic design service"',
            short_description: "Get constructive feedback on your product, content, website or anything else ",
            type_of_feedback: 'what you want feedback on; e.g., "clarity of the value proposition"',
        },
        getting_responses_survey: {
            description:
                "Objectives: Getting responses to an online survey \n\nAdvantage : \n\n- perfect for student projects, or to test a startup idea\n\nPrerequisites: \n\n- Be able to identify the right target for your survey\n\nLink: \n\n- Learn how to achieve a good search on LinkedIn https://blog.waalaxy.com/en/how-to-master-the-linkedin-standard-search-feature/",
            message_1: {
                content:
                    'Hello {\\{firstName}\\}, \n\nI am looking for feedback on {[issue associated with your survey; e.g. "the use of automation tools in startups"]}.\n\nI thought you might be the right person to help me. I would be very grateful if you could spare a few minutes to answer this questionnaire.\n\n{[link to questionnaire]}\n\nPS : I have nothing to sell',
            },
            message_2: {
                content:
                    "Hi again {\\{firstName}\\}, \n\nJust to be sure, did you have time to fill out the form?\n\nIf you are not the right person, could you recommend someone in your company who is in charge of this subject?\n\nThank you in advance. ",
            },
            message_3: {
                content:
                    "Please allow me to insist with a last message. The deadline for this survey is coming to an end in 2 days and I haven't had the expected number of responses...\n\nIf you have 5 min to contribute, it would help me a lot 🙏\nThank you! ",
            },
            short_description: "Getting responses to a online survey",
        },
        gravity: {
            description: "Visit the profile and send 4 Messages",
            short_description: "Visit & 4 Messages",
        },
        gravity_invitation: {
            description: "Visit, Invitation & 4 Messages if accepted",
            short_description: "Visit, Invitation & 4 Messages if accepted",
        },
        grow_network: {
            description:
                "Objective: Create new LinkedIn relationships (and more if you like) \n- Easy to use. Ideal to start and understand how Linkedin prospecting works.\n- Works with fairly general prospect lists",
            invitation: {
                content:
                    "Hi there {\\{firstName}\\},\n\nI am looking to expand my network and your profile came up in the LinkedIn suggestions.\n\nI look forward to connecting with you.",
            },
            message_1: {
                content: "Thank you for accepting my invitation {\\{firstName}\\}.\n\nLooking forward to our exchange. ",
            },
            short_description: "Create new LinkedIn relationships (and more if you like)",
        },
        grow_network_alumnis: {
            description:
                'Objective: Quickly increase your network by contacting your school\'s alumni.\n\nNote: The use of a more informal tone is up to you. With Sales Navigator, it is possible to filter by "year of experience" to address a younger target audience with a more informal approach and an older audience with a more formal approach. \n\nAdvantages: \n\n- Gives particularly high acceptance rates.\n- Very helpful to start on LinkedIn when you are a student.\n\nPrerequisites:\n\n- Have a list of profiles that studied in the same school as you.\n',
            invitation: {
                content:
                    "Hello {\\{firstName}\\},\n \nI noticed we both attended {[my school | Example : Harvard]}. I thought to myself that being connected on LinkedIn would be a good idea.\nI will look forward to a friendly exchange with you.",
                my_school: "My school | Example: Harvard",
            },
            message_1: {
                content: "Thank you for accepting me into your network {\\{firstName}\\}! 😁",
            },
            my_school: "my school | Example : Harvard",
            short_description: "Quickly increase your network by contacting your school's alumni.",
        },
        guardians_galaxy: {
            description: "Visit, then if connected, Message-Email-Message, if not then Email (with Email finder)",
            short_description: "Visit, then if connected, Message-Email-Message, if not then Email (with email Finder)",
        },
        guardians_galaxy_invitation: {
            description: "Visit, Follow, Invitation. If connected, Message-Email-Message, if not then Email",
            short_description: "Visit, Follow, Invitation. If connected, Message-Email-Message, if not then Email",
        },
        guardians_galaxy_invitation_2: {
            description: "Visit, Follow, Invitation. If not connected, send an Email (with Email Finder)",
            short_description: "Visit, Follow, Invitation. If not connected, send an Email (with Email Finder)",
        },
        ham: {
            description: "Visit - Invitation. If you want to start automated lead generation, maybe this is where you should begin.",
            short_description: "A simple visit-invitation campaign. Useful to grow your network for a future use.",
        },
        heavenly: {
            description: "Visit-Invitation. Message+Mail x4 if accepted, Email Finder then Mail x4 if not",
            short_description: "Visit - Invitation. Message+Mail x4 if accepted, Email Finder then Mail x4 if not",
        },
        heavenly_first_degree: {
            description: "Send 1 message + 1 email to your network, 3 times if no reply",
            short_description: "Send 1 message + 1 email to your network, 3 times if no reply",
        },
        interstellar: {
            description: "Send 3 LinkedIn messages, can vary the content depending on whether the message has been seen or not",
            short_description: "3 messages, can vary the content depending on whether the message has been seen or not",
        },
        interstellar_invitation: {
            description: "Invitation then sequence of 3 messages. Possibility to adapt the content if the prospect has seen your message or not",
            short_description: "Invitation then sequence of 3 messages",
        },
        invitation_2_messages_2_emails: {
            description: "Invitation, then send 2 messages on LinkedIn, and 2 emails (personal address)",
            short_description: "Invitation, then send 2 messages and 2 emails (perso)",
        },
        invitation_enrichment_webhook_message: {
            description:
                "Send an invitation, then find the email and send all available data to your CRM. If the prospect accepts the invitation, send a message.",
        },
        invitation_message_email_finder_2_emails: {
            description: "Invitation, then 1 message - 2 emails if accepted, 2 emails if not accepted.",
            short_description: "Invitation, then 1 message - 2 emails if accepted, 2 emails if not accepted.",
        },
        james_webb: {
            description: "Visit and find email. If email found send 2 emails, else send an invitation then 2 messages",
        },
        jar_jar_binks: {
            description: "Send 3 messages and 4 emails to people you are connected with",
            short_description: "Send 3 messages and 4 emails",
        },
        jar_jar_binks_2: {
            description: "Send 4 messages and 3 emails to people you are connected with",
            short_description: "Send 4 messages and 3 emails",
        },
        job_seeker_hunting: {
            description:
                "Objective: To contact people looking for a specific job\n\nAdvantages: \n\n- Effective because it allows us to target people with very specific needs (finding a job)\n\nPrerequisites:\n\n- Need to clearly identify the type of position sought for the approach to be relevant\n- LinkedIn Recruiter (Lite) is highly recommended",
            invitation: {
                content:
                    "Hello {\\{firstName}\\},\n\nI saw that you were looking for a {[type of position sought; e.g. web developer]}. Is this still the case?\nIf so, I would be happy to present to you an offer we have for this type of position at {[your company; ex: Waalaxy]}",
            },
            job_offer_link: "link to job posting; ex: https://www.welcometothejungle.com/fr/companies/waapi",
            job_offer_title: "type of position sought; e.g. web developer",
            message_1: {
                content:
                    "Thank you for accepting my application. I am led to believe that the position of {[type of position sought; e.g. web developer]} at our company may interest you.\nSee the job post for this position attached below: {[link to job posting; ex: https://www.welcometothejungle.com/fr/companies/waapi]}\nI invite you to come back to me if you have any questions, I am here to answer them.\nHave an excellent day.",
            },
            message_2: {
                content:
                    "Hi again {\\{firstName}\\},\n \nWere you able to read the offer I sent you? Does it correspond to what you are looking for?\nIf so, would you be open to discussing it?\nI am available if you have any questions.",
            },
            message_3: {
                content:
                    "{\\{firstName}\\}, As I have not received any feedback from you, I conclude that this offer does not correspond to your search.\n\nIf this situation changes in the future, I invite you to reach out to me.\nSincerely, ",
            },
            my_company: "your company; ex: Waalaxy",
            short_description: "To contact people looking for a specific job",
        },
        job_seeker_hunting_recruitment_agency: {
            description:
                "Objective: To contact job seekers\n\nNote: As the approach is significantly generalized, results may vary.\n\nAdvantages: \n\n- Being very broad it allows one to contact a large panel of candidates looking for a job.\n- ideal to start with Waalaxy as a recruiter.\n\nPrerequisites:\n\n- Need to clearly identify the type of position sought for the approach to be relevant\n- LinkedIn Recruiter (Lite) is highly recommended",
            invitation: {
                content:
                    "Hi there {\\{firstName}\\},\n\nI saw that you were looking for a new job. Would you like to tell me more about this?\nI am certain that among the offers proposed by our recruitment agency, some will correspond to your profile.\nI look forward to introducing them to you.",
            },
            job_offer_link: "link with job offers; e.g: https://www.welcometothejungle.com/en/companies/waapi",
            message_1: {
                content:
                    "I am thrilled at the opportunity to assist you in your job search.\nI will need further information to help you:\n- position you're looking for\n- geographical area (or 100% remote?) \n\nThank you for these details. They will help me find a suitable offer.\nYou can also consult the available offers here directly: {[link with job offers; e.g: https://www.welcometothejungle.com/en/companies/waapi]}.",
                job_offer_link: "link to job posting; eg: https://www.welcometothejungle.com/fr/companies/waapi",
            },
            message_2: {
                content:
                    "Hello again {\\{firstName}\\},\n \nI haven't heard back from you. Are you still looking for a position? If so, please feel free to give me more info about the search. I remain confident that I can find an offer that fits.\n\nAlways looking forward to accompanying you in your search,",
            },
            short_description: "To contact job seekers",
        },
        jupiter: {
            description:
                "Send an Invitation, then an email. If the invitation has not been accepted after a certain amount of time, it enriches the prospect to retrieve the address and send the email",
            short_description: "LinkedIn Invitation, then email contact (with or without email enrichment)",
        },
        krypton: {
            description:
                "Send 2 emails to the prospects for whom you already have the email address. Then send 3 messages if you are connected on LinkedIn",
            short_description: "Send 2 emails and 3 messages on LinkedIn",
        },
        krypton_invitation: {
            description:
                "Send 2 emails to the prospects for whom you already have the email address. Then send an invitation and 3 messages on LinkedIn. If the invitation is not accepted, send email.",
            short_description: "Send 2 emails, then send an invitation and 3 messages on LinkedIn",
        },
        laika: {
            description:
                "Laika was the first animal in space. And because the dog is the best human friend, this template is dedicated to contact all your LinkedIn friends, massively.",
            short_description: "A simple LinkedIn message-message campaign. Useful to contact your network.",
        },
        linear_invitation_only: {
            description: "Send an invitation to join your LinkedIn network. If the invitation is accepted, send messages.",
            short_description: "Send an invitation to join your LinkedIn network. If the invitation is accepted, send messages.",
        },
        linear_no_visit_no_invitation: {
            description: "Send messages to your LinkedIn network.",
            short_description: "Send messages to your LinkedIn network.",
        },
        linear_visit_invitation: {
            description: "Visit the profile, then send an invitation to join your LinkedIn network. If the invitation is accepted, send messages.",
            short_description:
                "Visit the profile, then send an invitation to join your LinkedIn network. If the invitation is accepted, send messages.",
        },
        linear_visit_only: {
            description: "Visit the profile, then send messages to your LinkedIn network.",
            short_description: "Visit the profile, then send messages to your LinkedIn network.",
        },
        looking_for_internship: {
            contract_duration: "internship duration ; ex : 6 months",
            current_year: "year; ex: 2022",
            description:
                "Objectif : Find an internship or apprenticeship\n\nAdvantages: \n\n- allows you to create opportunities in a fairly efficient way\n\nNote : Think of this sequence as an aid to opening up opportunities. Not as a why of applying to all your targeted companies.\n\nPrerequisites:\n\n- Have previously identified companies that make sense in your sector/for your job (See our tips for finding a job with Waalaxy)\n- Have a well-optimized LinkedIn profile that clearly indicates your search",
            job_field: "field ; ex: digital marketing",
            job_type: "type of contract you're looking ; ex:  internship or work-study",
            message_1: {
                content:
                    "Thank you for accepting my request.\n\nI am currently looking for an {[type of contract you're looking ; ex:  internship or work-study]} for a duration of {[internship duration ; ex : 6 months]} in {[field ; ex: digital marketing]}.\n\nIn your opinion, what are the 3 keys to a successful search for {[type of contract you're looking ; ex:  internship or work-study]} in {[year; ex: 2022]}\n\nThanking you in advance for your valuable advice.",
            },
            message_2: {
                content:
                    "Hello, \n\nI haven't heard back from you. Maybe you missed my message?\n\nThanking you in advance for your time and attention on this subject. ",
            },
            short_description: "Find an internship or work-study",
        },
        looking_for_job: {
            description:
                "Objective: to find a job \n\nAdvantages: \n\n- allows you to create a network favorable to your research\n\nNote : Think of this sequence as a help to opening up opportunities. Not as a why of applying to all your targeted companies.\n\nPrerequisites:\n\n- Have previously identified companies that make sense in your sector/for your job (See our tips for finding a job with Waalaxy)\n- Have a well-optimized LinkedIn profile that clearly indicates your search",
            invitation: {
                content:
                    "Hello, \n\nI am looking to get in touch with the person in charge of recruiting at {\\{company.name|}\\}.\nAre you the right person? \n\nIf not, could you tell me who to contact?\n\nGrateful and thanking you in advance {\\{firstName}\\}",
            },
            message_1: {
                content:
                    "Thank you for accepting my request. Are you in charge of recruiting?\nIf yes, is your company looking for {[position sought]}?\nIf not, who can I contact to find out more?",
            },
            message_2: {
                content: "Hi again, \n\nI haven't heard back from you. Maybe you missed my message?\n\nThanking you in advance for your time.",
            },
            short_description: "Objective: to find a job",
        },
        looking_for_job_alumnis: {
            alumuni_or_student: '"alumni" if no longer at school, "student" if still at school',
            description:
                "Objectif : Ask the alumni of your school if they have a job for you in their company\n\nDescription : This sequence can very well be adapted to a formal approach if you are not comfortable with the informal approach. \n\nAvantages : \n\n- the school fraternity remains strong and will open some great doors for you. High response rates.\n\nPrerequisites:\n\n- a list of alumni from your school",
            invitation: {
                content:
                    'Hey there {\\{firstName}\\}, \n\nWe both attended {[name of the school; ex: Polytech Montpellier]}. I am currently looking for a {[type of job : ex : "internship" ]}.\n\nWould you happen to know if in your current company, they are looking for {[position sought ; eg: "web developers"]} ?\n\nIf so, could you put me in touch with the right person to further discuss?\nThank you kindly 🙏',
            },
            job_type: 'type of job : ex : "internship" ',
            message_1: {
                content:
                    'Thank you for accepting me {\\{firstName}\\}.\n\nDo you know if your company is recruiting for {[position sought ; eg: "web developers"]} in {[type of job : ex : "internship" ]} ?\n\nIf you can tell me who to contact for more info, that would be great!',
            },
            message_2: {
                content:
                    'Any news? Were you able to find a few minutes to help a {["alumni" if no longer at school, "student" if still at school]} in distress? 😁',
            },
            position_sought: 'position sought ; eg: "web developers"',
            school_name: "name of the school; ex: Polytech Montpellier",
            short_description: "Ask the alumni of your school if they have a job for you in their company",
        },
        looking_person_in_charge: {
            description:
                'Objective : Finding the person in charge of the subject to present them our offer\n\nAdvantages: \n\n- particularly effective when the person in charge is not identifiable by their position\n\nNote: This sequence allows you to initiate a discussion with prospects, by looking for the person in charge of the given subject in the company. It is particularly effective when it is difficult to identify who is in charge of the subject in the company.\nConsequently, if you are looking for the head of partnerships at an incubator, it may not be in their LinkedIn title. We\'ll then search for "manager", "director" or any other employee and ask them to redirect us to the person in charge.\n\nPrerequisites: \n\n- You must be willing to manually contact the person in charge afterwards\n\nLevel: Padawaan\n\nLink: \n\n- See how to qualify your list : https://blog.waalaxy.com/en/how-to-master-the-linkedin-standard-search-feature/',
            invitation: {
                content:
                    "Hello {\\{firstName}\\}, \n\nI am looking for the person responsible for {[your topic; ex: lead generation]} at {\\{company.name|}\\}. I understand that this may very well be you, however, I'm not sure.\n\nCould you confirm this for me?\nLooking forward to hearing from you",
            },
            message_1: {
                content:
                    'Thank you for accepting me. Can you confirm that you are the person in charge of {[your topic; ex: lead generation]} at {\\{company.name|}\\}?\nIf so, I would love to speak with you to understand your current and future issues on this topic, and maybe see if we have ways to {[value contribution/proposition; e.g. "help you increase your customer acquisition x2 or 3"]}\n\nIf you are not the right person, I am truly sorry for the inconvenience. Would you be so kind as to please tell me who I should contact with this matter?\nThanking you in advance!',
            },
            message_2: {
                content:
                    "Hello {\\{firstName}\\}, \n\nI am coming back to you to know if you got my last message correctly.\nLooking forward to your reply. ",
            },
            short_description: "Finding the person in charge of the subject to present them our offer",
            topic: "your topic; ex: lead generation",
            value_proposition: 'value contribution/proposition; e.g. "help you increase your customer acquisition x2 or 3"',
        },
        lord_commander: {
            description: "Visit & 7-message sequence on LinkedIn. Best sequence when you want to spam people. Use it carefully.",
            short_description: "Visit & 7-message sequence on LinkedIn. Use it carefully!",
        },
        lord_commander_invitation: {
            description: " Visit, Invitation & 7-message sequence on LinkedIn. Best sequence when you want to spam people... Use it carefully!",
            short_description: " Visit, Invitation & 7-message sequence on LinkedIn. Use it carefully!",
        },
        mars_visit_version: {
            description:
                "Visit and then Invitation on LinkedIn. Efficient if you want to grow your network with a natural behavior or to populate prospects data from a CSV.",
            short_description: "Visit and then Invitation on LinkedIn.",
        },
        mercure: {
            description: "Send a message to your prospects, and a follow-up if they have not replied",
            short_description: "Message with follow-up",
            short_name: "Invitation + 2 messages",
        },
        mercure_invitation: {
            description: "Connect with your prospects, send them a message and a follow-up if they have not replied",
            short_description: "Invitation, and Message with follow-up",
        },
        messages_emails: {
            description: "If you are connected with your prospect, send LinkedIn messages, then if you have his email address, send emails",
            short_description: "If connected, send messages then emails",
        },
        mooncake: {
            description: "Find email. If email found, send an email. \n",
            short_description: "Find email. If email found, send an email. ",
        },
        mooncake_2: {
            description: "Find email. If email found, send 2 emails. ",
            short_description: "Find email. If email found, send 2 emails. ",
        },
        mooncake_3: {
            description: "Find email. If email found, send 3 emails. ",
            short_description: "Find email. If email found, send 3 emails. ",
        },
        mooncake_4: {
            description: "Find email. If email found, send 4 emails. ",
            short_description: "Find email. If email found, send 4 emails. ",
        },
        neil_armstrong: {
            description:
                "With Neil Armstrong campaign, you can really go to the Moon. But, going to the Moon is not easy. With this campaign, you will have LinkedIn & email touchpoints, depending on email enrichment success.",
            short_description:
                "Expert multi-channel campaign, with multiple LinkedIn & Email touchpoints. Be careful : this is powerful but complex.",
        },
        neptune: {
            description:
                "Connect with your prospects and send them a message. Perfect for sending content from a lead magnet on LinkedIn with auto-import on a post.",
            short_description: "Invitation then Message. Perfect for lead magnets on LinkedIn.",
        },
        neptune_extended: {
            description: "Invitation then message. If connected, send a message.",
            short_description: "Invitation then message. If connected, send a message.",
        },
        neptune_relations_2: {
            description: "Invitation then message. Useful to contact people you are not connected with",
            short_description: "Invitation then message",
        },
        odyssey: {
            description:
                "Visit, Follow, Invitation with your prospect. Send 3 messages if the prospect accepts your invitation, or send 3 emails if they don't accept and you have the email",
            short_description: "Visit, Follow, Invitation. Then 3 messages if accepted, 3 emails if not",
        },
        odyssey_4: {
            description: "Visit, Follow, Invitation. Then send 4 emails depending on the invitation status",
            short_description: "Visit, Follow, Invitation. Then send 4 emails depending on the invitation status",
        },
        odyssey_5: {
            description:
                "Visit, Follow, Invitation with your prospect. Send 5 messages if the prospect accepts your invitation, or send 5 emails if they don't accept and you have the email",
            short_description: "Visit, Follow, Invitation. Then 5 messages if accepted, 5 emails if not",
        },
        odyssey_5_invitation: {
            description:
                "Send invitation to your prospect. Then, send 5 messages if the prospect accepts your invitation, or send 5 emails if they don't accept and you have the email",
        },
        offer_for_profile: {
            description:
                "Objective: Allows you to target people, whether they are currently employed or not, to whom you would have a corresponding job offer to propose. \n\nNote: Very generalist, can be inefficient or give false positives, especially if the segmentation of prospects is not very good. \n\nAdvantages: Very generalist; requires little segmentation\n\nPrerequisite: Have a list of profiles that correspond to the offer you are proposing.",
            invitation: {
                content:
                    "Hello {\\{firstName}\\},\n\nI have a job opening that matches your profile at {[your company name]}. \n\nAre you open to discussing it? (you are not obliged to do anything)\n\nI look forward to presenting you this offer ",
                my_company_name: "your company name",
            },
            message_1: {
                content:
                    "Thank you for accepting me. I gather that you might be interested in the offer for {[type of job offered]}.\n\nWhen would you be available to discuss this? \n\nI'm attaching the offer here, if you'd like to know more: {[job offer link; eg: https://www.welcometothejungle.com/en/companies/waalaxy]}. ",
                job_link: "job offer link; eg: https://www.welcometothejungle.com/en/companies/waalaxy",
                job_type: "type of job offered",
            },
            message_2: {
                content:
                    "Hello {\\{firstName}\\},\n \nHave you had a chance to look at the offer? What do you think about it? Are you still open to discuss it ? \n\nWe're always available to answer any questions you may have. ",
            },
            message_3: {
                content:
                    "I would like to insist a little bit, as I did not get any answer to my previous messages. Could you be interested in this offer? \n\nAs a reminder, we are looking for {[quick description of the position; eg: a web developer to reinforce our technical team]}\n\nI look forward to discussing it. ",
                job_description: "quick description of the position; eg: a web developer to reinforce our technical team",
            },
            short_description:
                "Allows you to target people, whether they are currently employed or not, to whom you would have a corresponding job offer to propose. ",
        },
        orion: {
            description:
                "Visit, then send one or more messages to your prospect. Perfect to mix Connected and Pending prospects in the same campaign",
        },
        pluton: {
            description: "Find the pro email addresses of your prospects (via Dropcontact)",
            short_description: "Visit then find email",
            short_name: "Visit + Email Finder",
        },
        prometheus: {
            description: "Visit - Message on LinkedIn. Send an email if message not seen",
            short_description: "Visit - Message on LinkedIn. Send an email if message not seen",
        },
        prometheus_invitation: {
            description: "Visit - Invitation - Message on LinkedIn. Send an email if message not seen",
            short_description: "Visit - Invitation - Message on LinkedIn. Send an email if message not seen",
        },
        proxima: {
            description: "Expert multi-channel campaign, with multiple LinkedIn & Email touchpoints. Be careful: this is powerful but complex.",
        },
        r2d2: {
            description: "Visit - Invitation then 1 message - 2 emails if accepted, 2 emails if not accepted. ",
            short_description: "Visit - Invitation, then 1 message - 2 emails if accepted, 2 emails if not accepted. ",
        },
        recruiting_IT_profiles_funny: {
            description:
                'Objective: Contact developers with an original approach\n\nNote: May work with other profiles with IT skills and can be adapted as formal or informal accordingly depending on the age of the target. The approach is very broad, and as such results may vary.\n\nAdvantages: \n\n- Original approach that can be effective and differentiating\n\nPrerequisites:\n\n- Accepting to abandon the "formal" framework\n- LinkedIn Recruiter (Lite) is highly recommended',
            invitation: {
                content:
                    'What\'s up {first_name}? \n\nJust kidding, {\\{firstName}\\}. thought that might get your attention. At {[your company; e.g. Waalaxy]}, we do value informality but value talent like those you possess even more. \n\nIn fact, we are currently recruiting profiles like yours. Are you open to discussing it with us?\nPS: We have {[insert major and differentiating advantage; ex: "unlimited leave"]}',
            },
            major_advantage: 'insert major and differentiating advantage; ex: "unlimited leave"',
            message_1: {
                content:
                    'Thank you for accepting me {\\{firstName}\\} 😁\nI wonder... have you accepted me because :\nA) The joke about the {{first_name}}, was utterly brilliant\nB) You really need to find a gig\nC) The benefit {[insert major and differentiating advantage; ex: "unlimited leave"]} really struck a chord\nD) The answer D',
            },
            message_2: {
                content:
                    '"Speech sows, silence reaps." {\\{firstName}\\}, should I infer that contrary to what your LinkedIn profile says, your interests are in agriculture?',
            },
            my_company: "your company; e.g. Waalaxy",
            short_description: "Contact developers with an original approach",
        },
        saturn: {
            description:
                "Visit the profile, send a LinkedIn invitation, then a message. If the invitation has not been accepted after a certain time, it enriches the prospect to retrieve the address and send an email",
            short_description: "Visit, invitation then message on LinkedIn. Email with Enrichment if not accepted",
        },
        saturn_extended: {
            description: "Visit, invitation then messages on LinkedIn. Emails with Enrichment if not accepted",
            short_description: "Visit, invitation then messages on LinkedIn. Emails with Enrichment if not accepted",
        },
        sell_waalaxy_freelances: {
            affiliate_link: "your affiliate link ; eg: https://waalaxy.com/ambassador",
            description:
                "Objective : Sell Waalaxy to freelances and solopreneurs, betting on the free plan\n\nNote : Can be used to sale other tools than Waalaxy  \n\nAdvantages : \n\n- Waalaxy is perfect for freelances\n- can make you a salary with our 50% commission affiliate program\n\nPrerequisites :  \n\n- Join our affiliate program {[https://www.waalaxy.com/ambassador/]}(https://www.waalaxy.com/ambassador/)\n- Be able to identify solopreneurs",
            message_1: {
                content:
                    "Hello {\\{firstName}\\},\n\nIt is a pleasure to join your network :) Did you know that, after managing admin tasks, finding new clients is the main problem for freelancers?\nMost rely on word of mouth and platforms.\n\nThe problem here? \n\nThey have no real control over word of mouth and no way to differentiate themselves on the platforms (which force them to lower their prices).\n\nThere is a third way: prospecting.\n \nI am attaching a tool that allows you to contact 100 qualified prospects per week. For free. In less than 10 minutes a day.\n\nI hope this can help you.\n\n{[ templates.sell_waalaxy_freelances.affiliate_link ]}",
            },
            message_2: {
                content:
                    "{\\{firstName}\\}, did my previous message make sense to you?\n\nIf not at all, I would love to know why 😁\n\nYou already have more demands than you can fulfil? Or perhaps, you think that a free tool that allows you to do this smells like a scam?",
            },
            message_3: {
                content: "{\\{firstName}\\}?",
            },
            short_description: "Sell Waalaxy to freelances and solopreneurs, betting on the free plan",
        },
        sell_waalaxy_job_seekers: {
            affiliate_link: "your affiliate link ; eg: https://waalaxy.com/ambassador",
            article_link: "article link you can shorter with your affiliate key : https://blog.waalaxy.com/en/how-to-find-a-job-on-linkedin/",
            description:
                "Objective : Advise job seeker to use Waalaxy to find a new position \n\nNote : This is a long term strategy. Often students joining a company are asked to implement a tool to automate lead generation. At this moment, they can bring you a lot of money. \n\nAdvantages : \n\n- a job seeker is a future employee that will asks his company to pay for Waalaxy\n- can makes you a salary with our 50% commission affiliate program\n\nPrerequisites :  \n\n- Join our affiliate program https://www.waalaxy.com/ambassador\n- Be able to identify “open to work” people (LinkedIn recruiter recommended)",
            invitation: {
                content:
                    "Hello {\\{firstName}\\},\n\nAre you still looking for a job as indicated in your profile?\n\nI have a partnership with a tool that offers to contact 100 people a week on LinkedIn for free.\n\nSeveral friends of mine have recently found work using it.\n\nWould you be interested?",
            },
            message_1: {
                content:
                    "Thank you for accepting. I guess you might be interested.\n\nThe tool allows you to contact 100 people per week for free for life. With my link, you get 1 month free of the tool with all the premium features (up to 700 people contacted per week). A lot can happen in a month! Just think of everything you did last month. \n\n{[ your affiliate link ; eg: https://waalaxy.com/ambassador ]}\n\nPS: yes I get paid to attract users 😉  and you could too :) ",
            },
            message_2: {
                content:
                    "So, what did you think of the tool? Did it help you in your search?\n\nI'm attaching an article on how to find a job via LinkedIn. It could be useful\n\n{[article link you can shorter with your affiliate key : https://blog.waalaxy.com/en/how-to-find-a-job-on-linkedin/]}",
            },
            short_description: "Sell Waalaxy to job seekers",
        },
        sell_waalaxy_startup: {
            description:
                "Objective : Sell Waalaxy to startups & SMB\n\nNote : Can be use with any other affiliate program\n\nAvantages : \n\n- allows you to generate a significant recurring revenue\n\nPrerequisites :  \n\n- Join our affiliate program {[https://www.waalaxy.com/ambassador/]}(https://www.waalaxy.com/ambassador/)",
            message_1: {
                content:
                    "Hello {\\{firstName}\\}, \n\nIn your opinion, how many qualified leads per week can a person contact in less than 10mn per day, for 0€ per month?\n\nFind out the answer here: {[ your affiliate link; ex: https://waalaxy.com/ambassador ]}",
            },
            message_2: {
                content: "The answer was: 100.\nIs this something that could be relevant for you, in your search for new clients?",
            },
            short_description: "Sell Waalaxy to startups & SMB",
        },
        sell_waalaxy_students: {
            "affiliate_link\n": "",
            affiliate_link: "your affiliate link ; eg: https://waalaxy.com/ambassador",
            description:
                "Objective : Sell Waalaxy to students betting on the free plan\n\nNote : This is a long term strategy. Often students joining a company are asked to implement a tool to automate lead generation. At this moment, they can bring you a lot of money. \n\nAdvantages : \n\n- student are very open to discuss on LinkedIn.\n- can makes you a salary with our 50% commission affiliate program\n\nPrerequisites :  \n\n- Join our affiliate program {[https://www.waalaxy.com/ambassador/]}(https://www.waalaxy.com/ambassador/)\n- Be able to identify students at the end of their studies",
            invitation: {
                content:
                    "Hey {\\{firstName}\\},\n \nI see that you are studying. Studying implies working, and, importantly, work means looking for a job.\n\nAre you planning to find an internship or a job soon?\n\nI have a free tool that might help you. \nPS: It is truly 100% free ",
            },
            message_1: {
                content:
                    "Thank you for accepting me. I work with a tool called Waalaxy that allows you to contact 100 people per week on LinkedIn automatically and without paying a cent.\n\nMaybe this can help you if you plan to look for a job soon?\n\nLooking forward to telling you more! For now, here is the link: {[ your affiliate link; ex: https://waalaxy.com/ambassador ]}",
            },
            message_2: {
                content: "? you were able to check it out? Does it resonate with you?",
            },
            short_description: "Sell Waalaxy to students betting on the free plan",
        },
        share_content_event_attendees: {
            content_link: "content link; ex: https://blog.waalaxy.com/strategie-de-prospection-b2b/",
            content_subject: 'title; ex: "The 5 best prospecting strategies in 2022"',
            description:
                'Objective: distribute high-value content to event participants\n\nNote:  The sequence proposes to send an article but can also be used to share a video or any other content.\n\nExample of use: I contact the participants of the event "Make LinkedIn your main acquisition channel" with an article entitled "The 7 keys to find customers on LinkedIn”\n\nAdvantages : \n\n- No need to send an invitation (As such it may be used in parallel with another sequence with an invitation step)\n- Using event attendees provides accurate targeting. The prospect has already shown an interest in the topic.\n\nPrerequisites: \n\n- The proposed content must be closely related to the theme of the event\n- You must be a participant in the event and extract the profiles from the associated search to use this sequence\n\n\n- How to use this type of sequence https://blog.waalaxy.com/en/linkedin-messages-request/',
            event_name: 'name of event; e.g., "Make LinkedIn your primary acquisition channel"',
            message_1: {
                content:
                    'Hi there {\\{firstName}\\}, \n\nI see that we\'re both attending the {[name of event; e.g., "Make LinkedIn your primary acquisition channel"]}\nWe just released this article on the subject {[title; ex: "The 5 best prospecting strategies in 2022"]}\nI would be really interested to get your feedback on this content {[content link; ex: https://blog.waalaxy.com/strategie-de-prospection-b2b/]}\n\nPS: I do not sell anything :)',
            },
            message_2: {
                content:
                    "So, did you have time to read the article {\\{firstName}\\}?\nWhat did you think?\nIf you haven't found the time yet, no worries I understand. Just keep me posted!",
            },
            message_3: {
                content:
                    "I haven't heard back from you. \nNot enough time? Not relevant to you?\nI am curious to know more about why.\nHope to talk soon. ",
            },
            short_description: "Distribute high-value content to event participants",
        },
        share_content_general: {
            content_link: "content link | ex : https://blog.waalaxy.com/en/prospecting-def-plan/",
            content_topic: "content topic; ex: the 3 new ways to find customers in 2022, without spending a dime",
            content_type: "content type | ex : an article",
            description:
                "Objective: distribute high-value content to a target audience\n\nNote: While this may happen as a positive consequence, this sequence is not directly aimed at selling.\n\nAdvantages: \n\n- Indirect approach, requiring little to no effort (low response rate, few objections or questions)\n- Allows you to position yourself as an expert on a subject with a given target, and distribute your content\n\nPrerequisites:\n\n- High added-value content, available from a clickable link (possibility to host any type of document (video, PDF, etc.) on a Google Drive in order to send the document via a link)\n- A list of prospects who may be interested in the content",
            message_1: {
                content:
                    'Thank you for accepting my invite {\\{firstName}\\},\nI just released {[content type | ex : an article]} on the topic of {[content topic; ex: the 3 new ways to find customers in 2022, without spending a dime]}.\n\nGiven that you are a {[job title ex: "freelance]}, I thought it might be relevant for you.\nI would love to get your feedback on this content.\n{[content link | ex : https://blog.waalaxy.com/en/prospecting-def-plan/]}\nPS : I have nothing to sell',
            },
            message_2: {
                content:
                    "Did you have time to look at the link {\\{firstName}\\}? What did you think of it?\nIf you haven't found the time yet, no worries I understand. And if it's not relevant to you, please feel free to tell me. I won't bother you anymore.",
            },
            short_description: "Distribute high-value content to a target audience",
            targeted_position: 'job title ex: "freelance',
        },
        share_content_group_members: {
            content_link: "content link; ex:https://blog.waalaxy.com/strategie-de-prospection-b2b//",
            content_title: 'title ; ex : "The 5 best prospecting strategies in 2022"',
            description:
                'Objective: distribute high-value content to members of a group\n\nNote:  The sequence proposes to send an article but can also be used to share a video or any other type of content.\n\nExample of use : I contact the members of the group "BtoB Prospection: best practices" with an article "The 7 keys to finding clients on Linkedin".\n\nAdvantages: \n\n- No need to send an invitation (As such it may be used in parallel with another sequence with an invitation step)\n- The use of group members allows for precise targeting. The prospect has shown an interest in the subject already.\n\nPrerequisites: \n\n- The proposed content must be close to the group\'s theme\n- You must be a member of the group and retrieve the profiles from the members\' page\n\nLink: \n\n- How to use this type of sequence https://blog.waalaxy.com/en/linkedin-messages-request/ ',
            group_name: 'name of the group ; ex : "BtoB prospecting: best practices',
            message_1: {
                content:
                    'Hello {\\{firstName}\\}, \n\nI saw that you were also a member of the group {[ back-office.templates.share_content_group_members.group_name]}\nWe just released an article on the subject {[ title ; ex : "The 5 best prospecting strategies in 2022"]}\nI would be really interested in getting your feedback on this content \n{[content link; ex:https://blog.waalaxy.com/strategie-de-prospection-b2b//]}\n\nPS: I promise I am not selling anything ',
            },
            message_2: {
                content:
                    "Did you have time to read the article {\\{firstName}\\}?\n\nWhat did you think? \n\nIf you haven't found the time yet, no worries I understand. Just keep me posted!",
            },
            message_3: {
                content:
                    "I haven't heard back from you yet :(\nNot enough time? Not relevant to you?\nI am curious to know more about why.\nHope to talk soon. ",
            },
            short_description: "Distribute high-value content to members of a group",
        },
        simple_connect: {
            description: "Send a LinkedIn invitation to your prospects, with or without a note",
            short_description: "A simple invitation, with or without a note",
            short_name: "Invitation",
        },
        simple_email: {
            description: "Send an email to your prospect if he has one. Useful if you want to email your 1st relations on LinkedIn for example.",
            short_description: "Send an email to your prospect if he has one.",
        },
        simple_follow: {
            description: "Follow your prospects' LinkedIn profiles",
            short_description: "A simple LinkedIn follow",
        },
        simple_message: {
            description: "Send a LinkedIn message to your prospects. You can only send a message to people you are connected with",
            short_description: "A simple LinkedIn message",
            short_name: "Message (network only)",
        },
        simple_visit: {
            description: "Visit your prospects' LinkedIn profile",
            short_description: "A simple profile visit",
        },
        space_cowboy: {
            description:
                "For prospects in my network. Visit, LinkedIn Message, Email Finder. If the email address is retrieved, send an Email and a Message",
            short_description: "For prospects in my network. Visit, Message, Email Finder. If email address retrieved, 1 Email and 1 Message",
        },
        space_jam: {
            description:
                "Like Michael Jordan, always find a way to score. Send an invitation, and send an email if your prospect has not accepted your invitation",
            short_description: "Send an invitation, and send an email if your prospect has not accepted your invitation",
        },
        space_oddity: {
            description: "Visit-Invitation. If accepted, send a Message, then Email finder and an Email. ",
            short_description: "Visit-Invitation. If accepted, send a Message, then Email finder and an Email. ",
        },
        space_oddity_2: {
            description: "Visit-Invitation. If accepted, 2 Messages, then Email finder and send 2 Emails. ",
            short_description: "Visit-Invitation. If accepted, 2 Messages, then Email finder and 2 Emails. ",
        },
        space_oddity_2_5: {
            description:
                "Visit-Invitation. If accepted, Message and Email finder. If email found, send Email-Message-Email, if not send 2 Messages. ",
            short_description:
                "Visit-Invitation. If accepted, Message and Email finder. If email found, send Email-Message-Email, if not send 2 Messages. ",
        },
        space_oddity_2_5_simplified: {
            description:
                "Visit connected prospects, then Message and Email finder. If email found, send Email-Message-Email, if not send 2 Messages. ",
            short_description:
                "Visit connected prospects, then Message and Email finder. If email found, send Email-Message-Email, if not send 2 Messages. ",
        },
        space_oddity_3: {
            description: "Visit, send 3 Messages, then Email finder and send 3 Emails. ",
            short_description: "Visit, send 3 Messages, then Email finder and send 3 Emails. ",
        },
        space_oddity_3_invitation: {
            description: "Visit-Invitation. If accepted, 3 Messages, then Email finder and send 3 Emails. ",
            short_description: "Visit-Invitation. If accepted, 3 Messages, then Email finder and 3 Emails. ",
        },
        space_wizard: {
            description:
                "Visit, Follow, Invitation. If accepted, send a LinkedIn message to your prospects, then an email (personal address). If not accepted, find the email address and send two emails",
            short_description: "Visit, Follow, Invitation. Then LinkedIn message + email if accepted, Email Finder + 2 emails if not",
        },
        space_wizard_2: {
            description:
                "Visit, Follow, Invitation. If accepted, send a LinkedIn message to your prospects, then 2 emails (personal address). If not accepted, find the email address and send 3 emails",
            short_description: "Visit, Follow, Invitation. Then LinkedIn message + 2 emails if accepted, Email Finder + 3 emails if not",
        },
        space_wizard_3: {
            description:
                "Visit, Invitation. If accepted, send a LinkedIn message to your prospects, then 3 emails (personal address). If not accepted, find the email address and send 3 emails",
            short_description: "Visit, Invitation. Then LinkedIn message + 3 emails if accepted, Email Finder + 3 emails if not",
        },
        spaceflight: {
            description: "Visit, Follow and then Invitation on LinkedIn. Message-Message if connect accepted, find email then Email-Email if not.",
            short_description: "Visit, Follow and then Invitation on LinkedIn. Message-Message or Email-Email.",
        },
        spacetrooper: {
            description: "LinkedIn message, then Email finder",
            short_description: "LinkedIn message, then Email finder",
        },
        spacetrooper_2_invitation: {
            description: "Invitation, 2 LinkedIn messages, then Email finder",
            short_description: "Invitation, 2 LinkedIn messages, then Email finder",
        },
        spacetrooper_3: {
            description: "Visit, Invitation, 3 LinkedIn messages, then Email finder",
            short_description: "Visit, Invitation, 3 LinkedIn messages, then Email finder",
        },
        spacetrooper_invitation: {
            description: "Invitation, LinkedIn message, then Email finder",
            short_description: "Invitation, LinkedIn message, then Email finder",
        },
        spacewalker: {
            description: "Send an email, then a LinkedIn message, then an email, then a LinkedIn message to your 1st relations",
            short_description: "Email, Message, Email, Message to 1st relations",
        },
        spoutnik: {
            description: "Send 3 messages to your relations on LinkedIn. Useful to contact your network.",
            short_description: "Send 3 messages on LinkedIn. Useful to contact your network.",
        },
        star_trek: {
            description: "Visit-Follow-Invitation. If accepted, 2 messages, if not 2 emails. ",
            short_description: "Visit-Follow-Invitation. If accepted, 2 messages, if not 2 emails. ",
        },
        star_trek_simplified: {
            description: "Visit-Invitation. If accepted, 2 messages, if not 2 emails.",
            short_description: "Visit-Invitation. If accepted, 2 messages, if not 2 emails.",
        },
        star_wars_1: {
            description: "Send a message request to members of your groups and events, without having to send an invitation",
            short_description: "Send a message request without having to send an invitation",
        },
        star_wars_1_email: {
            description:
                "Visit and send a message request to members of your groups and events, without having to send an invitation. Then email finder and send an email",
            short_description: "Send a message request without having to send an invitation. Then Visit, Email Finder, and Email",
        },
        star_wars_2: {
            description:
                "Send a message request to members of your groups and events, without having to send an invitation. Then send a follow-up message",
            short_description: "Send a message request without having to send an invitation, then a follow-up message",
        },
        star_wars_3: {
            description:
                "Send a message request to members of your groups and events, without having to send an invitation. Then send 2 follow-up messages",
            short_description: "Send a message request without having to send an invitation, then 2 follow-up messages",
        },
        star_wars_4: {
            description:
                "Send a message request to members of your groups and events, without having to send an invitation. Then send 3 follow-up messages",
            short_description: "Send a message request without having to send an invitation, then 3 follow-up messages",
        },
        start_conversation_formal: {
            description:
                'To obtain a telephone or video appointment to discuss. \\n\nNote: This can lead you to exchange "with almost anyone". Consequently, not very effective for highly targeted prospecting.\n\nAdvantages: \n- Easy to use.\n- Ideal to start understanding how Linkedin prospecting works.\n- Works with broad prospect lists, thus largely applicable to different audiences\n\nPrerequisites:\n\n- None',
            invitation: {
                content:
                    "Hi there {\\{firstName}\\},\n \nYour profile appeared in my LinkedIn suggestions. Therefore, I thought it fitting to add you.\nI would be delighted to connect. ",
            },
            message_1: {
                content:
                    'Thank you for accepting my invitation {\\{firstName}\\}. \nWhat do you say if I suggest a video coffee to get to know each other and maintain a more "human" LinkedIn network?\n\nLooking forward to meeting you.',
            },
            message_2: {
                content:
                    "Hi again {\\{firstName}\\},\n\nI'm contacting you once more because I haven't heard back from you after my previous message. Perhaps you are very busy or simply not interested in an exchange?\n\nWishing you an excellent day! ",
            },
            short_description: "To obtain a telephone or video appointment to discuss.",
        },
        start_conversation_friendly: {
            description: "",
            invitation: {
                content: "Hi {\\{firstName}\\},\n \nYour profile came up in the LinkedIn suggestions. I thought adding you was a good idea 😃",
            },
            message_1: {
                content: "",
            },
            message_2: {
                content: "",
            },
            short_description: "",
        },
        start_conversation_sale: {
            description:
                "Objective: Open a discussion on a topic by taking the prospect's need\n\nAdvantage: \n\n- A qualitative approach that gives good response rates and allows to personalize making first contact\n\nPrerequisites:\n\n- Prospect list by well-qualified position/function\n\nNote:  \n\nCan be time-consuming to manage responses as it leads to high response rates.\n\nLevel: Padawaan\n\nLink: \n\n- Learn how to qualify your list: https://blog.waalaxy.com/en/how-to-master-the-linkedin-standard-search-feature/",
            invitation: {
                content:
                    'Hi there {\\{firstName}\\}, \n\nIf I read your profile correctly, you {[position held; e.g. "are a freelancer" or "run a business"]}.\nOn a daily basis, how much of your time is spent on {[problem you are solving; e.g., "keeping track of your customers\' billing"]}?\n\nTruly looking forward to talking about it with you.',
            },
            message_1: {
                content: "Thank you for accepting my invite. Were you able to see my previous message?",
            },
            message_2: {
                content: "Hi {\\{firstName}\\}, I am coming back to you regarding my message. Were you able to see it?",
            },
            problem_to_solve: 'problem you are solving; e.g., "keeping track of your customers\' billing"',
            prospect_position: 'position held; e.g. "are a freelancer" or "run a business"',
            short_description: "Open a discussion on a topic by taking the prospect's need",
        },
        tags: {
            advanced: "Advanced plan required",
            basic: "Basics",
            business: "Business plan required",
            enrichment: "Email finder",
            linkedin: "LinkedIn",
            message_request: "Message request",
            multi_channel_advanced: "Multi-Channel - Expert",
            multi_channel_basic: "Multi-Channel - Basics",
            one_step: "Beginner",
            pre_filled: "Pre-filled",
            pro: "Pro plan required",
            prospectin_templates: "ProspectIn templates",
            recommended: "Recommended",
            zapier: "Zapier integration",
        },
        tatooine: {
            description: "Visit - 2 Messages - 2 Emails (perso)",
            short_description: "Visit - 2 Messages - 2 Emails (perso)",
        },
        tatooine_invitation: {
            description: "Visit - Follow - Invitation - 2 Messages - 2 Emails (perso)",
            short_description: "Visit - Follow - Invitation - 2 Messages - 2 Emails (perso)",
        },
        test_sales_message: {
            description:
                "Objective: Test a sales message (and why not sell while we are at it?)\n\nNote: Works with any sales message you would like to test. Feel free to variate and see what works best.\n\nLevel: Jedi \n\nAdvantages : \n\n- allows you to have feedback on your prospecting message, ideal when you start\n- subtly opens the conversation to a potential sale\n\nPrerequisites: None",
            general_customer_position: 'job title; e.g. "salespeople"',
            message_1: {
                content:
                    "Greetings {\\{firstName}\\}, \n\nI am trying to improve my prospecting messages and I need your help. What would be the probability of you responding to this message (on a scale of 0 to 10)? If less than 5, why?\n\n”Hello {\\{firstName}\\}, \nAs a {[job title; e.g. salesman ]}, how do you {[ problem to be solved; e.g. source your leads ]}?\nAt {[ your company; e.g. Waalaxy]}, we help {[ job title; e.g. salespeople]} to {[ value proposition; e.g. save time in finding and contacting qualified prospects]} thanks to {[ solution ; ex : a simple and intuitive tool that takes care of 90% of the process in an automated way]}.\nIf this makes sense to you, I would love to further discuss it. Do you have any availability soon?“\n\nThank you in advance for your sincere feedback, it will help me a lot.",
            },
            message_2: {
                content:
                    "Just a quick reminder {\\{firstName}\\} I wanted to know if you had time to look at my message and maybe give me a direct and frank feedback?\n\nI really need to improve my approach but I'm not sure where to start...",
            },
            my_company: "your company; e.g. Waalaxy",
            problem_solved: "problem to be solved; e.g. source your leads",
            prospect_position: 'job title; e.g. "salesman"',
            short_description: "Test a sales message (and why not sell while we are at it?)",
            solution: ' solution ; ex : "a simple and intuitive tool that takes care of 90% of the process in an automated way',
            value_proposition: 'value proposition; e.g. "save time in finding and contacting qualified prospects"',
        },
        thanos: {
            description:
                "Send a LinkedIn invitation, then two messages. If the invitation has not been accepted after a certain time, it enriches the prospect to retrieve the address and send emails. If the LinkedIn messages haven't been replied, send emails.",
            short_description:
                "Invitation then message on LinkedIn. Emails with Enrichment if not accepted, or without enrichment if messages not replied",
        },
        thanos_4: {
            description:
                "Visit profile, send a LinkedIn invitation, then 3 messages. If the invitation has not been accepted after a certain time, it enriches the prospect to retrieve the address and send emails. If the LinkedIn messages haven't been replied, send emails.",
            short_description:
                "Visit, Invitation then 3 messages on LinkedIn. Emails with Enrichment if not accepted, or without enrichment if messages not replied",
        },
        the_100: {
            description: "Visit & 3 messages",
            short_description: "Visit & 3 messages",
        },
        the_100_invitation: {
            description: "Visit - Invitation & 3 messages if accepted",
            short_description: "Visit - Invitation & 3 messages if accepted",
        },
        the_black_star: {
            description: "Visit the profile and send a Message and an Email, three times in a row",
            short_description: "Visit the profile and send a Message and an Email, three times in a row",
        },
        the_black_star_invitation: {
            description: "Visit the profile and send a LinkedIn invitation. Message + Mail x3 if the invitation is accepted",
            short_description: "Visit-Invitation. Message + Mail x3 if the invitation is accepted",
        },
        thomas_pesquet: {
            description:
                "This campaign is dedicated to prospects who have a high enrichment rate. Starting with an email approach and with no answer, you will be able to send an invitation to your prospects directly on LinkedIn.",
            short_description: "Email-based campaign (including enrichment), with some LinkedIn touchpoints at the end. ",
        },
        total_recall: {
            description: "Send 3 LinkedIn messages. If the last one has not been seen, send 2 emails",
            short_description: "3 LinkedIn messages. Then, if not seen, 2 emails",
        },
        use_cases: {
            affiliation: "Affiliation",
            job_application: "Job application",
            networking: "Networking",
            other: "Other",
            promotion: "Promotion",
            recruiting: "Recruiting",
            sales: "Sales",
        },
        visit_crm_sync: {
            description: "Visit the profile, then send to CRM",
        },
        visit_crm_sync_2_emails: {
            description: "Visit, then send data to your CRM and send 2 emails",
        },
        visit_email_finder_email_invitation_message: {
            description:
                "Visit the profile then Email Finder. If email found, send an email, invitation, and message. Else, just send invitation and message on LinkedIn.",
            short_description: "Visit and Email Finder. If email found, send an email, invitation, and message. Else, just invitation and message.",
        },
        visit_email_finder_invitation_2_messages_email: {
            description: "Visit - Email Finder - Invitation. If accepted, send 2 messages then 1 email",
            short_description: "Visit - Email Finder - Invitation. If accepted, send 2 messages then 1 email",
        },
        visit_emailfinder_invitation_message: {
            description: "Visit the LinkedIn profile, find the email address, then send an invitation, and messages if the invitation is accepted",
            short_description: "Visit, Email Finder, Invitation, Message",
        },
        visit_follow: {
            description: "Visit your prospects' LinkedIn profile and follow them after a specific delay",
        },
        visit_follow_email_finder: {
            description: "Visit and Follow the LinkedIn profile of your prospects then find their email addresses",
            short_description: "Visit, follow then find email",
        },
        visit_follow_email_finder_invitation: {
            description: "Visit and Follow the LinkedIn profile of your prospects then find their email addresses and send an invitation",
        },
        visit_follow_invitation_messages: {
            description: "Visit then follow and send an invitation. If the invitation is accepted, then send messages to your prospect.",
        },
        visit_invitation_email_finder_crm_sync_2_messages: {
            description:
                "Visit the profile, send a LinkedIn invitation, then enrich the prospect to retrieve the address, send data to a CRM. If the prospect accepts the invitation, after a certain delay, send  LinkedIn messages. ",
        },
        visit_invitation_email_finder_emails: {
            description: "Visit and connect with your prospects. If the invitation is not accepted, find and send emails.",
        },
        visit_message_email_finder_2_emails: {
            description: "Visit - Message on LinkedIn. Send two emails if message not seen",
            short_description: "Visit - Message on LinkedIn. Send two emails if message not seen",
        },
        visit_webhook_invitation_message: {
            description: "Visit the profile, then export to your CRM and send an Invitation. If accepted, send a message.",
        },
        wall_e: {
            description: "Perfect for beginners, it will bring you a lot of warm leads with a LinkedIn only approach.",
            short_description: "Basic Visit - Message on LinkedIn. Because the most simple campaigns are the most efficient.",
        },
        wall_e_invitation: {
            description: "Perfect for beginners, it will bring you a lot of warm leads with a LinkedIn only approach.",
            short_description: "Basic Visit - Invitation - Message on LinkedIn. Because the most simple campaigns are the most efficient.",
        },
        youri_gagarine: {
            description: "Contact your prospects by email, then if they don't respond, try on LinkedIn",
            short_description: "Contact by email, then on LinkedIn",
        },
    },
    test: "Test",
    test_email: {
        modal: {
            add_additional_content: "Add a message (optional)",
            add_additional_content_info:
                "This text will appear above your initial email, in a separate section. It does not affect the content of the email.",
            back: "Back",
            error_invalid_email: "Enter a valid email address",
            info_text: "Separate the email addresses with commas",
            object: "Subject",
            send_test_email: "Send the test",
            subtitle: "Send a test to",
            title: "Send a test email",
            titlePreview: "Preview",
        },
        preview_cta: "Preview and test",
        toast: {
            error: "Error",
            error_message: "An error occurred while sending the test email.",
            success: "Email sent",
            success_message: "Your test email has been sent successfully",
        },
    },
    tips: "Tips",
    title: "Welcome",

    toast: {
        email_disconnected: {
            button: "Reconnect",
            text: "The email address {{emailAddress}} is disconnected. Reconnect it to resume email sending.",
            text_multiple: "These email addresses are disconnected: {{emailAddresses}}. Reconnect them to resume email sending.",
            title: "Email sending interrupted",
        },
        impersonate: {
            title: "Impersonate",
            error: "You don't have permission to access this member's account",
            error_link: "https://intercom.help/waalaxy/en/articles/10357786-how-to-update-my-team-members-permissions",
            error_cta: "Understanding permissions",
        },
        ai_generator: {
            error: "",
        },
        campaigns: {
            campaign_launched: "The campaign <strong>{{name}}</strong> has been launched!",
            campaign_paused: "Campaign paused",
            campaign_played: "Campaign played",
            campaign_duplicated: "Campaign successfully duplicated",
            campaign_stopped: "Campaign stopped",
            campaign_updated: "Campaign updated",
            draft_deleted: "Draft deleted",
            draft_failed_to_save: "Failed to save",
            draft_saved: "Draft saved",
            email_account_not_found:
                "The email account you are using for this campaign doesn't exist. Please go to an email step and select a valid account.",
            error_no_world_template: "An error has occurred, your campaign data could not be saved. Please refresh your page and try again.",
            error_permission_create_world: "You aren't allowed to use this sequence",
            error_prospects_already_in_campaign: "At least one prospect is already running in a campaign",
            failed_to_duplicate_campaign: "Failed to duplicate campaign",
            error_rename_campaign: "Error while updating the name",
            failed_to_add_prospect: "Failed to add the prospects",
            failed_to_delete_draft: "Failed to delete draft",
            failed_to_fetch_campaign: "Failed to fetch campaign",
            failed_to_fetch_draft: "Failed to fetch draft",
            name_taken: "You already have a campaign with this name",
            prospects_exited: "{{nbProspects}} prospects exited",
            prospects_paused: "{{nbProspects}} prospects paused",
            prospects_played: "{{nbProspects}} prospects played",
            prospects_put_back_in_campaign: "Prospects successfully put back in your campaign!",
            upgrade_to_business: "A Business plan is required",
        },
        can_not_fetch_saved_sales_search:
            "We’re having trouble connecting to Sales Navigator. Please reconnect by opening a Sales Navigator tab from LinkedIn.",
        closeAll: "Close all",
        company: {
            fetch_actions_error: "Failed to retrieve members actions",
            fetch_credits_error: "Failed to retrieve members used credits",
            fetch_error: "An error occurred when fetching team",
            fetch_roles_error: "Failed to retrieve members roles",
        },
        contents: {
            attachments: {
                error_get_attachment: "Unable to retrieve the attachment",
            },
            error_content_created: "Error on content creation",
            error_content_created_same_name: "Content with same name already exist",
            success_content_created: "Template created",
            success_content_deleted: "Content deleted",
            success_content_updated: "Successfully edited",
        },
        conversations: {
            filter: {
                error_fetch_options: "Unable to retrieve filter options",
            },
        },
        error: "Error",
        import_state: {
            done: "Import done",
        },
        info: "Info",
        login_as_failed: "Login failed check email address",
        my_invoices: {
            payment_failed: "Unable to process the payment renewal",
            payment_failed_cta: "Manage payment",
        },
        notifications: {
            accept_success: "You have joined {{company}}",
            decline_error: "Error while refusing the invitation",
            decline_success: "You refused to join {{company}}",
        },
        prospects: {
            bulk_delete_error: "An error occurred while deleting prospects",
            bulk_delete_success: "{{count}} prospect{{plural}} have been deleted",
            error_export_csv: "An error occurred while exporting your CSV. Try with less prospects.",
            error_export_csv_too_many_prospects: "The maximum number of prospects you can export is 50 000.",
            error_import_file: "Error",
            error_move_prospect: "These prospects could not be moved",
            filter: {
                error_fetch_options: "Error while fetching more options.",
                error_load_setup: "Error loading filters setup for prospects.",
            },
            import_comments_choice: "Import people who commented a LinkedIn post",
            import_csv_choice: "Import CSV file",
            import_event_choice: "Import from a LinkedIn event",
            import_group_choice: "Import from a LinkedIn group",
            import_network_choice: "Import from my LinkedIn network",
            import_reactions_choice: "Import people who reacted to a LinkedIn post",
            import_reposts_choice: "Import people who reposted a LinkedIn post",
            import_regular_search_choice: "Import via LinkedIn Search",
            import_regular_cloud_choice: "Import via LinkedIn Search",
            import_first_relation_cloud_choice: "Import from my LinkedIn network",
            import_profile_cloud_choice: "Import from a LinkedIn profile",
            import_group_cloud_choice: "Import from a LinkedIn group",
            import_event_cloud_choice: "Import from a LinkedIn event",
            import_post_comment_cloud_choice: "Import post commenters",
            import_post_reaction_cloud_choice: "Import post reactors",
            import_post_repost_cloud_choice: "Import post republishers",
            import_sales_search_cloud_choice: "Import via Sales Navigator search",
            import_sales_searches_cloud_choice: "Import from a saved search",
            import_sales_leads_cloud_choice: "Import from a leads list",
            import_sales_leads_list_choice: "Import from a leads list",
            import_sales_saved_search_choice: "Import from a saved search",
            import_sales_search_choice: "Import via LinkedIn Sales Navigator",
            import_talent_choice: "Import from LinkedIn Recruiter",
            success_add_to_campaign: "Added in the campaign",
            success_export_crm: "{{count}} prospect(s) exported to your CRM",
            success_move_prospect: "{{count}} prospect(s) moved",
        },
        queue: {
            bulk_delete_error: "An error occurred while deleting your actions",
            bulk_delete_success: "Actions have been deleted",
        },
        settings: {
            emails: {
                toasts: {
                    connection_error: "Connection failed",
                    create_account: {
                        account_creation_failed: "Creation failed. The email already exists on Waalaxy.",
                        imap_failed_to_connect:
                            "It seems that the server is taking too long to respond. Please check that the IMAP information entered are correct, or try again later.",
                        invalid_credentials: "The given credentials are incorrect.",
                        invalid_imap_address: "The connection information for the IMAP server are incorrect.",
                        invalid_smtp_address: "The connection information for the SMTP server are incorrect.",
                        password_required: "The application password is incorrect",
                        smtp_failed_to_connect:
                            "It seems that the server is taking too long to respond. Please check that the SMTP information entered are correct, or try again later.",
                    },
                    create_error: "An error occurred while creating",
                    create_success: "Successfully created",
                    delete_error: "An error occurred while deleting",
                    delete_success: "Deleted successfully",
                    expired_account_email_change:
                        "A disconnected account keeps its email address. To send from another address, add it as a new account.",
                    update_error: "An error occurred while updating",
                    update_success: "Email account updated",
                },
            },
            my_account: {
                error_change_email: "An error occurred in the email change",
                success_change_email: "Your email has been changed",
            },
            my_invoices: {
                failed_to_load_manage_link: "Unable to open the billing portal. Please try again.",
                failed_to_load_manage_link_ask_support: "No billing information found for this account. Please contact support.",
            },
            working_hours: {
                update_error: "An error occurred while updating",
                update_success: "Updated successfully",
            },
        },
        success: "Success",
        tags: {
            add_to_prospects: {
                error: "An error occurred while adding the {{tagName}} tag",
                success: "The {{tagName}} tag has been added",
            },
            create: {
                error: "An error occurred while creating the {{tagName}} tag",
                success: "The {{tagName}} tag has been created",
            },
            delete: {
                error: "An error occurred while deleting the {{tagName}} tag",
                success: "The {{tagName}} tag has been deleted",
            },
            edit: {
                error: "An error occurred while editing the {{tagName}} tag",
            },
            remove_from_prospects: {
                error: "An error occurred while removing the {{tagName}} tag",
                success: "The {{tagName}} tag has been removed",
            },
        },
        trigger_already_exist: "You already have this auto-import in the campaign: '{{name}}'.",
        warning: "Warning",
    },
    today: "Today",
    too_many_extensions_active: {
        help_text_1: "Still not working ?",
        help_text_2: "Talk with the support",
        modal: {
            text: "By clicking on <strong>“Uninstall the old extension”</strong>, you’ll be redirected to the Chrome Store to delete it.",
            title: "How to remove old extension ?",
        },
        text_1: "It seems that you have <strong>two versions</strong> of the Waalaxy <strong>extension</strong> installed. For the best experience, please keep only the new version.",
        title: "Only one extension at a time",
        uninstall_extension: "Uninstall the old extension",
    },
    tooltip: {
        auto_import: "How to use auto-imports?",
        auto_import_link: "https://blog.waalaxy.com/en/scrap-linkedin-profiles/",
        campaign_help: "Learn how a campaign works!",
        campaign_link: "https://blog.waalaxy.com/en/campaign-waalaxy/",
        cant_update_duplicate_security: "You don't have the permission to disable this security",
        dashboard: {
            action_sent: "Actions sent from your campaigns. Can take some time to refresh",
        },
        disabled_in_impersonate_mode: 'Disabled in "logged as" mode',
        duplicate_security: "When it is enabled, you can't import a prospect who is already in the app of another Team member",
        empty_list: {
            empty_contents_list_link_tutorial: "https://www.youtube.com/watch?v=43tB6kqZLjk&list=PLD7QMPI8zqoHHy1tfj8MAMDhModkqNugb&index=9",
            watch_demo: "Watch demo",
        },
        enrichment_email: "Get email addresses of your prospects with Dropcontact (GDPR compliant)",
        learn_more: "Click to learn more",
        link_synchronize_crms: "https://blog.waalaxy.com/en/synchronize-waalaxy-crms/",
        move_duplicates_to_other_list:
            "Enable this option to automatically move leads that are already in one of your lists, to the list you are importing into",
        overwrite_prospect_information:
            "Replaces the information already saved with the data from your CSV file. Only activate this if you wish to update your data.",
        queue: {
            estimated_time_later:
                "You've reached your daily quota. Daily quota are reset every 24 hours on a rolling period. Your quota will reset in {{quota_hours_reset}}h.",
            estimated_time_restrict:
                "You've reached your weekly invitation request quota on LinkedIn. To bypass this limit, send a message request (click to learn more...)",
            estimated_time_restrict_link: "https://www.youtube.com/watch?v=GyAYSLpAbS8&list=PLD7QMPI8zqoHHy1tfj8MAMDhModkqNugb&index=5",
            estimated_time_restrict_message_request: "You've reached your message request quota on LinkedIn.",
            postponed: "The limit of 200 invitations/week imposed by Linkedin has been reached. Your actions will resume early next week.",
        },
        queue_link: "https://blog.waalaxy.com/en/how-does-the-queue-work-on-waalaxy/",
        retro_active_explication: "Check this box if you want to take into account previous data. Leave blank if you want to start from now.",
        retro_active_mandatory: "This option cannot be disabled",
    },
    transfer_prospect_list: "Move to",
    transfer_prospects_list_modal: {
        cancel_btn: "Cancel",
        title: "Move this list to",
    },
    trial_premium_black_friday: {
        active_trial: {
            description: "Upgrade to the higher plan for {{price}} until November 28",
            text_cta: "Try for free",
            title: "Free trial until Black Friday",
        },
        actived_trial: {
            subtitle: "Only a few days left before our Black Friday offer 😎",
        },
        banner: {
            cta: "Try for free",
            description: "No charge at all. Then unlock the exclusive -50% Black Friday offer.",
            title: "Upgrade to the higher plan for {{price}} until November 28",
        },
        banner_freemium_trial: {
            cta: "Activate Waalaxy Premium",
            description: "Waalaxy is free until November 28, 2025.",
            title: "Pre save your -50% BLACK FRIDAY OFFER",
        },
        modal: {
            first_step: {
                cta: "Try for free",
                cta_cancel: "No, thank you",
                subtitle_1: "Unlock the {{plan}} plan and its features for {{price}} until 11/28.",
                subtitle_2: "No additional charge after this date. You will automatically revert to your current subscription.",
                title: "We’re giving you the higher plan until Black Friday!",
            },
            no_access: {
                cta: "Back to the app",
                subtitle_1: "You’re not eligible for this offer...",
                subtitle_2: "You already have a trial in progress, and it’s not possible to have multiple trials at the same time.",
                subtitle_3: "But we’ve got good news: on November 28 only, our annual plans are 50% off 🔥",
                title: "See you on Black Friday 🎉",
            },
            validated_step: {
                cta: "Back to the app",
                subtitle: "You now have access to all advanced features, with no commitment until Black Friday.",
                title: "{{plan}} plan activated",
            },
        },
    },
    trigger: "Auto-import",
    trigger_description: {
        comment_on_post_description: "Prospects who comment on a post",
        connect_invite_description: "Prospects who sent me an invitation",
        sales_lead_list_description: "Prospects from a saved list",
        sales_navigator_description: "Prospects from a saved search",
        visit_on_profile_description: "Prospects who visit my profile",
    },
    trigger_type: {
        auto_accept_invitation: {
            description: "Auto-accept the invitation",
            tooltip: "Invitations received will be automatically accepted when the prospect is imported in Waalaxy",
        },
        comment_on_post: "Comment on post",
        connect_invite: "Sent me an invitation",
        connect_invite_received: "Sent me an invitation",
        sales_lead_list: "Sales Navigator - Leads list",
        sales_navigator: "Sales Navigator - Saved search",
        sales_saved_search_new_result: "Sales Navigator - Saved search",
        visit_on_profile: "Visit on profile",
    },
    tuto: {
        campaign: {
            first_page_content:
                "Click on each step of your campaign to display only the relevant prospects and see how many prospects are at each step.",
            first_page_media: "https://i.postimg.cc/0QcgKr69/Campaign-Dashboard-2-5-Demo.gif",
            first_page_title: "Display your prospects at every step",
            second_page_content: "Click on the “i” icon to understand the path a prospect takes through your campaign",
            second_page_media: "https://i.postimg.cc/bJzcv1w6/Campaign-Dashboard-Demo.gif",
            second_page_title: "Learn more about the campaign conditions and prospects’ movement",
        },
    },
    type: "Type",
    uninstall: {
        changeTool: "I'm switching to another solution",
        dontKnowApp: "I don't know what Waalaxy is for",
        dontNeedAnymore: "I no longer need Waalaxy",
        dontUseMuch: "I don't use Waalaxy enough",
        form: {
            error: {
                enterReason: "You must enter a reason",
                selectReason: "You must select a reason",
            },
            reinstall: "Reinstall the extension",
            send: "Send",
            subtitle: "Can you tell us why you left?",
            title: "The Waalaxy extension has been successfully uninstalled",
            which: "Which ones?",
        },
        hardToUse: "Waalaxy is too complicated to use",
        lackFeatures: "I'm lacking key features",
        notExpectedResults: "I didn't get the results I was hoping for",
        other: "Other",
        review: {
            chromeStore: "4,8 on Chrome Store",
            subtitle: "were able to double their prospect pipeline with Waalaxy",
            title: "+100k users ",
            trustpilot: "4,4 on Trustpilot",
        },
        technicalIssues: "I encountered technical issues",
        thanks: {
            cta: "Chat with us",
            reinstall: "Reinstall Waalaxy",
            subtitle: "Your feedback is very important to us",
            text: "If there's anything we can do to help, answer your questions, or discuss things in more detail, our support heroes are available in the chat 👇",
            title: "Thanks for your feedback",
        },
        tooExpensive: "Waalaxy is too expensive",
    },
    unknwown_prospect_list: "Unknown prospect list",
    unsubscribe_inbox_modal: {
        body: {
            accomplished_stats: {
                created_answers: "Saved replies created",
                generated_conversations: "Managed conversations",
                scheduled_messages: "Scheduled messages",
                title: "What you have accomplished with Inbox",
            },
            tips: {
                link1: "https://blog.waalaxy.com/en/why-did-we-create-piwaa/",
                subtitle: "It will have no more secrets for you 😎",
                title: "👉 Discover all the tips of Inbox",
                title_link1: "Why did we create Inbox Waalaxy?",
            },
        },
        footer: {
            cta: {
                go_back: "I changed my mind, go back to the app",
                unsubscribe: "Unsubscribe Inbox",
            },
            lose_your_priviledges: "By clicking on 'Unsubscribe Inbox', you will lose all the Inbox features.",
        },
    },
    unsubscribe_modal: {
        article: {
            article_link: {
                null: {
                    contact_prospects: "https://blog.waalaxy.com/en/how-to-contact-prospects-with-waalaxy/",
                    expand_network: "https://blog.waalaxy.com/en/expand-your-linkedin-network-with-waalaxy/",
                    find_emails: "https://blog.waalaxy.com/en/find-professional-email-addresses-with-waalaxy/",
                    generic: "https://blog.waalaxy.com/en/linkedin-networking/",
                },
                ok: {
                    contact_prospects: "https://blog.waalaxy.com/en/linkedin-prospecting/",
                    expand_network: "https://blog.waalaxy.com/en/10-reasons-to-develop-your-linkedin-network/",
                    find_emails: "https://blog.waalaxy.com/en/sales-email/",
                    generic: "https://blog.waalaxy.com/en/linkedin-networking/",
                },
            },
            card_subtitle: {
                null: {
                    contact_prospects: "How to contact prospects with Waalaxy?",
                    expand_network: "Expand your LinkedIn network with Waalaxy!",
                    find_emails: "Find professional email addresses with Waalaxy",
                    generic: "How to expand my network to get leads",
                },
                ok: {
                    contact_prospects: "How to contact prospects with Waalaxy?",
                    expand_network: "Expand your LinkedIn network with Waalaxy!",
                    find_emails: "Find professional email addresses with Waalaxy",
                    generic: "How to expand my network to get leads",
                },
            },
            card_title: {
                null: {
                    contact_prospects: "Lead generation",
                    expand_network: "Networking",
                    find_emails: "Emailing",
                    generic: "Prospecting",
                },
                ok: {
                    contact_prospects: "Lead generation",
                    expand_network: "Networking",
                    find_emails: "Emailing",
                    generic: "Prospecting",
                },
            },
            title: {
                null: {
                    subtitle: "No more excuses for not closing 😎",
                    title: "👉 Here is an article for you to improve",
                },
                ok: {
                    subtitle: "No more excuses for not going the extra mile 🚴‍♀️",
                    title: "👉 Want to do more? We've written an article that fits perfectly your use case",
                },
            },
        },
        error: {
            fetching_goal: "A problem occurred while fetching goal",
            fetching_prospect: "A problem occurred while fetching prospects",
            fetching_replies: "A problem occurred while fetching replies",
            get_inbox_stats: "A problem occurred while fetching Inbox stats",
            unsubscribe: "A problem occurred on unsubscribe",
        },
        footer: {
            cta: {
                go_back: "I changed my mind, go back to the app",
                unsubscribe: "Unsubscribe Waalaxy",
            },
            lose_your_priviledges: 'By clicking on "Unsubscribe Waalaxy" you will lose all your premium priviledges after {{dateNextInvoice}}.',
        },
        heading: {
            subtitle: "It happens to the best of us.",
            title: "Need to take a step back?",
        },
        performance: {
            find_emails: {
                text: "Professional email found",
            },
            mainGoal: {
                other: "👉 Other",
            },
            null: {
                title: "Not satisfied of your performances?",
            },
            ok: {
                contact_prospects: "Need to contact prospects? That's what you've done!",
                expand: "Want to expand your network? That's what you've done!",
                expand_network: "Want to expand your network? That's what you've done!",
                find: "Wanted to find more clients? That's what you did",
                find_emails: "Need to get professional email adresses? That's what you've done!",
                generic: "Wanted to automate your prospection? That's what you did",
                hire: "Wanted to contact people to recruit? That's what you did",
                other: "Wanted to automate your prospection? That's what you did",
            },
            prospects: {
                text: "New connections",
            },
            replies: {
                text: "Answers",
            },
            your_goal: {
                title: "Your goal",
            },
        },
        plan: {
            cta: {
                change_plan: "Change my plan",
            },
            subtitle: {
                downgrade: "Change for our {{plan}} plan 🎉",
                upgrade: "Upgrade for our {{plan}} plan 🎉",
            },
            title: "Not satisfied of your plan?",
        },
        success: {
            unsubscribe: "Hope we’ll meet again ❤️",
        },
    },
    update: "Update",
    upgrade: "Choose this plan",
    upsell_in_app: {
        check_out_card: {
            terms_acceptance: "I accept this payment will be processed with billing information I provided",
            terms_of_services: "By going further you accept our <customLink>terms of services</customLink>",
        },
    },
    url: "URL",
    use_template: "Use a template",
    validate: "Validate",
    variables: {
        company: {
            placeholder: "eg: your company",
            text: "Company",
            title: "This text will be displayed if we can't find the company",
        },
        custom_variable: {
            placeholder: "Replacement text",
            title: "This text will be displayed if the variable is empty",
        },
        fallback_text: "Fallback",
        first_name: "First Name",
        job_title: "Job title",
        last_name: "Last Name",
        linkedin_conversation_link: "LinkedIn conversation link",
        linkedin_url: "LinkedIn profile URL",
        email: {
            title: "Email",
            placeholder: "john.doe@example.com",
        },
        firstName: {
            title: "First name",
            placeholder: "John",
        },
        lastName: {
            title: "Last name",
            placeholder: "Doe",
        },
        linkedinUrl: {
            title: "LinkedIn profile URL",
            placeholder: "https://www.linkedin.com/in/john-doe-1234567890/",
        },
        linkedInConversationLink: {
            title: "LinkedIn conversation link",
            placeholder: "https://www.linkedin.com/in/john-doe-1234567890/conversation/1234567890/",
        },
        location: {
            title: "Location",
            placeholder: "Paris, France",
        },
        phone: {
            title: "Phone number",
            placeholder: "+33 6 12 34 56 78",
        },
        jobTitle: {
            title: "Job title",
            placeholder: "Software Engineer",
        },
    },
    visit: "Visit",
    voice_note: {
        record: "Record a voice note",
    },
    waalaxy_features: {
        inbox_monthly: "Inbox monthly",
        inbox_quarterly: "Inbox quarterly",
        inbox_yearly: "Inbox yearly",
    },
    waalaxy_plan: {
        advanced: "Advanced",
        advanced_plan: "Advanced plan",
        business: "Business",
        business_plan: "Business plan",
        custom_price: "Custom",
        enterprise: "Enterprise",
        enterprise_add_seats_intercom_message: "I want to add seats to my Enterprise plan",
        enterprise_intercom_message: "I'm interested in the Enterprise plan",
        enterprise_minimum_seats: "Starts at <strong>5 seats</strong>",
        feature: {
            account_switching: "Seamless account switching",
            api_keys: "API Keys Management",
            automated_follow_up: "Automated follow-up messages",
            cold_email: "Cold Email Campaigns",
            crm_sync: "CRM Sync (to 2000+ tool)",
            csv: "CSV Imports & Exports",
            dedicated_onboarding: "Dedicated onboarding session",
            duplicate: "Duplicates prevention",
            email_finder: "{{freeCredits}} Email Finder Credits",
            email_follow_up: "Automated email follow-up",
            import: "Imports from LinkedIn, Sales Nav & Recruiter Lite",
            inbox: "Inbox",
            live_support: "Live Chat support",
            mcp: "IA Connector (MCP)",
            more_invites: "+500 Invitations",
            multi_account: "Multiple email senders account",
            multi_account_import: "Multi-account import",
            priority_support: "Priority support",
            smart_reply_detection: "Smart reply detection",
            support_reply: "Support reply within 48h",
            team_analytics: "Team analytics dashboard",
            team_workspace: "Team workspace",
            unified_billing: "Unified billing",
            unlimited_campaigns: "LinkedIn Campaigns",
            volume_discounts: "Volume discounts",
        },
        free_trial_advanced: "Trial Advanced plan",
        free_trial_business: "Trial Business plan",
        free_trial_elite: "Trial Elite plan",
        free_trial_freemium: "Trial Free plan",
        free_trial_networking_advanced: "Trial Networking Advanced plan",
        free_trial_networking_business: "Trial Networking Business plan",
        free_trial_networking_pro: "Trial Networking Pro plan",
        free_trial_pro: "Trial Pro plan",
        freemium: "Freemium",
        freemium_description: "80 invitations per month. That’s it.",
        freemium_plan: "Freemium plan",
        networking_advanced: "Networking Advanced",
        networking_advanced_plan: "Networking Advanced Plan",
        networking_business: "Networking Business",
        networking_business_plan: "Networking Business Plan",
        networking_pro: "Networking Pro",
        networking_pro_plan: "Networking Pro Plan",
        perks_header: {
            advanced: "Everything in PRO plus :",
            business: "Everything in ADVANCED plus :",
            enterprise: "The plan you choose, plus :",
            networking_advanced: "Key Features :",
            networking_business: "Key Features :",
            networking_pro: "Key Features :",
            pro: "Key Features :",
        },
        pro: "Pro",
        pro_plan: "Pro plan",
        unlock_feature: "Unlock this feature",
        upgrade_to: "Upgrade to {{plan}}",
        usecase: {
            advanced: "Perfect for scaling outreach and growing your network fast - at the best price.",
            business: "Maximize replies by combining LinkedIn and Emails. No leads left behind.",
            enterprise: "Designed for collaboration, for sales teams and agencies.",
            networking_advanced: "Keep growing your network at the cheapest price.",
            networking_business: "Keep growing your network at the cheapest price.",
            networking_pro: "Keep growing your network at the cheapest price.",
            pro: "Ideal if you have a strong LinkedIn network and want to turn connections into conversations.",
        },
    },
    waalaxy_plan_periodicity: {
        advanced_lifetime: "Advanced Lifetime Plan",
        advanced_monthly: "Advanced Monthly Plan",
        advanced_quarterly: "Advanced Quarterly Plan",
        advanced_yearly: "Advanced Yearly Plan",
        business_lifetime: "Business Lifetime Plan",
        business_monthly: "Business Monthly Plan",
        business_quarterly: "Business Quarterly Plan",
        business_yearly: "Business Yearly Plan",
        freemium_lifetime: "Freemium Lifetime Plan",
        freemium_monthly: "Freemium Monthly Plan",
        freemium_quarterly: "Freemium Quarterly Plan",
        freemium_yearly: "Freemium Yearly Plan",
        pro_lifetime: "Pro Lifetime Plan",
        pro_monthly: "Pro Monthly Plan",
        pro_quarterly: "Pro Quarterly Plan",
        pro_yearly: "Pro Yearly Plan",
    },
    waami_activation_modal: {
        create_effective_message: "Create effective messages in just a few clicks to boost your prospecting campaigns.",
        no_thanks_button: "No thanks, I'd rather wait.",
        title: "You have access to the message generator via AI",
        try_button: "I want to try it now!",
        try_generator: "Try a preview of our new message generator!",
    },
    waami_feedback: {
        how_improve: "How can we improve this message?",
        placeholder: "Describe what needs to be adjusted (e.g. tone, vocabulary, length of message, missing information, etc.).",
        thanks: "Thank you, your opinion helps us to move forward!",
    },
    waypoint_type: {
        connect_linkedin: "Invitation",
        connect_linkedin_not_sent: "Invitation",
        connect_linkedin_sent: "Invitation sent",
        email: "Email",
        email_not_sent: "Email",
        email_sent: "Email sent",
        end: "End",
        enrichment: "Email finder\n",
        entry: "Entry",
        failed: "Failed",
        follow_linkedin: "Follow",
        goal: "Reached",
        message_linkedin: "Message",
        message_linkedin_not_sent: "Message",
        message_linkedin_sent: "Message sent",
        message_request_linkedin: "Message request",
        message_sent: "Message sent",
        none: {
            text: "Initialisation...",
            tooltip: "This prospect is entering the campaign. The action will soon be added to the queue",
        },
        sleep: "Delay",
        visit_linkedin: "Visit",
        waiting_acceptation: "Invitation sent",
        webhook: "CRM Sync",
    },
    webhook: "CRM Sync",
    welcome: {
        form: {
            options: {
                mainGoal: {
                    contact_prospects: "Contact prospects 🎯",
                    expand_network: "Grow my network 👥",
                    find_emails: "Find pro emails ✉️",
                    generic: "Automate my prospection",
                },
            },
        },
    },
    worldTemplates: {
        questionnaire: {
            content: "Answer a few questions, and we'll suggest campaign templates tailored to your needs!",
            cta: "Get started!",
            redo: "Redo the questionnaire to find my ideal campaign model!",
            title: "Find your ideal campaign template ✨",
        },
    },
    wrong_extension: {
        modal: {
            text: "By Clicking on “<strong>Update my extension</strong>”, you’ll be redirected to the Chrome Store to update it.",
            title: "How do I update the Waalaxy extension?",
        },
        update: "Update my extension",
        update_version:
            "We look forward to seeing you on the new, more <strong>stable</strong> version of Waalaxy! \n👉 To access it, go on the Chrome Store by clicking on the button below, then “Update extension”.",
    },
    yes: "yes",
    yesterday: "Yesterday",
    you: "you",
    cross_sell: {
        discover: "Discover",
        cta_discover_partner: "Discover our partner",
        mirror: {
            title: "No colleague to invite? Rent a LinkedIn account",
            body: "MirrorProfiles rents premium LinkedIn accounts, natively compatible with Waalaxy and optimized for Day 1 automation. Scale your prospecting without hiring.",
            promo_label: "-10% with the code",
            promo_copy_aria: "Copy the promo code",
            promo_copied: "Promo code copied!",
            benefit_warmup: "4 months of warm-up",
            benefit_connections: "+500 real connections",
            benefit_no_commitment: "No commitment",
            benefit_customizable: "Customizable",
            banner_text: "<strong>No colleague?</strong> Rent a certified LinkedIn account to grow your team!",
            no_team_cta: "No colleague? Rent a LinkedIn account",
            card_title: "No colleague?",
            card_body: "Rent one or more certified LinkedIn accounts with our partner MirrorProfiles to grow your team!",
        },
        kawaak: {
            description: "Turn your expertise into LinkedIn content that (really) gets views",
            link: "https://kawaak.com/?o=injmay&from=waal ",
            title: "Kawaak",
        },
        podawaa: {
            description: "Skyrocket your brand image on LinkedIn",
            link: "https://www.podawaa.com/",
            title: "Podawaa",
        },
        skipcall: {
            description: "Make 4 calls in 1, only speak to those who answer",
            link: "https://skipcall.io/",
            title: "Skipcall",
        },
        kawaak_influence: {
            description: "Launch your first B2B influencer campaign on LinkedIn",
            link: "https://kawaak.com/influence?o=product&from=waal",
            title: "Kawaak Influence",
        },
    },
    restore_prospects: "Restore",
    payment_overdue_modal: {
        title: "Payment overdue",
        subtitle: "You have an open invoice of {{amount}} that you must regulate before continuing.",
        pay_the_invoice: "Pay the invoice",
    },
};
